(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[507],{

/***/ 5679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = self.fetch || (self.fetch = (__webpack_require__(3144)["default"]) || __webpack_require__(3144));


/***/ }),

/***/ 8296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bz": function() { return /* binding */ Registry; },
/* harmony export */   "Gv": function() { return /* reexport safe */ _plasmicapp_loader_fetcher__WEBPACK_IMPORTED_MODULE_0__.Gv; },
/* harmony export */   "fl": function() { return /* binding */ PlasmicTracker; },
/* harmony export */   "yA": function() { return /* binding */ getBundleSubset; }
/* harmony export */ });
/* harmony import */ var _plasmicapp_loader_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7915);
/* harmony import */ var _plasmicapp_isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5679);
/* harmony import */ var _plasmicapp_isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_plasmicapp_isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__);
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts


// src/deps-graph.ts
var DepsGraph = class {
  constructor(bundle, browserBuild) {
    this.bundle = bundle;
    this.browserBuild = browserBuild;
    this.dependsOn = {};
    this.dependedBy = {};
    this.rebuildGraph();
  }
  getTransitiveDependers(name2) {
    return this.transitiveCrawl(name2, this.dependedBy);
  }
  getTransitiveDeps(name2) {
    if (!(name2 in this.dependsOn)) {
      return [];
    }
    return this.transitiveCrawl(name2, this.dependsOn);
  }
  transitiveCrawl(name2, edges) {
    const deps = /* @__PURE__ */ new Set();
    const crawl = (dep2) => {
      var _a;
      if (deps.has(dep2)) {
        return;
      }
      deps.add(dep2);
      for (const subdep of (_a = edges[dep2]) != null ? _a : []) {
        crawl(subdep);
      }
    };
    for (const dep2 of edges[name2]) {
      crawl(dep2);
    }
    return Array.from(deps);
  }
  rebuildGraph() {
    this.dependedBy = {};
    this.dependsOn = {};
    for (const mod of this.browserBuild ? this.bundle.modules.browser : this.bundle.modules.server) {
      if (mod.type === "code") {
        for (const imported of mod.imports) {
          if (!(mod.fileName in this.dependsOn)) {
            this.dependsOn[mod.fileName] = [imported];
          } else {
            this.dependsOn[mod.fileName].push(imported);
          }
          if (!(imported in this.dependedBy)) {
            this.dependedBy[imported] = [mod.fileName];
          } else {
            this.dependedBy[imported].push(mod.fileName);
          }
        }
      }
    }
  }
};

// src/bundles.ts
function getBundleSubset(bundle, names, opts2) {
  var _a, _b;
  const namesSet = new Set(names);
  const target = (_a = opts2 == null ? void 0 : opts2.target) != null ? _a : "browser";
  const forBrowser = target === "browser";
  const graph = new DepsGraph(bundle, forBrowser);
  const deps = new Set(names.flatMap((name2) => graph.getTransitiveDeps(name2)));
  const isSubModule = (fileName) => deps.has(fileName) || namesSet.has(fileName);
  const modules = bundle.modules[target];
  const filteredModules = modules.filter((mod) => isSubModule(mod.fileName));
  const filteredComponents = bundle.components.filter(
    (c) => isSubModule(c.entry)
  );
  const filteredComponentsIds = new Set(filteredComponents.map((c) => c.id));
  const filteredIds = Object.fromEntries(
    Object.entries(bundle.filteredIds).map(([k, v]) => [k, [...v]])
  );
  bundle.components.filter((c) => !filteredComponentsIds.has(c.id)).forEach((component) => {
    var _a2;
    filteredIds[component.projectId] = (_a2 = filteredIds[component.projectId]) != null ? _a2 : [];
    if (!filteredIds[component.projectId].includes(component.id)) {
      filteredIds[component.projectId].push(component.id);
    }
  });
  return {
    modules: {
      browser: forBrowser ? filteredModules : [],
      server: forBrowser ? [] : filteredModules
    },
    components: filteredComponents,
    globalGroups: bundle.globalGroups,
    projects: bundle.projects,
    activeSplits: bundle.activeSplits,
    bundleKey: (_b = bundle.bundleKey) != null ? _b : null,
    deferChunksByDefault: bundle.deferChunksByDefault,
    disableRootLoadingBoundaryByDefault: bundle.disableRootLoadingBoundaryByDefault,
    filteredIds
  };
}

// src/registry.ts
var isBrowser = typeof window !== "undefined" && window != null && typeof window.document !== "undefined";
function isModuleBundlePromiseSet(name2) {
  return globalThis.__PlasmicBundlePromises && !!globalThis.__PlasmicBundlePromises[name2] && !!globalThis.__PlasmicBundlePromises[name2].then;
}
var Registry = class {
  constructor() {
    this.loadedModules = {};
    this.registeredModules = {};
    this.modules = {};
  }
  register(name2, module) {
    this.registeredModules[name2] = module;
  }
  isEmpty() {
    return Object.keys(this.loadedModules).length === 0;
  }
  clear() {
    this.loadedModules = {};
  }
  getRegisteredModule(name2) {
    return this.registeredModules[name2];
  }
  hasModule(name2, opts2 = {}) {
    if (name2 in this.registeredModules && !opts2.forceOriginal) {
      return true;
    }
    if (name2 in this.modules) {
      return true;
    }
    if (globalThis.__PLASMIC_CHUNKS && !!globalThis.__PLASMIC_CHUNKS[name2]) {
      return true;
    }
    if (isModuleBundlePromiseSet(name2)) {
      return true;
    }
    return false;
  }
  load(name, opts = {}) {
    if (name in this.registeredModules && !opts.forceOriginal) {
      return this.registeredModules[name];
    }
    if (name in this.loadedModules) {
      return this.loadedModules[name];
    }
    if (!this.modules[name] && globalThis.__PLASMIC_CHUNKS && !!globalThis.__PLASMIC_CHUNKS[name]) {
      this.modules[name] = globalThis.__PLASMIC_CHUNKS[name];
    }
    if (!this.modules[name] && isModuleBundlePromiseSet(name)) {
      throw globalThis.__PlasmicBundlePromises[name];
    }
    if (!(name in this.modules)) {
      throw new Error(`Unknown module ${name}`);
    }
    const code = this.modules[name];
    const requireFn = isBrowser ? (dep2) => {
      const normalizedDep = resolvePath(dep2, name);
      return this.load(normalizedDep);
    } : (dep) => {
      try {
        const normalizedDep = resolvePath(dep, name);
        return this.load(normalizedDep);
      } catch (err) {
        try {
          return eval("require")(dep);
        } catch (e) {
          throw err;
        }
      }
    };
    let func;
    try {
      func = new Function("require", "exports", code);
    } catch (err2) {
      throw new Error(`PLASMIC: Failed to create function for ${name}: ${err2}`);
    }
    const exports = {};
    this.loadedModules[name] = exports;
    try {
      func(requireFn, exports);
    } catch (err2) {
      delete this.loadedModules[name];
      if (!(err2 instanceof Error) && !!err2 && !!err2.then) {
        throw err2;
      }
      throw new Error(`PLASMIC: Failed to load ${name}: ${err2}`);
    }
    return exports;
  }
  updateModules(bundle) {
    let updated = false;
    for (const mod of isBrowser ? bundle.modules.browser : bundle.modules.server) {
      if (mod.type === "code" && !!mod.code && mod.code !== this.modules[mod.fileName]) {
        this.modules[mod.fileName] = mod.code;
        if (!globalThis.__PLASMIC_CHUNKS) {
          globalThis.__PLASMIC_CHUNKS = {};
        }
        globalThis.__PLASMIC_CHUNKS[mod.fileName] = mod.code;
        updated = true;
      }
    }
    if (updated) {
      this.clear();
    }
  }
};
function resolvePath(path, from) {
  const fromParts = from.split("/");
  const pathParts = path.split("/");
  if (pathParts.length === 0) {
    return path;
  }
  if (pathParts[0] === ".") {
    return [
      ...fromParts.slice(0, fromParts.length - 1),
      ...pathParts.slice(1)
    ].join("/");
  } else if (pathParts[0] === "..") {
    let count = 0;
    for (const part of pathParts) {
      if (part === "..") {
        count += 1;
      } else {
        break;
      }
    }
    return [
      ...fromParts.slice(0, fromParts.length - count - 1),
      ...pathParts.slice(count)
    ].join("/");
  } else {
    return path;
  }
}

// src/tracker/index.ts


// src/tracker/utils.ts
var isBrowser2 = typeof window !== "undefined" && window != null && typeof window.document !== "undefined";
function getPlasmicCookieValues() {
  if (!isBrowser2) {
    return {};
  }
  return Object.fromEntries(
    document.cookie.split("; ").filter((cookie) => cookie.includes("plasmic:")).map((cookie) => cookie.split("=")).map(([key, value]) => [key.split(":")[1], value])
  );
}
function getVariationCookieValues() {
  const cookies = getPlasmicCookieValues();
  return Object.fromEntries(
    Object.keys(cookies).map((key) => [key.split(".")[1], cookies[key]]).filter((val) => !!val[0])
  );
}
function getDistinctId() {
  if (!isBrowser2) {
    return "LOADER-SERVER";
  }
  return "LOADER-CLIENT";
}
function getCampaignParams() {
  const { location } = window;
  const params = {};
  try {
    const url = new URL(location.href);
    const CAMPAIGN_KEYWORDS = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "gclid"
    ];
    CAMPAIGN_KEYWORDS.forEach((keyword) => {
      const value = url.searchParams.get(keyword);
      if (value) {
        params[keyword] = value;
      }
    });
  } catch (err2) {
  }
  return params;
}
function getLocationMeta() {
  const { location } = window;
  const { referrer } = document;
  return __spreadValues({
    url: location.href,
    host: location.host,
    pathname: location.pathname,
    referrer
  }, getCampaignParams());
}
function getScreenMeta() {
  const { screen } = window;
  return {
    screen_height: screen.height,
    screen_width: screen.width,
    viewport_height: window.innerHeight,
    viewport_width: window.innerWidth
  };
}
function getOS(userAgent) {
  if (/Windows/i.test(userAgent)) {
    if (/Phone/.test(userAgent) || /WPDesktop/.test(userAgent)) {
      return "Windows Phone";
    }
    return "Windows";
  } else if (/(iPhone|iPad|iPod)/.test(userAgent)) {
    return "iOS";
  } else if (/Android/.test(userAgent)) {
    return "Android";
  } else if (/(BlackBerry|PlayBook|BB10)/i.test(userAgent)) {
    return "BlackBerry";
  } else if (/Mac/i.test(userAgent)) {
    return "Mac OS X";
  } else if (/Linux/.test(userAgent)) {
    return "Linux";
  } else if (/CrOS/.test(userAgent)) {
    return "Chrome OS";
  } else {
    return "";
  }
}
function getDeviceInfo(userAgent) {
  const PATTERNS = [
    {
      device: "iPhone",
      patterns: [/iPhone/]
    },
    {
      device: "iPad",
      patterns: [/iPad/]
    },
    {
      device: "iPod Touch",
      patterns: [/iPod/]
    },
    {
      device: "Windows Phone",
      patterns: [/Windows Phone/i, /WPDesktop/]
    },
    {
      device: "Android",
      patterns: [/Android/]
    }
  ];
  const match = PATTERNS.find(
    (pattern) => pattern.patterns.some((expr) => expr.test(userAgent))
  );
  const device = match == null ? void 0 : match.device;
  return {
    device: device != null ? device : "",
    deviceType: device ? "Mobile" : "Desktop",
    os: getOS(userAgent)
  };
}
function getUserAgentMeta() {
  const { navigator } = window;
  const { userAgent } = navigator;
  return __spreadValues({}, getDeviceInfo(userAgent));
}
function getWindowMeta() {
  if (!isBrowser2) {
    return {};
  }
  return __spreadValues(__spreadValues(__spreadValues({}, getLocationMeta()), getScreenMeta()), getUserAgentMeta());
}
var isProduction = "production" === "production";
function getEnvMeta() {
  return {
    isBrowser: isBrowser2,
    isProduction
  };
}
function rawSplitVariation(variation) {
  const rawVariations = {};
  Object.keys(variation).forEach((variationKey) => {
    const [, splitId] = variationKey.split(".");
    if (splitId) {
      rawVariations[splitId] = variation[variationKey];
    }
  });
  return rawVariations;
}
var POLL_TIME = 5e3;
function throttled(func2) {
  let timerId = void 0;
  return (param) => {
    if (timerId) {
      return;
    }
    if (isBrowser2) {
      timerId = window.requestAnimationFrame(() => {
        timerId = void 0;
        func2(param);
      });
    } else {
      timerId = setTimeout(() => {
        timerId = void 0;
        func2(param);
      }, POLL_TIME);
    }
  };
}

// src/tracker/index.ts
var API_ENDPOINT = "https://analytics.plasmic.app/capture";
var API_PUBLIC_KEY = "phc_BRvYTAoMoam9fDHfrIneF67KdtMJagLVVCM6ELNYd4n";
var TRACKER_VERSION = 4;
var PlasmicTracker = class {
  constructor(opts2) {
    this.opts = opts2;
    this.eventQueue = [];
    this.sendEvents = throttled((transport) => __async(this, null, function* () {
      if (this.eventQueue.length === 0) {
        return;
      }
      const events = [...this.eventQueue];
      this.eventQueue.length = 0;
      const body = {
        api_key: API_PUBLIC_KEY,
        batch: events
      };
      try {
        const stringBody = JSON.stringify(body);
        if (transport === "beacon") {
          window.navigator.sendBeacon(API_ENDPOINT, stringBody);
        } else {
          this.fetch(API_ENDPOINT, {
            method: "POST",
            headers: {
              Accept: "application/json"
            },
            body: stringBody
          }).then(() => {
          }).catch(() => {
          });
        }
      } catch (err2) {
      }
    }));
    this.fetch = (opts2.nativeFetch && globalThis.fetch ? globalThis.fetch : (_plasmicapp_isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default())).bind(globalThis);
  }
  trackRender(opts2) {
    var _a, _b;
    this.enqueue({
      event: "$render",
      properties: __spreadValues(__spreadValues(__spreadValues({}, this.getProperties()), (_a = opts2 == null ? void 0 : opts2.renderCtx) != null ? _a : {}), rawSplitVariation((_b = opts2 == null ? void 0 : opts2.variation) != null ? _b : {}))
    });
  }
  trackFetch() {
    this.enqueue({
      event: "$fetch",
      properties: this.getProperties()
    });
  }
  trackConversion(value = 0) {
    this.enqueue({
      event: "$conversion",
      properties: __spreadProps(__spreadValues({}, this.getProperties()), {
        value
      })
    });
  }
  getProperties() {
    var _a;
    return __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({
      distinct_id: getDistinctId()
    }, getWindowMeta()), getEnvMeta()), this.getContextMeta()), getVariationCookieValues()), {
      timestamp: (_a = Date.now()) != null ? _a : +/* @__PURE__ */ new Date(),
      trackerVersion: TRACKER_VERSION
    });
  }
  enqueue(event) {
    if (this.opts.__plasmicTrackerDisabled) {
      return;
    }
    this.eventQueue.push(event);
    this.sendEvents("fetch");
  }
  getContextMeta() {
    return {
      platform: this.opts.platform,
      preview: this.opts.preview,
      projectIds: this.opts.projectIds
    };
  }
};

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 7915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gv": function() { return /* binding */ PlasmicModulesFetcher; },
/* harmony export */   "Mq": function() { return /* binding */ internal_getCachedBundleInNodeServer; }
/* harmony export */ });
/* unused harmony export Api */
/* harmony import */ var _plasmicapp_isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5679);
/* harmony import */ var _plasmicapp_isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_plasmicapp_isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var process = __webpack_require__(3454);
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/api.ts

var VERSION = "10";
var isBrowser = typeof window !== "undefined" && window != null && typeof window.document !== "undefined";
function transformApiLoaderBundleOutput(bundle) {
  return __spreadProps(__spreadValues({}, bundle), {
    filteredIds: Object.fromEntries(bundle.projects.map((p) => [p.id, []]))
  });
}
var Api = class {
  constructor(opts) {
    this.opts = opts;
    this.lastResponse = void 0;
    var _a;
    this.host = (_a = opts.host) != null ? _a : "https://codegen.plasmic.app";
    this.fetch = (opts.nativeFetch && globalThis.fetch ? globalThis.fetch : (_plasmicapp_isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0___default())).bind(globalThis);
  }
  fetchLoaderData(projectIds, opts) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i;
      const { platform, preview } = opts;
      const query = new URLSearchParams([
        ["platform", platform != null ? platform : "react"],
        ...((_b = (_a = opts.platformOptions) == null ? void 0 : _a.nextjs) == null ? void 0 : _b.appDir) ? [["nextjsAppDir", "true"]] : [],
        ...projectIds.map((projectId) => ["projectId", projectId]),
        ...opts.browserOnly ? [["browserOnly", "true"]] : [],
        ...opts.i18nKeyScheme ? [["i18nKeyScheme", opts.i18nKeyScheme]] : [],
        ...opts.i18nTagPrefix ? [["i18nTagPrefix", opts.i18nTagPrefix]] : [],
        ...opts.skipHead ? [["skipHead", "true"]] : []
      ]).toString();
      const url = `${this.host}/api/v1/loader/code/${preview ? "preview" : "published"}?${query}`;
      const useLastReponse = (
        // We consider that manualRedirect is true by default, only by setting it to false
        // we disable it.
        !(this.opts.manualRedirect === false) && !preview && !isBrowser
      );
      if (useLastReponse) {
        const redirectResp = yield this.fetch(url, {
          method: "GET",
          headers: this.makeGetHeaders(),
          redirect: "manual"
        });
        if (redirectResp.status !== 301 && redirectResp.status !== 302) {
          const error = yield this.parseJsonResponse(redirectResp);
          throw new Error(
            `Error fetching loader data, a redirect was expected: ${(_d = (_c = error == null ? void 0 : error.error) == null ? void 0 : _c.message) != null ? _d : redirectResp.statusText}`
          );
        }
        const nextLocation = redirectResp.headers.get("location");
        if (!nextLocation) {
          throw new Error(
            `Error fetching loader data, a redirect was expected but no location header was found`
          );
        }
        if (((_e = this.lastResponse) == null ? void 0 : _e.key) === nextLocation) {
          return this.lastResponse.bundle;
        }
        const resp2 = yield this.fetch(`${this.host}${nextLocation}`, {
          method: "GET",
          headers: this.makeGetHeaders()
        });
        if (resp2.status >= 400) {
          const error = yield this.parseJsonResponse(resp2);
          throw new Error(
            `Error fetching loader data: ${(_g = (_f = error == null ? void 0 : error.error) == null ? void 0 : _f.message) != null ? _g : resp2.statusText}`
          );
        }
        const json2 = transformApiLoaderBundleOutput(
          yield this.parseJsonResponse(resp2)
        );
        this.lastResponse = {
          bundle: json2,
          key: nextLocation
        };
        return json2;
      }
      const resp = yield this.fetch(url, {
        method: "GET",
        headers: this.makeGetHeaders()
      });
      if (resp.status >= 400) {
        const error = yield this.parseJsonResponse(resp);
        throw new Error(
          `Error fetching loader data: ${(_i = (_h = error == null ? void 0 : error.error) == null ? void 0 : _h.message) != null ? _i : resp.statusText}`
        );
      }
      const json = yield this.parseJsonResponse(resp);
      return transformApiLoaderBundleOutput(json);
    });
  }
  parseJsonResponse(resp) {
    return __async(this, null, function* () {
      const text = yield resp.text();
      try {
        return JSON.parse(text);
      } catch (err) {
        throw new Error(
          `Error parsing JSON response: ${err}; status: ${resp.status}; response: ${text}`
        );
      }
    });
  }
  fetchHtmlData(opts) {
    return __async(this, null, function* () {
      const { projectId, component, embedHydrate, hydrate } = opts;
      const query = new URLSearchParams([
        ["projectId", projectId],
        ["component", component],
        ["embedHydrate", embedHydrate ? "1" : "0"],
        ["hydrate", hydrate ? "1" : "0"]
      ]).toString();
      const resp = yield this.fetch(`${this.host}/api/v1/loader/html?${query}`, {
        method: "GET",
        headers: this.makeGetHeaders()
      });
      const json = yield resp.json();
      return json;
    });
  }
  makeGetHeaders() {
    return __spreadValues({
      "x-plasmic-loader-version": VERSION
    }, this.makeAuthHeaders());
  }
  makeAuthHeaders() {
    const tokens = this.opts.projects.map((p) => `${p.id}:${p.token}`).join(",");
    return {
      "x-plasmic-api-project-tokens": tokens
    };
  }
  getChunksUrl(bundle, modules) {
    var _a;
    return `${this.host}/api/v1/loader/chunks?bundleKey=${encodeURIComponent(
      (_a = bundle.bundleKey) != null ? _a : "null"
    )}&fileName=${encodeURIComponent(
      modules.map((m) => m.fileName).sort().join(",")
    )}`;
  }
};

// src/fetcher.ts
var PlasmicModulesFetcher = class {
  constructor(opts) {
    this.opts = opts;
    this.curFetch = void 0;
    this.api = new Api({
      projects: opts.projects,
      host: opts.host,
      nativeFetch: opts.nativeFetch,
      manualRedirect: opts.manualRedirect
    });
  }
  getChunksUrl(bundle, modules) {
    return this.api.getChunksUrl(bundle, modules);
  }
  fetchAllData() {
    return __async(this, null, function* () {
      const bundle = yield this.getCachedOrFetch();
      this.cacheBundleInNodeServer(bundle);
      return bundle;
    });
  }
  getCachedOrFetch() {
    return __async(this, null, function* () {
      var _a;
      if (this.opts.cache) {
        const cachedData = yield this.opts.cache.get();
        if (cachedData) {
          return cachedData;
        }
      }
      if (this.curFetch) {
        return yield this.curFetch;
      }
      if (typeof process === "undefined" || !((_a = process.env) == null ? void 0 : _a.PLASMIC_QUIET)) {
        console.debug("Plasmic: doing a fresh fetch...");
      }
      const fetchPromise = this.doFetch();
      this.curFetch = fetchPromise;
      try {
        const data = yield fetchPromise;
        return data;
      } finally {
        if (this.curFetch === fetchPromise) {
          this.curFetch = void 0;
        }
      }
    });
  }
  doFetch() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      const data = yield this.api.fetchLoaderData(
        this.opts.projects.map(
          (p) => p.version ? `${p.id}@${p.version}` : p.id
        ),
        {
          platform: this.opts.platform,
          platformOptions: this.opts.platformOptions,
          preview: this.opts.preview,
          i18nKeyScheme: (_b = (_a = this.opts.i18n) == null ? void 0 : _a.keyScheme) != null ? _b : this.opts.i18nKeyScheme,
          i18nTagPrefix: (_c = this.opts.i18n) == null ? void 0 : _c.tagPrefix,
          browserOnly: isBrowser,
          skipHead: this.opts.skipHead
        }
      );
      if (this.opts.cache) {
        yield this.opts.cache.set(data);
      }
      if (typeof process === "undefined" || !((_d = process.env) == null ? void 0 : _d.PLASMIC_QUIET)) {
        console.debug(
          `Plasmic: fetched designs for ${data.projects.map((p) => `"${p.name}" (${p.id}@${p.version})`).join(", ")}`
        );
      }
      return data;
    });
  }
  cacheBundleInNodeServer(bundle) {
    if (isBrowser) {
      return;
    }
    const global = globalThis;
    if (global.__PLASMIC_BUNDLES === void 0) {
      global.__PLASMIC_BUNDLES = {};
    }
    global.__PLASMIC_BUNDLES[getBundleKey(this.opts)] = bundle;
  }
};
function internal_getCachedBundleInNodeServer(opts) {
  var _a;
  if (isBrowser) {
    throw new Error(`Should not be consulting Node server cache in browser`);
  }
  const global = globalThis;
  return (_a = global.__PLASMIC_BUNDLES) == null ? void 0 : _a[getBundleKey(opts)];
}
function getBundleKey({
  host,
  platform,
  i18nKeyScheme,
  preview,
  projects,
  skipHead
}) {
  return JSON.stringify({
    host,
    platform,
    i18nKeyScheme,
    preview,
    projects,
    skipHead
  });
}

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 6507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FW": function() { return /* reexport safe */ _plasmicapp_loader_react__WEBPACK_IMPORTED_MODULE_0__.FW; },
/* harmony export */   "UF": function() { return /* binding */ PlasmicRootProvider; },
/* harmony export */   "UX": function() { return /* reexport safe */ _plasmicapp_loader_react__WEBPACK_IMPORTED_MODULE_0__.UX; },
/* harmony export */   "fZ": function() { return /* binding */ initPlasmicLoader; },
/* harmony export */   "i9": function() { return /* reexport safe */ _plasmicapp_loader_react__WEBPACK_IMPORTED_MODULE_0__.i9; },
/* harmony export */   "nh": function() { return /* reexport safe */ _plasmicapp_loader_react__WEBPACK_IMPORTED_MODULE_0__.nh; },
/* harmony export */   "y1": function() { return /* reexport safe */ _plasmicapp_loader_react__WEBPACK_IMPORTED_MODULE_0__.y1; }
/* harmony export */ });
/* unused harmony exports NextJsPlasmicComponentLoader, extractPlasmicQueryData */
/* harmony import */ var _plasmicapp_loader_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4349);
/* harmony import */ var _plasmicapp_nextjs_app_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4638);
/* harmony import */ var next_head_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var next_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1365);
/* harmony import */ var next_constants__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_constants__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var path__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1864);
/* harmony import */ var path__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(path__WEBPACK_IMPORTED_MODULE_8__);
/* provided dependency */ var process = __webpack_require__(3454);
"use client";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __reflectGet = Reflect.get;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __superGet = (cls, obj, key) => __reflectGet(__getProtoOf(cls), key, obj);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.tsx









// src/cache.ts



// src/server-require.ts
var secretRequire;
try {
  secretRequire = eval("require");
} catch (err) {
  try {
    secretRequire = eval("(module) => import(module)");
  } catch (err2) {
    secretRequire = void 0;
  }
}
function serverRequire(module) {
  return __async(this, null, function* () {
    if (!secretRequire) {
      throw new Error(
        `Unexpected serverRequire() -- can only do this from a Node server!`
      );
    }
    return secretRequire(module);
  });
}
function tryServerRequire(module) {
  return __async(this, null, function* () {
    try {
      const require2 = yield serverRequire(module);
      return require2;
    } catch (e) {
      return void 0;
    }
  });
}
function tryServerRequires(modules) {
  return __async(this, null, function* () {
    for (const module of modules) {
      const require2 = yield tryServerRequire(module);
      if (require2 != null) {
        return require2;
      }
    }
    return void 0;
  });
}
function serverRequireFs() {
  return __async(this, null, function* () {
    return serverRequire("fs");
  });
}

// src/cache.ts
var FileCache = class {
  constructor(filePath) {
    this.filePath = filePath;
  }
  get() {
    return __async(this, null, function* () {
      const fs = yield serverRequireFs();
      try {
        yield fs.promises.mkdir(path__WEBPACK_IMPORTED_MODULE_8___default().dirname(this.filePath), { recursive: true });
        const data = (yield fs.promises.readFile(this.filePath)).toString();
        return JSON.parse(data);
      } catch (e) {
        return void 0;
      }
    });
  }
  set(data) {
    return __async(this, null, function* () {
      const fs = yield serverRequireFs();
      try {
        yield fs.promises.writeFile(this.filePath, JSON.stringify(data));
      } catch (err2) {
        console.warn(`Error writing to Plasmic cache: ${err2}`);
      }
    });
  }
  clear() {
    return __async(this, null, function* () {
      const fs = yield serverRequireFs();
      try {
        yield fs.promises.unlink(this.filePath);
      } catch (err2) {
      }
    });
  }
};
function hashString(str) {
  let h = 0, i = 0;
  for (; i < str.length; h &= h)
    h = 31 * h + str.charCodeAt(i++);
  return Math.abs(h);
}
function makeCache(opts) {
  const cacheDir = path__WEBPACK_IMPORTED_MODULE_8___default().resolve(process.cwd(), ".next", ".plasmic");
  const cachePath = path__WEBPACK_IMPORTED_MODULE_8___default().join(
    cacheDir,
    `plasmic-${hashString(
      [...opts.projects.map((p) => {
        var _a;
        return `${p.id}@${(_a = p.version) != null ? _a : ""}`;
      })].sort().join("-")
    )}${opts.preview ? "-preview" : ""}-cache.json`
  );
  return new FileCache(cachePath);
}
function initPlasmicLoaderWithCache(initFn, _a) {
  var _b = _a, { nextNavigation } = _b, opts = __objRest(_b, ["nextNavigation"]);
  const isBrowser = typeof window !== "undefined";
  const isProd = "production" === "production";
  const isBuildPhase = process.env.NEXT_PHASE === next_constants__WEBPACK_IMPORTED_MODULE_7__.PHASE_PRODUCTION_BUILD;
  const cache = isBrowser || isProd ? void 0 : makeCache(opts);
  const loader = initFn(__spreadProps(__spreadValues({
    onClientSideFetch: "warn"
  }, opts), {
    cache,
    platform: "nextjs",
    platformOptions: {
      nextjs: {
        appDir: !!nextNavigation
      }
    },
    // For Nextjs 12, revalidate may in fact re-use an existing instance
    // of PlasmicComponentLoader that's already in memory, so we need to
    // make sure we don't re-use the data cached in memory.
    // We also enforce this for dev mode, so that we don't have to restart
    // the dev server, in case getStaticProps() re-uses the same PlasmicComponentLoader
    // We also enforce that during build phase, we re-use the data cached in memory
    // to avoid re-fetching the data from Plasmic servers.
    alwaysFresh: !isBuildPhase && !isBrowser
  }));
  if (!isProd) {
    const stringOpts = JSON.stringify(opts);
    if (process.env.PLASMIC_OPTS && process.env.PLASMIC_OPTS !== stringOpts) {
      console.warn(
        `PLASMIC: We detected that you created a new PlasmicLoader with different configurations. You may need to restart your dev server.
`
      );
    }
    process.env.PLASMIC_OPTS = stringOpts;
  }
  if (cache) {
    if (!isProd) {
      if (process.env.PLASMIC_WATCHED !== "true") {
        (() => __async(this, null, function* () {
          process.env.PLASMIC_WATCHED = "true";
          console.log(`Subscribing to Plasmic changes...`);
          try {
            const PlasmicRemoteChangeWatcher = (yield serverRequire("@plasmicapp/watcher")).PlasmicRemoteChangeWatcher;
            const watcher = new PlasmicRemoteChangeWatcher({
              projects: opts.projects,
              host: opts.host
            });
            const clearCache = () => {
              cache.clear();
              loader.clearCache();
            };
            watcher.subscribe({
              onUpdate: () => {
                if (opts.preview) {
                  clearCache();
                }
              },
              onPublish: () => {
                if (!opts.preview) {
                  clearCache();
                }
              }
            });
          } catch (e) {
            console.warn("Couldn't subscribe to Plasmic changes", e);
          }
        }))();
      }
    } else {
      cache.clear();
      loader.clearCache();
    }
  }
  return loader;
}

// src/mocks.tsx

var fakeRouter = {
  push: () => __async(void 0, null, function* () {
    return true;
  }),
  replace: () => __async(void 0, null, function* () {
    return true;
  }),
  reload: () => {
  },
  back: () => {
  },
  forward: () => {
  },
  prefetch: () => __async(void 0, null, function* () {
    return;
  }),
  beforePopState: () => {
  },
  events: {
    on: () => {
    },
    off: () => {
    },
    emit: () => {
    }
  },
  route: "/",
  asPath: "/",
  basePath: "/",
  pathname: "/",
  query: {},
  isFallback: false,
  isLocaleDomain: false,
  isReady: true,
  isPreview: false
};
function wrapRouterContext(element) {
  return __async(this, null, function* () {
    var _a;
    const RouterContext = (_a = yield tryServerRequires([
      "next/dist/shared/lib/router-context.shared-runtime",
      "next/dist/shared/lib/router-context"
    ])) == null ? void 0 : _a.RouterContext;
    return !!(RouterContext == null ? void 0 : RouterContext.Provider) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_6__.createElement(RouterContext.Provider, { value: fakeRouter }, element) : element;
  });
}

// src/index.tsx
var reactMajorVersion = +react__WEBPACK_IMPORTED_MODULE_6__.version.split(".")[0];
function filterCodeFromRenderData(data) {
  if (reactMajorVersion >= 18 && !!data.bundle.bundleKey) {
    const entrypoints = /* @__PURE__ */ new Set([
      ...data.entryCompMetas.map((compMeta) => compMeta.entry),
      "root-provider.js",
      ...data.bundle.projects.map((x) => x.globalContextsProviderFileName).filter((x) => !!x),
      ...data.bundle.components.filter((c) => c.isGlobalContextProvider).map((c) => c.entry),
      ...data.bundle.globalGroups.map((g) => g.contextFile)
    ]);
    data.bundle.modules.browser = data.bundle.modules.browser.map((module) => {
      if (module.type !== "code" || entrypoints.has(module.fileName)) {
        return module;
      }
      return __spreadProps(__spreadValues({}, module), { code: "" });
    });
  }
}
var NextJsPlasmicComponentLoader = class extends _plasmicapp_loader_react__WEBPACK_IMPORTED_MODULE_0__/* .PlasmicComponentLoader */ .lO {
  constructor(internal) {
    super(internal);
  }
  getActiveVariation(opts) {
    return __async(this, null, function* () {
      const extractBuiltinTraits = () => {
        var _a, _b, _c, _d;
        const url = new URL(
          (_b = (_a = opts.req) == null ? void 0 : _a.url) != null ? _b : "/",
          `https://${(_d = (_c = opts.req) == null ? void 0 : _c.headers.host) != null ? _d : "server.side"}`
        );
        return {
          pageUrl: url.href
        };
      };
      return this._getActiveVariation({
        enableUnseededExperiments: true,
        traits: __spreadValues(__spreadValues({}, extractBuiltinTraits()), opts.traits),
        getKnownValue: (key) => {
          var _a, _b;
          if (opts.known) {
            return opts.known[key];
          } else {
            return (_b = (_a = opts.req) == null ? void 0 : _a.cookies[`plasmic:${key}`]) != null ? _b : void 0;
          }
        },
        updateKnownValue: (key, value) => {
          var _a, _b, _c;
          if (opts.res) {
            const cookie = `plasmic:${key}=${value}`;
            const resCookie = (_b = (_a = opts.res) == null ? void 0 : _a.getHeader("Set-Cookie")) != null ? _b : [];
            let newCookies = [];
            if (Array.isArray(resCookie)) {
              newCookies = [...resCookie, `plasmic:${key}=${value}`];
            } else {
              newCookies = [`${resCookie}`, cookie];
            }
            (_c = opts.res) == null ? void 0 : _c.setHeader("Set-Cookie", newCookies);
          }
        }
      });
    });
  }
  maybeFetchComponentData(...args) {
    return __async(this, null, function* () {
      const data = yield __superGet(NextJsPlasmicComponentLoader.prototype, this, "maybeFetchComponentData").call(this, ...args);
      const { opts } = parseFetchComponentDataArgs(...args);
      if (data && ((opts == null ? void 0 : opts.deferChunks) || (opts == null ? void 0 : opts.deferChunks) === void 0 && data.bundle.deferChunksByDefault)) {
        filterCodeFromRenderData(data);
      }
      return data;
    });
  }
  fetchComponentData(...args) {
    return __async(this, null, function* () {
      const data = yield __superGet(NextJsPlasmicComponentLoader.prototype, this, "fetchComponentData").call(this, ...args);
      const { opts } = parseFetchComponentDataArgs(...args);
      if ((opts == null ? void 0 : opts.deferChunks) || (opts == null ? void 0 : opts.deferChunks) === void 0 && data.bundle.deferChunksByDefault) {
        filterCodeFromRenderData(data);
      }
      return data;
    });
  }
};
function parseFetchComponentDataArgs(...args) {
  let specs;
  let opts;
  if (Array.isArray(args[0])) {
    specs = args[0];
    opts = args[1];
  } else {
    specs = args;
    opts = void 0;
  }
  return { specs, opts };
}
function initPlasmicLoader(opts) {
  const loader = initPlasmicLoaderWithCache(
    (opts2) => new NextJsPlasmicComponentLoader(
      new _plasmicapp_loader_react__WEBPACK_IMPORTED_MODULE_0__/* .InternalPlasmicComponentLoader */ .AI(opts2)
    ),
    opts
  );
  loader.registerModules({
    "next/head": (next_head_js__WEBPACK_IMPORTED_MODULE_2___default()),
    "next/link": (next_link_js__WEBPACK_IMPORTED_MODULE_3___default()),
    "next/router": next_router_js__WEBPACK_IMPORTED_MODULE_4__
  });
  if (opts.nextNavigation) {
    loader.registerModules({
      "next/navigation": opts.nextNavigation
    });
  }
  return loader;
}
function extractPlasmicQueryData(element) {
  return __async(this, null, function* () {
    return (0,_plasmicapp_loader_react__WEBPACK_IMPORTED_MODULE_0__/* .extractPlasmicQueryData */ .lL)(yield wrapRouterContext(element));
  });
}
var PlasmicNextLink = react__WEBPACK_IMPORTED_MODULE_6__.forwardRef(function PlasmicNextLink2(props, ref) {
  if (props.href) {
    const _a = props, {
      href,
      replace,
      scroll,
      shallow,
      passHref,
      prefetch,
      locale
    } = _a, rest = __objRest(_a, [
      "href",
      "replace",
      "scroll",
      "shallow",
      "passHref",
      "prefetch",
      "locale"
    ]);
    const isFragment = typeof href === "string" && href.startsWith("#");
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_6__.createElement(
      (next_link_js__WEBPACK_IMPORTED_MODULE_3___default()),
      __spreadValues({
        href,
        replace,
        scroll: scroll != null ? scroll : isFragment ? false : void 0,
        shallow,
        passHref,
        prefetch,
        locale
      }, { legacyBehavior: true }),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_6__.createElement("a", __spreadProps(__spreadValues({}, rest), { ref }))
    );
  } else {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_6__.createElement("a", __spreadProps(__spreadValues({}, props), { href: void 0, ref }));
  }
});
function PlasmicRootProvider(props) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_6__.createElement(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, null, !props.skipChunks && renderDynamicPayloadScripts(props.loader, props.prefetchedData), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_6__.createElement(
    _plasmicapp_loader_react__WEBPACK_IMPORTED_MODULE_0__/* .PlasmicRootProvider */ .UF,
    __spreadValues({
      Head: (next_head_js__WEBPACK_IMPORTED_MODULE_2___default()),
      Link: PlasmicNextLink
    }, props)
  ));
}
function renderDynamicPayloadScripts(loader, prefetchedData) {
  const missingModulesData = prefetchedData && prefetchedData.bundle.modules.browser.filter(
    (module) => module.type === "code" && !module.code
  );
  if (!missingModulesData || missingModulesData.length === 0) {
    return null;
  }
  const isBrowser = typeof window !== "undefined";
  if (isBrowser) {
    if (!globalThis.__PlasmicBundlePromises) {
      globalThis.__PlasmicBundlePromises = {};
    }
    for (const { fileName } of missingModulesData) {
      if (!globalThis.__PlasmicBundlePromises[fileName]) {
        globalThis.__PlasmicBundlePromises[fileName] = new Promise(
          (resolve) => {
            globalThis.__PlasmicBundlePromises["__promise_resolve_" + fileName] = resolve;
          }
        );
      }
    }
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_6__.createElement(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_6__.createElement(
    (next_script__WEBPACK_IMPORTED_MODULE_5___default()),
    {
      strategy: "beforeInteractive",
      key: "init:" + missingModulesData.map((m) => m.fileName).join(";"),
      id: "init:" + missingModulesData.map((m) => m.fileName).join(";"),
      dangerouslySetInnerHTML: {
        __html: `
            if (!globalThis.__PlasmicBundlePromises) {
              globalThis.__PlasmicBundlePromises = {};
            }
            ${missingModulesData.map(
          (module) => `if (!globalThis.__PlasmicBundlePromises[${JSON.stringify(
            module.fileName
          )}]) {
                  globalThis.__PlasmicBundlePromises[${JSON.stringify(
            module.fileName
          )}] = new Promise((resolve) => {
                    globalThis.__PlasmicBundlePromises[${JSON.stringify(
            "__promise_resolve_" + module.fileName
          )}] = resolve;
                  })
                }
              `
        ).join("\n")}`.trim()
      }
    }
  ), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_6__.createElement(
    (next_script__WEBPACK_IMPORTED_MODULE_5___default()),
    {
      strategy: "beforeInteractive",
      key: "load:" + missingModulesData.map((m) => m.fileName).join(";"),
      id: "load:" + missingModulesData.map((m) => m.fileName).join(";"),
      defer: true,
      async: true,
      src: loader.getChunksUrl(prefetchedData.bundle, missingModulesData)
    }
  ));
}

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 4349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FW": function() { return /* reexport */ DataProvider; },
  "AI": function() { return /* binding */ InternalPlasmicComponentLoader; },
  "y1": function() { return /* reexport */ PlasmicCanvasContext; },
  "nh": function() { return /* reexport */ PlasmicCanvasHost; },
  "i9": function() { return /* binding */ PlasmicComponent; },
  "lO": function() { return /* binding */ PlasmicComponentLoader; },
  "UF": function() { return /* binding */ PlasmicRootProvider; },
  "lL": function() { return /* binding */ extractPlasmicQueryData; },
  "UX": function() { return /* reexport */ index_esm.usePlasmicQueryData; }
});

// UNUSED EXPORTS: DataCtxReader, GlobalActionsContext, GlobalActionsProvider, PageParamsProvider, PlasmicTranslatorContext, convertBundlesToComponentRenderData, extractPlasmicQueryDataFromElement, hydrateFromElement, initPlasmicLoader, matchesPagePath, plasmicPrepass, renderToElement, renderToString, repeatedElement, useDataEnv, usePlasmicCanvasComponentInfo, usePlasmicCanvasContext, usePlasmicComponent, useSelector, useSelectors

// NAMESPACE OBJECT: ./node_modules/@plasmicapp/data-sources-context/dist/index.esm.js
var index_esm_namespaceObject = {};
__webpack_require__.r(index_esm_namespaceObject);
__webpack_require__.d(index_esm_namespaceObject, {
  "PlasmicDataSourceContextProvider": function() { return PlasmicDataSourceContextProvider; },
  "useCurrentUser": function() { return useCurrentUser; },
  "usePlasmicDataSourceContext": function() { return usePlasmicDataSourceContext; }
});

// NAMESPACE OBJECT: ./node_modules/@plasmicapp/host/dist/host.esm.js
var host_esm_namespaceObject = {};
__webpack_require__.r(host_esm_namespaceObject);
__webpack_require__.d(host_esm_namespaceObject, {
  "DataContext": function() { return DataContext; },
  "DataCtxReader": function() { return DataCtxReader; },
  "DataProvider": function() { return DataProvider; },
  "GlobalActionsContext": function() { return GlobalActionsContext; },
  "GlobalActionsProvider": function() { return GlobalActionsProvider; },
  "PageParamsProvider": function() { return PageParamsProvider; },
  "PlasmicCanvasContext": function() { return PlasmicCanvasContext; },
  "PlasmicCanvasHost": function() { return PlasmicCanvasHost; },
  "PlasmicLinkProvider": function() { return PlasmicLinkProvider; },
  "PlasmicTranslatorContext": function() { return PlasmicTranslatorContext; },
  "applySelector": function() { return applySelector; },
  "mkMetaName": function() { return mkMetaName; },
  "mkMetaValue": function() { return mkMetaValue; },
  "registerComponent": function() { return registerComponent; },
  "registerFunction": function() { return registerFunction; },
  "registerGlobalContext": function() { return registerGlobalContext; },
  "registerToken": function() { return registerToken; },
  "registerTrait": function() { return registerTrait; },
  "repeatedElement": function() { return repeatedElement; },
  "stateHelpersKeys": function() { return stateHelpersKeys; },
  "unstable_registerFetcher": function() { return registerFetcher; },
  "useDataEnv": function() { return useDataEnv; },
  "useGlobalActions": function() { return useGlobalActions; },
  "usePlasmicCanvasComponentInfo": function() { return usePlasmicCanvasComponentInfo; },
  "usePlasmicCanvasContext": function() { return usePlasmicCanvasContext; },
  "usePlasmicLink": function() { return usePlasmicLink; },
  "usePlasmicLinkMaybe": function() { return usePlasmicLinkMaybe; },
  "usePlasmicTranslator": function() { return usePlasmicTranslator; },
  "useSelector": function() { return useSelector; },
  "useSelectors": function() { return useSelectors; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
;// CONCATENATED MODULE: ./node_modules/@plasmicapp/data-sources-context/dist/index.esm.js
"use client";

// src/index.tsx

var PlasmicDataSourceContext = react.createContext(void 0);
function usePlasmicDataSourceContext() {
  return react.useContext(PlasmicDataSourceContext);
}
function useCurrentUser() {
  var _a;
  const ctx = usePlasmicDataSourceContext();
  return (_a = ctx == null ? void 0 : ctx.user) != null ? _a : {
    isLoggedIn: false
  };
}
var PlasmicDataSourceContextProvider = PlasmicDataSourceContext.Provider;

//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ./node_modules/@plasmicapp/query/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(3273);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
var react_dom_namespaceObject = /*#__PURE__*/__webpack_require__.t(react_dom, 2);
// EXTERNAL MODULE: ./node_modules/react/jsx-dev-runtime.js
var jsx_dev_runtime = __webpack_require__(4862);
var jsx_dev_runtime_namespaceObject = /*#__PURE__*/__webpack_require__.t(jsx_dev_runtime, 2);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
var jsx_runtime_namespaceObject = /*#__PURE__*/__webpack_require__.t(jsx_runtime, 2);
;// CONCATENATED MODULE: ./node_modules/@plasmicapp/host/dist/host.esm.js
'use client';







/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function isString(x) {
    return typeof x === "string";
}
function ensure(x, msg) {
    if (msg === void 0) { msg = ""; }
    if (x === null || x === undefined) {
        debugger;
        msg = (isString(msg) ? msg : msg()) || "";
        throw new Error("Value must not be undefined or null".concat(msg ? "- ".concat(msg) : ""));
    }
    else {
        return x;
    }
}

function useForceUpdate() {
    var _a = (0,react.useState)(0), setTick = _a[1];
    var update = (0,react.useCallback)(function () {
        setTick(function (tick) { return tick + 1; });
    }, []);
    return update;
}

if (globalThis.__PlasmicHostVersion == null) {
    globalThis.__PlasmicHostVersion = "3";
}
var rootChangeListeners = [];
var PlasmicRootNodeWrapper = /** @class */ (function () {
    function PlasmicRootNodeWrapper(value) {
        var _this = this;
        this.value = value;
        this.set = function (val) {
            _this.value = val;
            rootChangeListeners.forEach(function (f) { return f(); });
        };
        this.get = function () { return _this.value; };
    }
    return PlasmicRootNodeWrapper;
}());
var plasmicRootNode = new PlasmicRootNodeWrapper(null);
function getHashParams() {
    return new URLSearchParams(location.hash.replace(/^#/, "?"));
}
function getPlasmicOrigin() {
    var params = getHashParams();
    return ensure(params.get("origin"), "Missing information from Plasmic window.");
}
function getStudioHash() {
    var hashParams = getHashParams();
    if (hashParams.has("studioHash")) {
        return hashParams.get("studioHash");
    }
    var urlParams = new URL(location.href).searchParams;
    return urlParams.get("studio-hash");
}
function renderStudioIntoIframe() {
    var script = document.createElement("script");
    var plasmicOrigin = getPlasmicOrigin();
    var hash = getStudioHash();
    script.src = "".concat(plasmicOrigin, "/static/js/studio").concat(hash ? ".".concat(hash, ".js") : ".js");
    document.body.appendChild(script);
}
var renderCount = 0;
function setPlasmicRootNode(node) {
    // Keep track of renderCount, which we use as key to ErrorBoundary, so
    // we can reset the error on each render
    renderCount++;
    plasmicRootNode.set(node);
}
/**
 * React context to detect whether the component is rendered on Plasmic editor.
 * If not, return false.
 * If so, return an object with more information about the component
 */
var PlasmicCanvasContext = react.createContext(false);
var usePlasmicCanvasContext = function () {
    return react.useContext(PlasmicCanvasContext);
};
function _PlasmicCanvasHost() {
    var _a, _b;
    // If window.parent is null, then this is a window whose containing iframe
    // has been detached from the DOM (for the top window, window.parent === window).
    // In that case, we shouldn't do anything.  If window.parent is null, by the way,
    // location.hash will also be null.
    var isFrameAttached = !!window.parent;
    var isCanvas = !!((_a = location.hash) === null || _a === void 0 ? void 0 : _a.match(/\bcanvas=true\b/));
    var isLive = !!((_b = location.hash) === null || _b === void 0 ? void 0 : _b.match(/\blive=true\b/)) || !isFrameAttached;
    var shouldRenderStudio = isFrameAttached &&
        !document.querySelector("#plasmic-studio-tag") &&
        !isCanvas &&
        !isLive;
    var forceUpdate = useForceUpdate();
    react.useLayoutEffect(function () {
        rootChangeListeners.push(forceUpdate);
        return function () {
            var index = rootChangeListeners.indexOf(forceUpdate);
            if (index >= 0) {
                rootChangeListeners.splice(index, 1);
            }
        };
    }, [forceUpdate]);
    react.useEffect(function () {
        if (shouldRenderStudio && isFrameAttached && window.parent !== window) {
            renderStudioIntoIframe();
        }
    }, [shouldRenderStudio, isFrameAttached]);
    react.useEffect(function () {
        if (!shouldRenderStudio && !document.querySelector("#getlibs") && isLive) {
            var scriptElt = document.createElement("script");
            scriptElt.id = "getlibs";
            scriptElt.src = getPlasmicOrigin() + "/static/js/getlibs.js";
            scriptElt.async = false;
            scriptElt.onload = function () {
                var _a, _b;
                (_b = (_a = window).__GetlibsReadyResolver) === null || _b === void 0 ? void 0 : _b.call(_a);
            };
            document.head.append(scriptElt);
        }
    }, [shouldRenderStudio]);
    var _c = react.useState(function () {
        return deriveCanvasContextValue();
    }), canvasContextValue = _c[0], setCanvasContextValue = _c[1];
    react.useEffect(function () {
        if (isCanvas) {
            var listener_1 = function () {
                setCanvasContextValue(deriveCanvasContextValue());
            };
            window.addEventListener("hashchange", listener_1);
            return function () { return window.removeEventListener("hashchange", listener_1); };
        }
        return undefined;
    }, [isCanvas]);
    if (!isFrameAttached) {
        return null;
    }
    if (isCanvas || isLive) {
        var appDiv = document.querySelector("#plasmic-app.__wab_user-body");
        if (!appDiv) {
            appDiv = document.createElement("div");
            appDiv.id = "plasmic-app";
            appDiv.classList.add("__wab_user-body");
            document.body.prepend(appDiv);
        }
        return react_dom.createPortal(react.createElement(ErrorBoundary, { key: "".concat(renderCount) },
            react.createElement(PlasmicCanvasContext.Provider, { value: canvasContextValue }, plasmicRootNode.get())), appDiv, "plasmic-app");
    }
    if (shouldRenderStudio && window.parent === window) {
        return (react.createElement("iframe", { src: "https://docs.plasmic.app/app-content/app-host-ready#appHostUrl=".concat(encodeURIComponent(location.href)), style: {
                width: "100vw",
                height: "100vh",
                border: "none",
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 99999999,
            } }));
    }
    return null;
}
var PlasmicCanvasHost = function (props) {
    var enableWebpackHmr = props.enableWebpackHmr;
    var _a = react.useState(null), node = _a[0], setNode = _a[1];
    react.useEffect(function () {
        setNode(react.createElement(_PlasmicCanvasHost, null));
    }, []);
    return (react.createElement(react.Fragment, null,
        !enableWebpackHmr && react.createElement(DisableWebpackHmr, null),
        node));
};
var renderErrorListeners = [];
function registerRenderErrorListener(listener) {
    renderErrorListeners.push(listener);
    return function () {
        var index = renderErrorListeners.indexOf(listener);
        if (index >= 0) {
            renderErrorListeners.splice(index, 1);
        }
    };
}
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error) {
        renderErrorListeners.forEach(function (listener) { return listener(error); });
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.error) {
            return react.createElement("div", null,
                "Error: ", "".concat(this.state.error.message));
        }
        else {
            return react.createElement(react.Fragment, null, this.props.children);
        }
    };
    return ErrorBoundary;
}(react.Component));
function DisableWebpackHmr() {
    if (true) {
        return null;
    }
    return (react.createElement("script", { type: "text/javascript", dangerouslySetInnerHTML: {
            __html: "\n      if (typeof window !== \"undefined\") {\n        const RealEventSource = window.EventSource;\n        window.EventSource = function(url, config) {\n          if (/[^a-zA-Z]hmr($|[^a-zA-Z])/.test(url)) {\n            console.warn(\"Plasmic: disabled EventSource request for\", url);\n            return {\n              onerror() {}, onmessage() {}, onopen() {}, close() {}\n            };\n          } else {\n            return new RealEventSource(url, config);\n          }\n        }\n      }\n      ",
        } }));
}
function deriveCanvasContextValue() {
    var _a;
    var hash = window.location.hash;
    if (hash && hash.length > 0) {
        // create URLsearchParams skipping the initial # character
        var params = new URLSearchParams(hash.substring(1));
        if (params.get("canvas") === "true") {
            var globalVariants = params.get("globalVariants");
            return {
                componentName: (_a = params.get("componentName")) !== null && _a !== void 0 ? _a : null,
                globalVariants: globalVariants ? JSON.parse(globalVariants) : {},
                interactive: params.get("interactive") === "true",
            };
        }
    }
    return false;
}
var INTERNAL_CC_CANVAS_SELECTION_PROP = "__plasmic_selection_prop__";
function usePlasmicCanvasComponentInfo(props) {
    return react.useMemo(function () {
        // Inside Plasmic Studio, code components will receive an additional prop
        // that contains selection information for that specific code component.
        // This hook will return that selection information which is useful for
        // changing the behavior of the code component when it is selected, making
        // it easier to interact with code components and slots that aren't always
        // visible in the canvas. (e.g. automatically opening a modal when it's selected)
        var selectionInfo = props === null || props === void 0 ? void 0 : props[INTERNAL_CC_CANVAS_SELECTION_PROP];
        if (selectionInfo) {
            return {
                isSelected: selectionInfo.isSelected,
                selectedSlotName: selectionInfo.selectedSlotName,
            };
        }
        return null;
    }, [props]);
}

var tuple = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args;
};

var DataContext = (0,react.createContext)(undefined);
function mkMetaName(name) {
    return "__plasmic_meta_".concat(name);
}
function mkMetaValue(meta) {
    return meta;
}
function applySelector(rawData, selector) {
    if (!selector) {
        return undefined;
    }
    var curData = rawData;
    for (var _i = 0, _a = selector.split("."); _i < _a.length; _i++) {
        var key = _a[_i];
        curData = curData === null || curData === void 0 ? void 0 : curData[key];
    }
    return curData;
}
function useSelector(selector) {
    var rawData = useDataEnv();
    return applySelector(rawData, selector);
}
function useSelectors(selectors) {
    if (selectors === void 0) { selectors = {}; }
    var rawData = useDataEnv();
    return Object.fromEntries(Object.entries(selectors)
        .filter(function (_a) {
        var key = _a[0], selector = _a[1];
        return !!key && !!selector;
    })
        .map(function (_a) {
        var key = _a[0], selector = _a[1];
        return tuple(key, applySelector(rawData, selector));
    }));
}
function useDataEnv() {
    return (0,react.useContext)(DataContext);
}
function DataProvider(_a) {
    var name = _a.name, data = _a.data, hidden = _a.hidden, advanced = _a.advanced, label = _a.label, children = _a.children;
    var parentContext = useDataEnv();
    var childContext = (0,react.useMemo)(function () {
        var _a;
        if (!name) {
            return null;
        }
        return __assign(__assign({}, parentContext), (_a = {}, _a[name] = data, _a[mkMetaName(name)] = mkMetaValue({ hidden: hidden, advanced: advanced, label: label }), _a));
    }, [parentContext, name, data, hidden, advanced, label]);
    if (childContext === null) {
        return react.createElement(react.Fragment, null, children);
    }
    else {
        return (react.createElement(DataContext.Provider, { value: childContext }, children));
    }
}
/**
 * This transforms `{ "...slug": "a/b/c" }` into `{ "slug": ["a", "b", "c"] }.
 */
function fixCatchallParams(params) {
    var newParams = {};
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (!value) {
            continue;
        }
        if (key.startsWith("...")) {
            newParams[key.slice(3)] =
                typeof value === "string"
                    ? value.replace(/^\/|\/$/g, "").split("/")
                    : value;
        }
        else {
            newParams[key] = value;
        }
    }
    return newParams;
}
function mkPathFromRouteAndParams(route, params) {
    if (!params) {
        return route;
    }
    var path = route;
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (typeof value === "string") {
            path = path.replace("[".concat(key, "]"), value);
        }
        else if (Array.isArray(value)) {
            if (path.includes("[[...".concat(key, "]]"))) {
                path = path.replace("[[...".concat(key, "]]"), value.join("/"));
            }
            else if (path.includes("[...".concat(key, "]"))) {
                path = path.replace("[...".concat(key, "]"), value.join("/"));
            }
        }
    }
    return path;
}
function PageParamsProvider(_a) {
    var children = _a.children, route = _a.route, deprecatedRoute = _a.path, _b = _a.params, params = _b === void 0 ? {} : _b, _c = _a.query, query = _c === void 0 ? {} : _c;
    route = route !== null && route !== void 0 ? route : deprecatedRoute;
    params = fixCatchallParams(params);
    var $ctx = useDataEnv() || {};
    var path = route ? mkPathFromRouteAndParams(route, params) : undefined;
    return (react.createElement(DataProvider, { name: "pageRoute", data: route, label: "Page route", advanced: true },
        react.createElement(DataProvider, { name: "pagePath", data: path, label: "Page path" },
            react.createElement(DataProvider, { name: "params", data: __assign(__assign({}, $ctx.params), params), label: "Page URL path params" },
                react.createElement(DataProvider, { name: "query", data: __assign(__assign({}, $ctx.query), query), label: "Page URL query params" }, children)))));
}
function DataCtxReader(_a) {
    var children = _a.children;
    var $ctx = useDataEnv();
    return children($ctx);
}

var root$7 = globalThis;
root$7.__PlasmicFetcherRegistry = [];
function registerFetcher(fetcher, meta) {
    root$7.__PlasmicFetcherRegistry.push({ fetcher: fetcher, meta: meta });
}

var GlobalActionsContext = react.createContext(undefined);
function GlobalActionsProvider(props) {
    var contextName = props.contextName, children = props.children, actions = props.actions;
    var existingActions = useGlobalActions();
    var namespacedActions = react.useMemo(function () {
        return Object.fromEntries(Object.entries(actions).map(function (_a) {
            var key = _a[0], val = _a[1];
            return [
                "".concat(contextName, ".").concat(key),
                val,
            ];
        }));
    }, [contextName, actions]);
    return (react.createElement(GlobalActionsContext.Provider, { value: __assign(__assign({}, existingActions), namespacedActions) }, children));
}
function useGlobalActions() {
    var _a;
    return (_a = react.useContext(GlobalActionsContext)) !== null && _a !== void 0 ? _a : {};
}

var PlasmicLinkContext = react.createContext(undefined);
function usePlasmicLinkMaybe() {
    return react.useContext(PlasmicLinkContext);
}
var AnchorLink = react.forwardRef(function AnchorLink(props, ref) {
    return react.createElement("a", __assign({}, props, { ref: ref }));
});
function usePlasmicLink() {
    var Link = react.useContext(PlasmicLinkContext);
    if (Link) {
        return Link;
    }
    else {
        return AnchorLink;
    }
}
function PlasmicLinkProvider(props) {
    var Link = props.Link, children = props.children;
    return (react.createElement(PlasmicLinkContext.Provider, { value: Link }, children));
}

var root$6 = globalThis;
// A compile-time error will occur if a new field is added to the StateHelper
// interface but not included in the keys array of state helper.
var stateHelpersKeys = [
    "initFunc",
    "onChangeArgsToValue",
    "onMutate",
];
if (root$6.__PlasmicComponentRegistry == null) {
    root$6.__PlasmicComponentRegistry = [];
}
function registerComponent(component, meta) {
    // Check for duplicates
    if (root$6.__PlasmicComponentRegistry.some(function (r) {
        return r.component === component && r.meta.name === meta.name;
    })) {
        return;
    }
    root$6.__PlasmicComponentRegistry.push({ component: component, meta: meta });
}

var root$5 = globalThis;
if (root$5.__PlasmicFunctionsRegistry == null) {
    root$5.__PlasmicFunctionsRegistry = [];
}
function registerFunction(fn, meta) {
    // Check for duplicates
    if (root$5.__PlasmicFunctionsRegistry.some(function (r) {
        return r.function === fn &&
            r.meta.name === meta.name &&
            r.meta.namespace == meta.namespace;
    })) {
        return;
    }
    root$5.__PlasmicFunctionsRegistry.push({ function: fn, meta: meta });
}

var root$4 = globalThis;
if (root$4.__PlasmicContextRegistry == null) {
    root$4.__PlasmicContextRegistry = [];
}
function registerGlobalContext(component, meta) {
    // Check for duplicates
    if (root$4.__PlasmicContextRegistry.some(function (r) {
        return r.component === component && r.meta.name === meta.name;
    })) {
        return;
    }
    root$4.__PlasmicContextRegistry.push({ component: component, meta: meta });
}

var root$3 = globalThis;
if (root$3.__PlasmicTokenRegistry == null) {
    root$3.__PlasmicTokenRegistry = [];
}
function registerToken(token) {
    root$3.__PlasmicTokenRegistry.push(token);
}

var root$2 = globalThis;
if (root$2.__PlasmicTraitRegistry == null) {
    root$2.__PlasmicTraitRegistry = [];
}
function registerTrait(trait, meta) {
    root$2.__PlasmicTraitRegistry.push({
        trait: trait,
        meta: meta,
    });
}

var _a$1, _b;
function repeatedElement(index, elt) {
    return repeatedElementFn(index, elt);
}
var repeatedElementFn = function (index, elt) {
    if (Array.isArray(elt)) {
        return elt.map(function (v) { return repeatedElementFn(index, v); });
    }
    if (elt && (0,react.isValidElement)(elt) && typeof elt !== "string") {
        return (0,react.cloneElement)(elt);
    }
    return elt;
};
var root$1 = globalThis;
var setRepeatedElementFn = (_b = (_a$1 = root$1 === null || root$1 === void 0 ? void 0 : root$1.__Sub) === null || _a$1 === void 0 ? void 0 : _a$1.setRepeatedElementFn) !== null && _b !== void 0 ? _b : function (fn) {
    repeatedElementFn = fn;
};

var PlasmicTranslatorContext = react.createContext(undefined);
function usePlasmicTranslator() {
    var _t = react.useContext(PlasmicTranslatorContext);
    var translator = _t
        ? typeof _t === "function"
            ? _t
            : _t.translator
        : undefined;
    return translator;
}

var hostModule = /*#__PURE__*/Object.freeze({
    __proto__: null,
    DataContext: DataContext,
    DataCtxReader: DataCtxReader,
    DataProvider: DataProvider,
    GlobalActionsContext: GlobalActionsContext,
    GlobalActionsProvider: GlobalActionsProvider,
    PageParamsProvider: PageParamsProvider,
    PlasmicCanvasContext: PlasmicCanvasContext,
    PlasmicCanvasHost: PlasmicCanvasHost,
    PlasmicLinkProvider: PlasmicLinkProvider,
    PlasmicTranslatorContext: PlasmicTranslatorContext,
    applySelector: applySelector,
    mkMetaName: mkMetaName,
    mkMetaValue: mkMetaValue,
    registerComponent: registerComponent,
    registerFunction: registerFunction,
    registerGlobalContext: registerGlobalContext,
    registerToken: registerToken,
    registerTrait: registerTrait,
    repeatedElement: repeatedElement,
    stateHelpersKeys: stateHelpersKeys,
    unstable_registerFetcher: registerFetcher,
    useDataEnv: useDataEnv,
    useGlobalActions: useGlobalActions,
    usePlasmicCanvasComponentInfo: usePlasmicCanvasComponentInfo,
    usePlasmicCanvasContext: usePlasmicCanvasContext,
    usePlasmicLink: usePlasmicLink,
    usePlasmicLinkMaybe: usePlasmicLinkMaybe,
    usePlasmicTranslator: usePlasmicTranslator,
    useSelector: useSelector,
    useSelectors: useSelectors
});

var hostVersion = "1.0.212";

var _a;
var root = globalThis;
if (root.__Sub == null) {
    // Creating a side effect here by logging, so that vite won't
    // ignore this block for whatever reason. Hiding this for now
    // as users are complaining; will have to check if this has
    // been fixed with vite.
    // console.log("Plasmic: Setting up app host dependencies");
    root.__Sub = __assign({ React: react_namespaceObject, ReactDOM: react_dom_namespaceObject, jsxRuntime: jsx_runtime_namespaceObject, jsxDevRuntime: jsx_dev_runtime_namespaceObject, PlasmicQuery: index_esm, hostModule: hostModule, hostVersion: hostVersion, hostUtils: {
            setPlasmicRootNode: setPlasmicRootNode,
            registerRenderErrorListener: registerRenderErrorListener,
            setRepeatedElementFn: setRepeatedElementFn,
        }, 
        // For backwards compatibility:
        setPlasmicRootNode: setPlasmicRootNode, registerRenderErrorListener: registerRenderErrorListener, setRepeatedElementFn: setRepeatedElementFn }, hostModule);
}
else {
    console.warn("Encountered likely duplicate host version: ".concat(root.__Sub.hostVersion, " vs ").concat(hostVersion));
    root.__Sub.duplicateHostVersions = (_a = root.__Sub.duplicateHostVersions) !== null && _a !== void 0 ? _a : [];
    root.__Sub.duplicateHostVersions.push(hostVersion);
}


//# sourceMappingURL=host.esm.js.map

// EXTERNAL MODULE: ./node_modules/@plasmicapp/loader-core/dist/index.esm.js
var dist_index_esm = __webpack_require__(8296);
// EXTERNAL MODULE: ./node_modules/pascalcase/index.js
var pascalcase = __webpack_require__(8339);
var pascalcase_default = /*#__PURE__*/__webpack_require__.n(pascalcase);
// EXTERNAL MODULE: ./node_modules/@plasmicapp/loader-fetcher/dist/index.esm.js
var loader_fetcher_dist_index_esm = __webpack_require__(7915);
// EXTERNAL MODULE: ./node_modules/json-logic-js/logic.js
var logic = __webpack_require__(962);
var logic_default = /*#__PURE__*/__webpack_require__.n(logic);
;// CONCATENATED MODULE: ./node_modules/@plasmicapp/loader-splits/dist/index.esm.js
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/random.ts
var getSeededRandomFunction = (strSeed) => {
  function cyrb128(str) {
    let h1 = 1779033703, h2 = 3144134277, h3 = 1013904242, h4 = 2773480762;
    for (let i = 0, k; i < str.length; i++) {
      k = str.charCodeAt(i);
      h1 = h2 ^ Math.imul(h1 ^ k, 597399067);
      h2 = h3 ^ Math.imul(h2 ^ k, 2869860233);
      h3 = h4 ^ Math.imul(h3 ^ k, 951274213);
      h4 = h1 ^ Math.imul(h4 ^ k, 2716044179);
    }
    h1 = Math.imul(h3 ^ h1 >>> 18, 597399067);
    h2 = Math.imul(h4 ^ h2 >>> 22, 2869860233);
    h3 = Math.imul(h1 ^ h3 >>> 17, 951274213);
    h4 = Math.imul(h2 ^ h4 >>> 19, 2716044179);
    return [
      (h1 ^ h2 ^ h3 ^ h4) >>> 0,
      (h2 ^ h1) >>> 0,
      (h3 ^ h1) >>> 0,
      (h4 ^ h1) >>> 0
    ];
  }
  function sfc32(a, b, c, d) {
    return function() {
      a >>>= 0;
      b >>>= 0;
      c >>>= 0;
      d >>>= 0;
      let t = a + b | 0;
      a = b ^ b >>> 9;
      b = c + (c << 3) | 0;
      c = c << 21 | c >>> 11;
      d = d + 1 | 0;
      t = t + d | 0;
      c = c + t | 0;
      return (t >>> 0) / 4294967296;
    };
  }
  const seed = cyrb128(strSeed);
  const rand = sfc32(seed[0], seed[1], seed[2], seed[3]);
  return rand;
};

// src/variation.ts

var isBrowser = typeof window !== "undefined" && window != null && typeof window.document !== "undefined";
var PLASMIC_SEED = "plasmic_seed";
var BUILTIN_TRAITS_UNKNOWN = {
  pageUrl: "unknown"
};
var getBrowserBuiltinTraits = () => {
  if (!isBrowser) {
    return {};
  }
  return {
    pageUrl: document.location.href
  };
};
var getSplitKey = (split) => {
  return `${split.type === "experiment" ? "exp." : "seg."}${split.id}`;
};
function getActiveVariation(opts) {
  const { splits, getKnownValue, updateKnownValue } = opts;
  const getRandomValue = (key) => {
    var _a;
    if (opts.getRandomValue) {
      return opts.getRandomValue(key);
    }
    if (opts.traits[PLASMIC_SEED]) {
      const rand = getSeededRandomFunction(
        ((_a = opts.traits[PLASMIC_SEED]) != null ? _a : "") + key
      );
      return rand();
    }
    if (!opts.enableUnseededExperiments) {
      return 0;
    }
    return Math.random();
  };
  const variation = {};
  splits.forEach((split) => {
    var _a;
    const key = getSplitKey(split);
    const knownVal = split.type === "experiment" ? getKnownValue == null ? void 0 : getKnownValue(key) : void 0;
    if (knownVal) {
      variation[key] = knownVal;
      return;
    }
    const numSlices = split.slices.length;
    let chosenSlice = void 0;
    if (split.type === "experiment") {
      if (opts.useSeedBucketing) {
        const seed = opts.traits[PLASMIC_SEED];
        const buckets = [];
        const totalBuckets = (_a = opts.seedRange) != null ? _a : 1;
        let avaiableBuckets = totalBuckets;
        for (let i = 0; i < numSlices; i++) {
          const slice = split.slices[i];
          const numBuckets = Math.min(
            Math.floor(slice.prob * totalBuckets),
            avaiableBuckets
          );
          for (let j = 0; j < numBuckets; j++) {
            buckets.push(slice.id);
          }
          avaiableBuckets -= numBuckets;
        }
        if (buckets.length > 0) {
          const shuffleRand = getSeededRandomFunction(split.id);
          for (let i = 0; i < buckets.length; i++) {
            const j = Math.floor(shuffleRand() * (i + 1));
            [buckets[i], buckets[j]] = [buckets[j], buckets[i]];
          }
          const sliceIdx = +(seed != null ? seed : "0") % buckets.length;
          chosenSlice = split.slices.find((s) => s.id === buckets[sliceIdx]);
        } else {
          chosenSlice = split.slices[numSlices - 1];
        }
      } else {
        let p = getRandomValue(split.id);
        chosenSlice = split.slices[numSlices - 1];
        for (let i = 0; i < numSlices; i++) {
          if (p - split.slices[i].prob <= 0) {
            chosenSlice = split.slices[i];
            break;
          }
          p -= split.slices[i].prob;
        }
      }
    } else if (split.type === "segment") {
      for (let i = 0; i < numSlices; i++) {
        if (logic_default().apply(split.slices[i].cond, __spreadValues(__spreadValues(__spreadValues({
          time: (/* @__PURE__ */ new Date()).toISOString()
        }, BUILTIN_TRAITS_UNKNOWN), getBrowserBuiltinTraits()), opts.traits))) {
          chosenSlice = split.slices[i];
        }
      }
    }
    if (chosenSlice) {
      variation[key] = chosenSlice.id;
      if (split.externalId && chosenSlice.externalId) {
        variation[`ext.${split.externalId}`] = chosenSlice.externalId;
      }
      if (split.type === "experiment") {
        updateKnownValue == null ? void 0 : updateKnownValue(key, chosenSlice.id);
      }
    }
  });
  return variation;
}
function getExternalIds(splits, variation, filters) {
  const externalVariation = {};
  function shouldIncludeSplit(split) {
    if (!filters) {
      return true;
    }
    if (filters.projectIds && !filters.projectIds.includes(split.projectId)) {
      return false;
    }
    if (filters.customFilter && !filters.customFilter(split)) {
      return false;
    }
    return true;
  }
  Object.keys(variation).forEach((variationKey) => {
    const [, splitId] = variationKey.split(".");
    const sliceId = variation[variationKey];
    const split = splits.find(
      (s) => s.id === splitId || s.externalId === splitId
    );
    if (split && split.externalId && shouldIncludeSplit(split)) {
      const slice = split.slices.find((s) => s.id === sliceId || s.externalId === sliceId);
      if (slice == null ? void 0 : slice.externalId) {
        externalVariation[`${split.externalId}`] = slice.externalId;
      }
    }
  });
  return externalVariation;
}
function describeVariationForKey(splits, key, value) {
  const [, splitId] = key.split(".");
  const split = splits.find(
    (s) => s.id === splitId || s.externalId === splitId
  );
  if (!split) {
    throw new Error(`Split not found for key "${key}"`);
  }
  const sliceIndex = split.slices.findIndex(
    (s) => s.id === value || s.externalId === value
  );
  if (sliceIndex === -1) {
    throw new Error(`Invalid split value "${value}" for key "${key}"`);
  }
  return {
    name: split.name,
    description: split.description,
    pagesPaths: split.pagesPaths,
    type: sliceIndex === 0 ? "original" : "override",
    chosenValue: value,
    externalIdGroup: split.externalId,
    externalIdValue: sliceIndex >= 0 && split.slices[sliceIndex].externalId ? split.slices[sliceIndex].externalId : void 0
  };
}
function describeVariation(splits, variation) {
  return Object.fromEntries(
    Object.entries(variation).map(([key, value]) => {
      return [key, describeVariationForKey(splits, key, value)];
    })
  );
}

//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ./node_modules/@plasmicapp/prepass/dist/index.esm.js + 1 modules
var prepass_dist_index_esm = __webpack_require__(9143);
// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__(7762);
;// CONCATENATED MODULE: ./node_modules/@plasmicapp/loader-react/dist/index.esm.js
"use client";
var index_esm_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var index_esm_getOwnPropSymbols = Object.getOwnPropertySymbols;
var index_esm_hasOwnProp = Object.prototype.hasOwnProperty;
var index_esm_propIsEnum = Object.prototype.propertyIsEnumerable;
var index_esm_defNormalProp = (obj, key, value) => key in obj ? index_esm_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var index_esm_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (index_esm_hasOwnProp.call(b, prop))
      index_esm_defNormalProp(a, prop, b[prop]);
  if (index_esm_getOwnPropSymbols)
    for (var prop of index_esm_getOwnPropSymbols(b)) {
      if (index_esm_propIsEnum.call(b, prop))
        index_esm_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (index_esm_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && index_esm_getOwnPropSymbols)
    for (var prop of index_esm_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && index_esm_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/loader-client.ts










// src/PlasmicRootProvider.tsx




// src/utils.tsx


var index_esm_isBrowser = typeof window !== "undefined";
function index_esm_useForceUpdate() {
  const [, setTick] = react.useState(0);
  const update = react.useCallback(() => {
    setTick((tick) => tick + 1);
  }, []);
  return update;
}
function useStableLookupSpec(spec) {
  return useStableLookupSpecs(spec)[0];
}
function useStableLookupSpecs(...specs) {
  const [stableSpecs, setStableSpecs] = react.useState(specs);
  react.useEffect(() => {
    if (specs.length !== stableSpecs.length || specs.some((s, i) => !areLookupSpecsEqual(s, stableSpecs[i]))) {
      setStableSpecs(specs);
    }
  }, [specs, stableSpecs]);
  return stableSpecs;
}
function areLookupSpecsEqual(spec1, spec2) {
  if (spec1 === spec2) {
    return true;
  }
  if (typeof spec1 !== typeof spec2) {
    return false;
  }
  const fullSpec1 = toFullLookup(spec1);
  const fullSpec2 = toFullLookup(spec2);
  return (isNameSpec(fullSpec1) && isNameSpec(fullSpec2) && fullSpec1.name === fullSpec2.name && fullSpec1.isCode === fullSpec2.isCode || isPathSpec(fullSpec1) && isPathSpec(fullSpec2) && fullSpec1.path === fullSpec2.path) && fullSpec1.projectId === fullSpec2.projectId;
}
function isNameSpec(lookup) {
  return "name" in lookup;
}
function isPathSpec(lookup) {
  return "path" in lookup;
}
function toFullLookup(lookup) {
  const namePart = typeof lookup === "string" ? lookup : lookup.name;
  const projectId = typeof lookup === "string" ? void 0 : lookup.projectId;
  const codeComponent = typeof lookup === "string" ? void 0 : lookup.isCode;
  if (codeComponent !== true && namePart.startsWith("/")) {
    return { path: normalizePath(namePart), projectId };
  } else {
    return {
      name: codeComponent ? namePart : normalizeName(namePart),
      rawName: namePart.trim(),
      projectId,
      isCode: codeComponent
    };
  }
}
function normalizePath(path) {
  return path.trim();
}
function normalizeName(name) {
  return pascalcase_default()(name).trim();
}
function useIsMounted() {
  const ref = react.useRef(false);
  const isMounted = react.useCallback(() => ref.current, []);
  react.useEffect(() => {
    ref.current = true;
    return () => {
      ref.current = false;
    };
  }, []);
  return isMounted;
}
function matchesPagePath(pattern, path) {
  const normalizedPattern = "/" + pattern.replace(/^\/|\/$/g, "");
  const normalizedPath = "/" + path.replace(/^\/|\/$/g, "");
  const regexString = normalizedPattern.replace(/\/\[\[\.\.\.([^\]^]+)]]/g, "(?:/([^]*))?").replace(/\/\[\.\.\.([^\]^]+)]/g, "/([^]*)").replace(/\[([^\]^]+)]/g, "([^/]+)").replace(/\//g, "\\/");
  const regex = new RegExp(`^/?${regexString}$`);
  const match = normalizedPath.match(regex);
  if (!match)
    return false;
  const slugNames = [...pattern.matchAll(/\[\.?\.?\.?([^[\]]+)]/g)].map(
    (m) => m[1]
  );
  const params = {};
  for (let i = 0; i < slugNames.length; i++) {
    const slugName = slugNames[i];
    const value = match[i + 1];
    if (pattern.includes(`[[...${slugName}]]`)) {
      params[slugName] = value ? value.split("/").filter(Boolean) : [];
    } else if (pattern.includes(`[...${slugName}]`)) {
      params[slugName] = value.split("/").filter(Boolean);
    } else if (value !== void 0) {
      params[slugName] = value;
    }
  }
  return { params };
}
function isDynamicPagePath(path) {
  return !!path.match(/\[[^/]*\]/);
}
function matchesCompMeta(lookup, meta) {
  if (lookup.projectId && meta.projectId !== lookup.projectId) {
    return false;
  }
  return isNameSpec(lookup) ? (lookup.name === meta.name || lookup.rawName === meta.name || lookup.rawName === meta.displayName) && (lookup.isCode == null || lookup.isCode === meta.isCode) : !!(meta.path && matchesPagePath(meta.path, lookup.path));
}
function getCompMetas(metas, lookup) {
  const full = toFullLookup(lookup);
  return metas.filter((meta) => matchesCompMeta(full, meta)).map(
    (meta) => {
      if (isNameSpec(full) || !meta.path) {
        return meta;
      }
      const match = matchesPagePath(meta.path, full.path);
      if (!match) {
        return meta;
      }
      return __spreadProps(index_esm_spreadValues({}, meta), { params: match.params });
    }
  ).sort(
    (meta1, meta2) => (
      // We sort the matched component metas by the number of path params, so
      // if there are two pages `/products/foo` and `/products/[slug]`,
      // the first one will have higher precedence.
      Array.from(Object.keys(meta1.params || {})).length - Array.from(Object.keys(meta2.params || {})).length
    )
  );
}
function getLookupSpecName(lookup) {
  if (typeof lookup === "string") {
    return lookup;
  } else if (lookup.projectId) {
    return `${lookup.name} (project ${lookup.projectId})`;
  } else {
    return lookup.name;
  }
}
function MaybeWrap(props) {
  return props.cond ? props.wrapper(props.children) : props.children;
}
function uniq(elements) {
  return Array.from(new Set(elements));
}
function intersect(a, b) {
  const setB = new Set(b);
  return a.filter((elt) => setB.has(elt));
}

// src/variation.ts
function getPlasmicCookieValues() {
  return Object.fromEntries(
    document.cookie.split("; ").filter((cookie) => cookie.includes("plasmic:")).map((cookie) => cookie.split("=")).map(([key, value]) => [key.split(":")[1], value])
  );
}
function updatePlasmicCookieValue(key, value) {
  document.cookie = `plasmic:${key}=${value}`;
}
var getGlobalVariantsFromSplits = (splits, variation) => {
  const globalVariants = [];
  Object.keys(variation).map((variationKey) => {
    const [_type, splitId] = variationKey.split(".");
    const sliceId = variation[variationKey];
    const split = splits.find(
      (s) => s.id === splitId || s.externalId === splitId
    );
    if (split) {
      const slice = split.slices.find((s) => s.id === sliceId || s.externalId === sliceId);
      if (slice) {
        slice.contents.map((x) => {
          globalVariants.push({
            name: x.group,
            value: x.variant,
            projectId: x.projectId
          });
        });
      }
    }
  });
  return globalVariants;
};
var mergeGlobalVariantsSpec = (target, from) => {
  let result = [...target];
  const existingGlobalVariants = new Set(
    target.map((t) => {
      var _a;
      return `${t.name}-${(_a = t.projectId) != null ? _a : ""}`;
    })
  );
  const newGlobals = from.filter(
    (t) => {
      var _a;
      return !existingGlobalVariants.has(`${t.name}-${(_a = t.projectId) != null ? _a : ""}`);
    }
  );
  if (newGlobals.length > 0) {
    result = [...result, ...newGlobals];
  }
  return result;
};

// src/PlasmicRootProvider.tsx
var PlasmicRootContext = react.createContext(void 0);
function PlasmicRootProvider(props) {
  const {
    globalVariants,
    prefetchedData,
    children,
    skipCss,
    skipFonts,
    prefetchedQueryData,
    suspenseForQueryData,
    globalContextsProps,
    variation,
    translator,
    Head,
    Link,
    pageRoute,
    pageParams,
    pageQuery,
    suspenseFallback,
    disableLoadingBoundary,
    disableRootLoadingBoundary
  } = props;
  const loader = props.loader.__internal;
  if (prefetchedData) {
    loader.registerPrefetchedBundle(prefetchedData.bundle);
  }
  const [splits, setSplits] = react.useState(loader.getActiveSplits());
  const forceUpdate = index_esm_useForceUpdate();
  const watcher = react.useMemo(
    () => ({
      onDataFetched: () => {
        setSplits(loader.getActiveSplits());
        forceUpdate();
      }
    }),
    [loader, forceUpdate]
  );
  react.useEffect(() => {
    loader.subscribePlasmicRoot(watcher);
    return () => loader.unsubscribePlasmicRoot(watcher);
  }, [watcher, loader]);
  const currentContextValue = react.useContext(PlasmicRootContext);
  const { user, userAuthToken, isUserLoading, authRedirectUri } = props;
  const value = react.useMemo(() => {
    var _a, _b, _c;
    const withCurrentContextValueFallback = (v, key) => {
      return v !== void 0 ? v : currentContextValue == null ? void 0 : currentContextValue[key];
    };
    return {
      globalVariants: [
        ...mergeGlobalVariantsSpec(
          globalVariants != null ? globalVariants : [],
          getGlobalVariantsFromSplits(splits, variation != null ? variation : {})
        ),
        ...(_a = currentContextValue == null ? void 0 : currentContextValue.globalVariants) != null ? _a : []
      ],
      globalContextsProps: index_esm_spreadValues(index_esm_spreadValues({}, (_b = currentContextValue == null ? void 0 : currentContextValue.globalContextsProps) != null ? _b : {}), globalContextsProps != null ? globalContextsProps : {}),
      loader: withCurrentContextValueFallback(loader, "loader"),
      variation: index_esm_spreadValues(index_esm_spreadValues({}, (_c = currentContextValue == null ? void 0 : currentContextValue.variation) != null ? _c : {}), variation != null ? variation : {}),
      translator: withCurrentContextValueFallback(translator, "translator"),
      Head: withCurrentContextValueFallback(Head, "Head"),
      Link: withCurrentContextValueFallback(Link, "Link"),
      user: withCurrentContextValueFallback(user, "user"),
      userAuthToken: withCurrentContextValueFallback(
        userAuthToken,
        "userAuthToken"
      ),
      isUserLoading: withCurrentContextValueFallback(
        isUserLoading,
        "isUserLoading"
      ),
      authRedirectUri: withCurrentContextValueFallback(
        authRedirectUri,
        "authRedirectUri"
      ),
      suspenseFallback: withCurrentContextValueFallback(
        suspenseFallback,
        "suspenseFallback"
      ),
      disableLoadingBoundary: withCurrentContextValueFallback(
        disableLoadingBoundary,
        "disableLoadingBoundary"
      )
    };
  }, [
    globalVariants,
    variation,
    globalContextsProps,
    loader,
    splits,
    translator,
    Head,
    Link,
    user,
    userAuthToken,
    isUserLoading,
    authRedirectUri,
    suspenseFallback,
    disableLoadingBoundary,
    currentContextValue
  ]);
  react.useEffect(() => {
    loader.trackRender({
      renderCtx: {
        // We track the provider as a single entity
        rootComponentId: "provider",
        teamIds: loader.getTeamIds(),
        projectIds: loader.getProjectIds()
      },
      variation: value.variation
    });
  }, [loader, value]);
  const reactMajorVersion = +react.version.split(".")[0];
  const shouldDisableRootLoadingBoundary = disableRootLoadingBoundary != null ? disableRootLoadingBoundary : loader.getBundle().disableRootLoadingBoundaryByDefault;
  return /* @__PURE__ */ react.createElement(
    index_esm.PlasmicQueryDataProvider,
    {
      prefetchedCache: prefetchedQueryData,
      suspense: suspenseForQueryData
    },
    /* @__PURE__ */ react.createElement(PlasmicRootContext.Provider, { value }, !skipCss && /* @__PURE__ */ react.createElement(
      PlasmicCss,
      {
        loader,
        prefetchedData,
        skipFonts
      }
    ), /* @__PURE__ */ react.createElement(
      PageParamsProvider,
      {
        route: pageRoute,
        params: pageParams,
        query: pageQuery
      },
      /* @__PURE__ */ react.createElement(
        MaybeWrap,
        {
          cond: !shouldDisableRootLoadingBoundary && reactMajorVersion >= 18,
          wrapper: (contents) => /* @__PURE__ */ react.createElement(react.Suspense, { fallback: suspenseFallback != null ? suspenseFallback : "Loading..." }, contents)
        },
        children
      )
    ))
  );
}
var PlasmicCss = react.memo(function PlasmicCss2(props) {
  const { loader, prefetchedData, skipFonts } = props;
  const [useScopedCss, setUseScopedCss] = react.useState(!!prefetchedData);
  const builtCss = buildCss(loader, {
    scopedCompMetas: useScopedCss && prefetchedData ? prefetchedData.bundle.components : void 0,
    skipFonts
  });
  const forceUpdate = index_esm_useForceUpdate();
  const watcher = react.useMemo(
    () => ({
      onDataFetched: () => {
        setUseScopedCss(false);
        forceUpdate();
      }
    }),
    [loader, forceUpdate]
  );
  react.useEffect(() => {
    loader.subscribePlasmicRoot(watcher);
    return () => loader.unsubscribePlasmicRoot(watcher);
  }, [watcher, loader]);
  return /* @__PURE__ */ react.createElement("style", { dangerouslySetInnerHTML: { __html: builtCss } });
});
function buildCss(loader, opts) {
  const { scopedCompMetas, skipFonts } = opts;
  const cssFiles = scopedCompMetas && /* @__PURE__ */ new Set([
    "entrypoint.css",
    ...scopedCompMetas.map((c) => c.cssFile)
  ]);
  const cssModules = loader.getLookup().getCss().filter((f) => !cssFiles || cssFiles.has(f.fileName));
  const getPri = (fileName) => fileName === "entrypoint.css" ? 0 : 1;
  const compareModules = (a, b) => getPri(a.fileName) !== getPri(b.fileName) ? getPri(a.fileName) - getPri(b.fileName) : a.fileName.localeCompare(b.fileName);
  cssModules.sort(compareModules);
  const remoteFonts = loader.getLookup().getRemoteFonts();
  return `
    ${skipFonts ? "" : remoteFonts.map((f) => `@import url('${f.url}');`).join("\n")}
    ${cssModules.map((mod) => mod.source).join("\n")}
  `;
}
function usePlasmicRootContext() {
  return react.useContext(PlasmicRootContext);
}

// src/global-variants.ts
function createUseGlobalVariant(name, projectId) {
  return () => {
    var _a;
    const rootContext = usePlasmicRootContext();
    if (!rootContext) {
      return void 0;
    }
    const loader = rootContext.loader;
    const spec = [
      ...loader.getGlobalVariants(),
      ...(_a = rootContext.globalVariants) != null ? _a : []
    ].find(
      (spec2) => spec2.name === name && (!spec2.projectId || spec2.projectId === projectId)
    );
    return spec ? spec.value : void 0;
  };
}

// src/loader-shared.ts




// src/bundles.ts

function getUsedComps(allComponents, entryCompIds) {
  const q = [...entryCompIds];
  const seenIds = new Set(entryCompIds);
  const componentMetaById = new Map(
    allComponents.map((meta) => [meta.id, meta])
  );
  const usedComps = [];
  while (q.length > 0) {
    const [id] = q.splice(0, 1);
    const meta = componentMetaById.get(id);
    if (!meta) {
      continue;
    }
    usedComps.push(meta);
    meta.usedComponents.forEach((usedCompId) => {
      if (!seenIds.has(usedCompId)) {
        seenIds.add(usedCompId);
        q.push(usedCompId);
      }
    });
  }
  return usedComps;
}
function prepComponentData(bundle, compMetas, opts) {
  if (compMetas.length === 0) {
    return {
      entryCompMetas: bundle.components,
      bundle,
      remoteFontUrls: []
    };
  }
  const usedComps = getUsedComps(
    bundle.components,
    compMetas.map((compMeta) => compMeta.id)
  );
  const compPaths = usedComps.map((compMeta) => compMeta.entry);
  const subBundle = (0,dist_index_esm/* getBundleSubset */.yA)(
    bundle,
    [
      "entrypoint.css",
      ...compPaths,
      "root-provider.js",
      ...bundle.projects.map((x) => x.globalContextsProviderFileName).filter((x) => !!x),
      // We need to explicitly include global context provider components
      // to make sure they are kept in bundle.components. That's because
      // for esbuild, just the globalContextsProviderFileName is not enough,
      // because it will import a chunk that includes the global context
      // component, instead of importing that global context component's
      // entry file. And because nothing depends on the global context component's
      // entry file, we end up excluding the global context component from
      // bundle.components, which then makes its substitution not work.
      // Instead, we forcibly include it here (we'll definitely need it anyway!).
      ...bundle.components.filter((c) => c.isGlobalContextProvider).map((c) => c.entry),
      ...bundle.globalGroups.map((g) => g.contextFile)
    ],
    opts
  );
  const remoteFontUrls = [];
  subBundle.projects.forEach(
    (p) => remoteFontUrls.push(...p.remoteFonts.map((f) => f.url))
  );
  return {
    entryCompMetas: compMetas,
    bundle: subBundle,
    remoteFontUrls
  };
}
function mergeBundles(target, from) {
  var _a, _b, _c, _d, _e, _f, _g;
  const existingProjects = new Set(target.projects.map((p) => p.id));
  const newProjects = from.projects.filter((p) => !existingProjects.has(p.id));
  if (newProjects.length > 0) {
    target = __spreadProps(index_esm_spreadValues({}, target), {
      projects: [...target.projects, ...newProjects]
    });
  }
  const existingCompIds = new Set(target.components.map((c) => c.id));
  function shouldIncludeComponentInBundle(c) {
    var _a2;
    if (existingCompIds.has(c.id)) {
      return false;
    }
    if (!existingProjects.has(c.projectId)) {
      return true;
    }
    const targetBundleFilteredIds = (_a2 = target.filteredIds[c.projectId]) != null ? _a2 : [];
    return targetBundleFilteredIds.includes(c.id);
  }
  const newCompMetas = from.components.filter(
    (m) => shouldIncludeComponentInBundle(m)
  );
  if (newCompMetas.length > 0) {
    target = __spreadProps(index_esm_spreadValues({}, target), {
      components: [...target.components, ...newCompMetas]
    });
    target.filteredIds = Object.fromEntries(
      Object.entries(target.filteredIds).map(([k, v]) => [k, [...v]])
    );
    from.projects.forEach((fromProject) => {
      var _a2, _b2;
      const projectId = fromProject.id;
      const fromBundleFilteredIds = (_a2 = from.filteredIds[projectId]) != null ? _a2 : [];
      if (!existingProjects.has(projectId)) {
        target.filteredIds[projectId] = [...fromBundleFilteredIds];
      } else {
        target.filteredIds[projectId] = intersect(
          (_b2 = target.filteredIds[projectId]) != null ? _b2 : [],
          fromBundleFilteredIds
        );
      }
    });
  }
  const existingModules = {
    browser: new Set(target.modules.browser.map((m) => m.fileName)),
    server: new Set(target.modules.server.map((m) => m.fileName))
  };
  const newModules = {
    browser: from.modules.browser.filter(
      (m) => !existingModules.browser.has(m.fileName)
    ),
    server: from.modules.server.filter(
      (m) => !existingModules.server.has(m.fileName)
    )
  };
  if (newModules.browser.length > 0 || newModules.server.length > 0) {
    target = __spreadProps(index_esm_spreadValues({}, target), {
      modules: {
        browser: [...target.modules.browser, ...newModules.browser],
        server: [...target.modules.server, ...newModules.server]
      }
    });
  }
  const existingGlobalIds = new Set(target.globalGroups.map((g) => g.id));
  const newGlobals = from.globalGroups.filter(
    (g) => !existingGlobalIds.has(g.id)
  );
  if (newGlobals.length > 0) {
    target = __spreadProps(index_esm_spreadValues({}, target), {
      globalGroups: [...target.globalGroups, ...newGlobals]
    });
  }
  const existingSplitIds = new Set(target.activeSplits.map((s) => s.id));
  const newSplits = (_a = from.activeSplits.filter(
    // Don't include splits belonging to projects already present
    // in the target bundle
    (s) => !existingSplitIds.has(s.id) && !existingProjects.has(s.projectId)
  )) != null ? _a : [];
  if (newSplits.length > 0) {
    target = __spreadProps(index_esm_spreadValues({}, target), {
      activeSplits: [...target.activeSplits, ...newSplits]
    });
  }
  target.bundleKey = (_c = (_b = target.bundleKey) != null ? _b : from.bundleKey) != null ? _c : null;
  target.deferChunksByDefault = (_e = (_d = target.deferChunksByDefault) != null ? _d : from.deferChunksByDefault) != null ? _e : false;
  target.disableRootLoadingBoundaryByDefault = (_g = (_f = target.disableRootLoadingBoundaryByDefault) != null ? _f : from.disableRootLoadingBoundaryByDefault) != null ? _g : false;
  return target;
}
var convertBundlesToComponentRenderData = (bundles, compMetas) => {
  if (bundles.length === 0) {
    return null;
  }
  const mergedBundles = bundles.reduce((prev, cur) => mergeBundles(prev, cur));
  return prepComponentData(mergedBundles, compMetas);
};

// src/component-lookup.ts
function getFirstCompMeta(metas, lookup) {
  const filtered = getCompMetas(metas, lookup);
  return filtered.length === 0 ? void 0 : filtered[0];
}
var ComponentLookup = class {
  constructor(bundle, registry) {
    this.bundle = bundle;
    this.registry = registry;
  }
  getComponentMeta(spec) {
    const compMeta = getFirstCompMeta(this.bundle.components, spec);
    return compMeta;
  }
  getComponent(spec, opts = {}) {
    const compMeta = getFirstCompMeta(this.bundle.components, spec);
    if (!compMeta) {
      throw new Error(`Component not found: ${spec}`);
    }
    const moduleName = compMeta.entry;
    if (!this.registry.hasModule(moduleName, opts)) {
      throw new Error(`Component not yet fetched: ${compMeta.name}`);
    }
    const entry = this.registry.load(moduleName, {
      forceOriginal: opts.forceOriginal
    });
    return !opts.forceOriginal && typeof (entry == null ? void 0 : entry.getPlasmicComponent) === "function" ? entry.getPlasmicComponent() : entry.default;
  }
  hasComponent(spec) {
    const compMeta = getFirstCompMeta(this.bundle.components, spec);
    if (compMeta) {
      return this.registry.hasModule(compMeta.entry);
    }
    return false;
  }
  getGlobalContexts() {
    const customGlobalMetas = this.bundle.globalGroups.filter(
      (m) => m.type === "global-user-defined"
    );
    return customGlobalMetas.map((meta) => ({
      meta,
      context: this.registry.load(meta.contextFile).default
    }));
  }
  getGlobalContextsProvider(spec) {
    const compMeta = getFirstCompMeta(this.bundle.components, spec);
    const projectMeta = compMeta ? this.bundle.projects.find((x) => x.id === compMeta.projectId) : void 0;
    if (!projectMeta || !projectMeta.globalContextsProviderFileName || !this.registry.hasModule(projectMeta.globalContextsProviderFileName)) {
      return void 0;
    }
    const entry = this.registry.load(
      projectMeta.globalContextsProviderFileName
    );
    return typeof (entry == null ? void 0 : entry.getPlasmicComponent) === "function" ? entry.getPlasmicComponent() : entry.default;
  }
  getRootProvider() {
    const entry = this.registry.load("root-provider.js");
    return entry.default;
  }
  getCss() {
    return this.bundle.modules.browser.filter(
      (mod) => mod.type === "asset" && mod.fileName.endsWith("css")
    );
  }
  getRemoteFonts() {
    return this.bundle.projects.flatMap((p) => p.remoteFonts);
  }
};

// src/loader-shared.ts
var SUBSTITUTED_COMPONENTS = {};
var REGISTERED_CODE_COMPONENT_HELPERS = {};
var SUBSTITUTED_GLOBAL_VARIANT_HOOKS = {};
var REGISTERED_CUSTOM_FUNCTIONS = {};
function customFunctionImportAlias(meta) {
  const customFunctionPrefix = `__fn_`;
  return meta.namespace ? `${customFunctionPrefix}${meta.namespace}__${meta.name}` : `${customFunctionPrefix}${meta.name}`;
}
function internalSetRegisteredFunction(fn, meta) {
  REGISTERED_CUSTOM_FUNCTIONS[customFunctionImportAlias(meta)] = fn;
}
function parseFetchComponentDataArgs(...args) {
  let specs;
  let opts;
  if (Array.isArray(args[0])) {
    specs = args[0];
    opts = args[1];
  } else {
    specs = args;
    opts = void 0;
  }
  return { specs, opts };
}
var BaseInternalPlasmicComponentLoader = class {
  constructor(args) {
    this.registry = new dist_index_esm/* Registry */.Bz();
    this.globalVariants = [];
    this.subs = [];
    this.bundle = {
      modules: {
        browser: [],
        server: []
      },
      components: [],
      globalGroups: [],
      projects: [],
      activeSplits: [],
      bundleKey: null,
      deferChunksByDefault: false,
      disableRootLoadingBoundaryByDefault: false,
      filteredIds: {}
    };
    this.opts = args.opts;
    this.fetcher = args.fetcher;
    this.tracker = args.tracker;
    this.onBundleMerged = args.onBundleMerged;
    this.onBundleFetched = args.onBundleFetched;
    this.registerModules(args.builtinModules);
  }
  maybeGetCompMetas(...specs) {
    const found = /* @__PURE__ */ new Set();
    const missing = [];
    for (const spec of specs) {
      const filteredMetas = getCompMetas(this.bundle.components, spec);
      if (filteredMetas.length > 0) {
        filteredMetas.forEach((meta) => found.add(meta));
      } else {
        missing.push(spec);
      }
    }
    return { found: Array.from(found.keys()), missing };
  }
  maybeFetchComponentData(...args) {
    return __async(this, null, function* () {
      const { specs, opts } = parseFetchComponentDataArgs(...args);
      const returnWithSpecsToFetch = (specsToFetch) => __async(this, null, function* () {
        yield this.fetchMissingData({ missingSpecs: specsToFetch });
        const { found: existingMetas2, missing: missingSpecs2 } = this.maybeGetCompMetas(...specs);
        if (missingSpecs2.length > 0) {
          return null;
        }
        return prepComponentData(this.bundle, existingMetas2, opts);
      });
      if (this.opts.alwaysFresh) {
        return yield returnWithSpecsToFetch(specs);
      }
      const { found: existingMetas, missing: missingSpecs } = this.maybeGetCompMetas(...specs);
      if (missingSpecs.length === 0) {
        return prepComponentData(this.bundle, existingMetas, opts);
      }
      return yield returnWithSpecsToFetch(missingSpecs);
    });
  }
  fetchComponentData(...args) {
    return __async(this, null, function* () {
      const { specs, opts } = parseFetchComponentDataArgs(...args);
      const data = yield this.maybeFetchComponentData(specs, opts);
      if (!data) {
        const { missing: missingSpecs } = this.maybeGetCompMetas(...specs);
        throw new Error(
          `Unable to find components ${missingSpecs.map(getLookupSpecName).join(", ")}`
        );
      }
      return data;
    });
  }
  fetchPages(opts) {
    return __async(this, null, function* () {
      this.maybeReportClientSideFetch(
        () => `Plasmic: fetching all page metadata in the browser`
      );
      const data = yield this.fetchAllData();
      return data.components.filter(
        (comp) => comp.isPage && comp.path && ((opts == null ? void 0 : opts.includeDynamicPages) || !isDynamicPagePath(comp.path))
      );
    });
  }
  fetchComponents() {
    return __async(this, null, function* () {
      this.maybeReportClientSideFetch(
        () => `Plasmic: fetching all component metadata in the browser`
      );
      const data = yield this.fetchAllData();
      return data.components;
    });
  }
  getActiveSplits() {
    return this.bundle.activeSplits;
  }
  getChunksUrl(bundle, modules) {
    return this.fetcher.getChunksUrl(bundle, modules);
  }
  fetchMissingData(opts) {
    return __async(this, null, function* () {
      this.maybeReportClientSideFetch(
        () => `Plasmic: fetching missing components in the browser: ${opts.missingSpecs.map((spec) => getLookupSpecName(spec)).join(", ")}`
      );
      return this.fetchAllData();
    });
  }
  maybeReportClientSideFetch(mkMsg) {
    if (index_esm_isBrowser && this.opts.onClientSideFetch) {
      const msg = mkMsg();
      if (this.opts.onClientSideFetch === "warn") {
        console.warn(msg);
      } else {
        throw new Error(msg);
      }
    }
  }
  fetchAllData() {
    return __async(this, null, function* () {
      var _a;
      const bundle = yield this.fetcher.fetchAllData();
      this.tracker.trackFetch();
      this.mergeBundle(bundle);
      (_a = this.onBundleFetched) == null ? void 0 : _a.call(this);
      return bundle;
    });
  }
  mergeBundle(newBundle) {
    var _a, _b;
    newBundle.bundleKey = (_a = newBundle.bundleKey) != null ? _a : null;
    if (newBundle.bundleKey && this.bundle.bundleKey && newBundle.bundleKey !== this.bundle.bundleKey) {
      console.warn(
        `Plasmic Error: Different code export hashes. This can happen if your app is using different loaders with different project IDs or project versions.
Conflicting values:
${newBundle.bundleKey}
${this.bundle.bundleKey}`
      );
    }
    this.bundle = mergeBundles(newBundle, this.bundle);
    (_b = this.onBundleMerged) == null ? void 0 : _b.call(this);
  }
  getBundle() {
    return this.bundle;
  }
  clearCache() {
    this.bundle = {
      modules: {
        browser: [],
        server: []
      },
      components: [],
      globalGroups: [],
      projects: [],
      activeSplits: [],
      bundleKey: null,
      deferChunksByDefault: false,
      disableRootLoadingBoundaryByDefault: false,
      filteredIds: {}
    };
    this.registry.clear();
  }
  registerModules(modules) {
    if (Object.keys(modules).some(
      (name) => this.registry.getRegisteredModule(name) !== modules[name]
    )) {
      if (!this.registry.isEmpty()) {
        console.warn(
          "Calling PlasmicComponentLoader.registerModules() after Plasmic component has rendered; starting over."
        );
        this.registry.clear();
      }
      for (const key of Object.keys(modules)) {
        this.registry.register(key, modules[key]);
      }
    }
  }
  substituteComponent(component, name) {
    this.internalSubstituteComponent(component, name, void 0);
  }
  internalSubstituteComponent(component, name, codeComponentHelpers) {
    if (!this.isRegistryEmpty()) {
      console.warn(
        "Calling PlasmicComponentLoader.registerSubstitution() after Plasmic component has rendered; starting over."
      );
      this.clearRegistry();
    }
    this.subs.push({ lookup: name, component, codeComponentHelpers });
  }
  refreshRegistry() {
    for (const sub of this.subs) {
      const metas = getCompMetas(this.getBundle().components, sub.lookup);
      metas.forEach((meta) => {
        SUBSTITUTED_COMPONENTS[meta.id] = sub.component;
        if (sub.codeComponentHelpers) {
          REGISTERED_CODE_COMPONENT_HELPERS[meta.id] = sub.codeComponentHelpers;
        }
      });
    }
    this.registry.updateModules(this.getBundle());
  }
  isRegistryEmpty() {
    return this.registry.isEmpty();
  }
  clearRegistry() {
    this.registry.clear();
  }
  setGlobalVariants(globalVariants) {
    this.globalVariants = globalVariants;
  }
  getGlobalVariants() {
    return this.globalVariants;
  }
  registerPrefetchedBundle(bundle) {
    if (!index_esm_isBrowser) {
      const cachedBundle = (0,loader_fetcher_dist_index_esm/* internal_getCachedBundleInNodeServer */.Mq)(this.opts);
      if (cachedBundle) {
        this.mergeBundle(cachedBundle);
      }
    }
    this.mergeBundle(bundle);
  }
  getLookup() {
    return new ComponentLookup(this.getBundle(), this.registry);
  }
  trackConversion(value = 0) {
    this.tracker.trackConversion(value);
  }
  getActiveVariation(opts) {
    return __async(this, null, function* () {
      yield this.fetchComponents();
      return getActiveVariation(__spreadProps(index_esm_spreadValues({}, opts), {
        splits: this.getBundle().activeSplits
      }));
    });
  }
  getTeamIds() {
    return uniq(
      this.getBundle().projects.map(
        (p) => p.teamId ? `${p.teamId}${p.indirect ? "@indirect" : ""}` : null
      ).filter((x) => !!x)
    );
  }
  getProjectIds() {
    return uniq(
      this.getBundle().projects.map(
        (p) => `${p.id}${p.indirect ? "@indirect" : ""}`
      )
    );
  }
  trackRender(opts) {
    this.tracker.trackRender(opts);
  }
  loadServerQueriesModule(fileName) {
    return this.registry.load(fileName);
  }
};
var PlasmicComponentLoader = class {
  constructor(internal) {
    this.warnedRegisterComponent = false;
    this.__internal = internal;
  }
  /**
   * Sets global variants to be used for all components.  Note that
   * this is not reactive, and will not re-render all components
   * already mounted; instead, it should be used to activate global
   * variants that should always be activated for the lifetime of this
   * app.  If you'd like to reactively change the global variants,
   * you should specify them via <PlasmicRootProvider />
   */
  setGlobalVariants(globalVariants) {
    this.__internal.setGlobalVariants(globalVariants);
  }
  registerModules(modules) {
    this.__internal.registerModules(modules);
  }
  /**
   * Register custom components that should be swapped in for
   * components defined in your project.  You can use this to
   * swap in / substitute a Plasmic component with a "real" component.
   */
  substituteComponent(component, name) {
    this.__internal.substituteComponent(component, name);
  }
  registerComponent(component, metaOrName) {
    if (metaOrName && typeof metaOrName === "object" && "props" in metaOrName) {
      this.__internal.registerComponent(component, metaOrName);
    } else {
      if (false) {}
      this.substituteComponent(component, metaOrName);
    }
  }
  registerFunction(fn, meta) {
    this.__internal.registerFunction(fn, meta);
  }
  registerGlobalContext(context, meta) {
    this.__internal.registerGlobalContext(context, meta);
  }
  registerTrait(trait, meta) {
    this.__internal.registerTrait(trait, meta);
  }
  registerToken(token) {
    this.__internal.registerToken(token);
  }
  fetchComponentData(...args) {
    return this.__internal.fetchComponentData(...args);
  }
  maybeFetchComponentData(...args) {
    return __async(this, null, function* () {
      return this.__internal.maybeFetchComponentData(...args);
    });
  }
  /**
   * Returns all the page component metadata for these projects.
   */
  fetchPages(opts) {
    return __async(this, null, function* () {
      return this.__internal.fetchPages(opts);
    });
  }
  /**
   * Returns all components metadata for these projects.
   */
  fetchComponents() {
    return __async(this, null, function* () {
      return this.__internal.fetchComponents();
    });
  }
  _getActiveVariation(opts) {
    return __async(this, null, function* () {
      return this.__internal.getActiveVariation(opts);
    });
  }
  getActiveVariation(opts) {
    return __async(this, null, function* () {
      return this._getActiveVariation({
        traits: opts.traits,
        getKnownValue: (key) => {
          if (opts.known) {
            return opts.known[key];
          } else {
            const cookies = getPlasmicCookieValues();
            return cookies[key];
          }
        },
        updateKnownValue: (key, value) => {
          if (!opts.known) {
            updatePlasmicCookieValue(key, value);
          }
        }
      });
    });
  }
  getChunksUrl(bundle, modules) {
    return this.__internal.getChunksUrl(bundle, modules);
  }
  getExternalVariation(variation, filters) {
    return getExternalIds(this.getActiveSplits(), variation, filters);
  }
  getActiveSplits() {
    return this.__internal.getActiveSplits();
  }
  trackConversion(value = 0) {
    this.__internal.trackConversion(value);
  }
  clearCache() {
    return this.__internal.clearCache();
  }
  unstable__getServerQueriesData(renderData, $ctx) {
    return __async(this, null, function* () {
      if (renderData.entryCompMetas.length === 0) {
        return {};
      }
      const fileName = renderData.entryCompMetas[0].serverQueriesExecFuncFileName;
      if (!fileName) {
        return {};
      }
      const module = this.__internal.loadServerQueriesModule(fileName);
      const { executeServerQueries } = module;
      try {
        const $serverQueries = yield executeServerQueries($ctx);
        return $serverQueries;
      } catch (err) {
        console.error("Error executing server queries function", err);
        return {};
      }
    });
  }
};

// src/loader-client.ts
var InternalPlasmicComponentLoader = class extends BaseInternalPlasmicComponentLoader {
  constructor(opts) {
    const tracker = new dist_index_esm/* PlasmicTracker */.fl(__spreadProps(index_esm_spreadValues({}, opts), {
      projectIds: opts.projects.map((p) => p.id)
    }));
    super({
      opts,
      tracker,
      fetcher: new dist_index_esm/* PlasmicModulesFetcher */.Gv(opts),
      onBundleMerged: () => {
        this.refreshRegistry();
      },
      onBundleFetched: () => {
        this.roots.forEach((watcher) => {
          var _a;
          return (_a = watcher.onDataFetched) == null ? void 0 : _a.call(watcher);
        });
      },
      builtinModules: {
        react: react,
        "react-dom": react_dom,
        "react/jsx-runtime": jsx_runtime_namespaceObject,
        "react/jsx-dev-runtime": jsx_dev_runtime_namespaceObject,
        // Also inject @plasmicapp/query and @plasmicapp/host to use the
        // same contexts here and in loader-downloaded code.
        "@plasmicapp/query": index_esm,
        "@plasmicapp/data-sources-context": index_esm_namespaceObject,
        "@plasmicapp/host": host_esm_namespaceObject,
        "@plasmicapp/host/registerFunction": internalSetRegisteredFunction,
        "@plasmicapp/loader-runtime-registry": {
          components: SUBSTITUTED_COMPONENTS,
          globalVariantHooks: SUBSTITUTED_GLOBAL_VARIANT_HOOKS,
          codeComponentHelpers: REGISTERED_CODE_COMPONENT_HELPERS,
          functions: REGISTERED_CUSTOM_FUNCTIONS
        }
      }
    });
    this.roots = [];
  }
  registerComponent(component, meta) {
    var _a, _b;
    const stateHelpers = Object.fromEntries(
      Object.entries((_a = meta.states) != null ? _a : {}).filter(
        ([_, stateSpec]) => Object.keys(stateSpec).some((key) => stateHelpersKeys.includes(key))
      ).map(([stateName, stateSpec]) => [
        stateName,
        Object.fromEntries(
          stateHelpersKeys.filter((key) => key in stateSpec).map((key) => [key, stateSpec[key]])
        )
      ])
    );
    const helpers = { states: stateHelpers };
    this.internalSubstituteComponent(
      component,
      { name: meta.name, isCode: true },
      Object.keys(stateHelpers).length > 0 ? helpers : void 0
    );
    registerComponent(component, index_esm_spreadValues(__spreadProps(index_esm_spreadValues({}, meta), {
      // Import path is not used as we will use component substitution
      importPath: (_b = meta.importPath) != null ? _b : ""
    }), Object.keys(stateHelpers).length > 0 ? {
      componentHelpers: {
        helpers,
        importPath: "",
        importName: ""
      }
    } : {}));
  }
  registerFunction(fn, meta) {
    var _a;
    registerFunction(fn, __spreadProps(index_esm_spreadValues({}, meta), {
      importPath: (_a = meta.importPath) != null ? _a : ""
    }));
    internalSetRegisteredFunction(fn, meta);
  }
  registerGlobalContext(context, meta) {
    var _a;
    this.substituteComponent(context, { name: meta.name, isCode: true });
    registerGlobalContext(context, __spreadProps(index_esm_spreadValues({}, meta), {
      importPath: (_a = meta.importPath) != null ? _a : ""
    }));
  }
  registerTrait(trait, meta) {
    registerTrait(trait, meta);
  }
  registerToken(token) {
    registerToken(token);
  }
  subscribePlasmicRoot(watcher) {
    this.roots.push(watcher);
  }
  unsubscribePlasmicRoot(watcher) {
    const index = this.roots.indexOf(watcher);
    if (index >= 0) {
      this.roots.splice(index, 1);
    }
  }
  refreshRegistry() {
    for (const globalGroup of this.getBundle().globalGroups) {
      if (globalGroup.type !== "global-screen") {
        SUBSTITUTED_GLOBAL_VARIANT_HOOKS[globalGroup.id] = createUseGlobalVariant(globalGroup.name, globalGroup.projectId);
      }
    }
    super.refreshRegistry();
  }
};

// src/index.ts



// src/PlasmicComponent.tsx


// src/usePlasmicComponent.tsx

function usePlasmicComponent(spec, opts = {}) {
  const rootContext = usePlasmicRootContext();
  if (!rootContext) {
    throw new Error(
      `You can only use usePlasmicComponent if wrapped in <PlasmicRootProvider />`
    );
  }
  const loader = rootContext.loader;
  const lookup = loader.getLookup();
  const component = lookup.hasComponent(spec) ? lookup.getComponent(spec, opts) : void 0;
  const stableSpec = useStableLookupSpec(spec);
  const isMounted = useIsMounted();
  const forceUpdate = index_esm_useForceUpdate();
  react.useEffect(() => {
    if (!component) {
      (() => __async(this, null, function* () {
        yield loader.fetchComponentData(stableSpec);
        if (isMounted()) {
          forceUpdate();
        }
      }))();
    }
  }, [component, stableSpec]);
  return component;
}

// src/PlasmicComponent.tsx
var PlasmicComponentContext = react.createContext(false);
function PlasmicComponent(props) {
  const { component, projectId, componentProps, forceOriginal } = props;
  const rootContext = usePlasmicRootContext();
  const isRootLoader = !react.useContext(PlasmicComponentContext);
  if (!rootContext) {
    throw new Error(
      `You must use <PlasmicRootProvider/> at the root of your app`
    );
  }
  const _a = rootContext, {
    loader,
    globalContextsProps,
    variation,
    userAuthToken,
    isUserLoading,
    authRedirectUri,
    translator
  } = _a, rest = __objRest(_a, [
    "loader",
    "globalContextsProps",
    "variation",
    "userAuthToken",
    "isUserLoading",
    "authRedirectUri",
    "translator"
  ]);
  const Component = usePlasmicComponent(
    { name: component, projectId, isCode: false },
    { forceOriginal }
  );
  react.useEffect(() => {
    if (isRootLoader) {
      const meta = loader.getLookup().getComponentMeta({ name: component, projectId });
      if (meta) {
        loader.trackRender({
          renderCtx: {
            rootProjectId: meta.projectId,
            rootComponentId: meta.id,
            rootComponentName: component,
            teamIds: loader.getTeamIds(),
            projectIds: loader.getProjectIds()
          },
          variation
        });
      }
    }
  }, [component, projectId, loader, variation]);
  const element = react.useMemo(() => {
    var _a2;
    if (!Component) {
      return null;
    }
    let elt = /* @__PURE__ */ react.createElement(Component, index_esm_spreadValues({}, componentProps));
    if (isRootLoader) {
      const lookup = loader.getLookup();
      const ReactWebRootProvider = lookup.getRootProvider();
      const GlobalContextsProvider = lookup.getGlobalContextsProvider({
        name: component,
        projectId
      });
      elt = /* @__PURE__ */ react.createElement(
        ReactWebRootProvider,
        __spreadProps(index_esm_spreadValues({}, rest), {
          userAuthToken,
          isUserLoading,
          authRedirectUri,
          i18n: {
            translator,
            tagPrefix: (_a2 = loader.opts.i18n) == null ? void 0 : _a2.tagPrefix
          }
        }),
        /* @__PURE__ */ react.createElement(
          MaybeWrap,
          {
            cond: !!GlobalContextsProvider,
            wrapper: (children) => /* @__PURE__ */ react.createElement(GlobalContextsProvider, index_esm_spreadValues({}, globalContextsProps), children)
          },
          /* @__PURE__ */ react.createElement(PlasmicComponentContext.Provider, { value: true }, elt)
        )
      );
    }
    return elt;
  }, [
    Component,
    componentProps,
    loader,
    isRootLoader,
    component,
    projectId,
    globalContextsProps,
    userAuthToken,
    // Just use the token to memo, `user` should be derived from it
    isUserLoading,
    authRedirectUri
  ]);
  return element;
}

// src/prepass-client.ts

function extractPlasmicQueryData(element) {
  return (0,prepass_dist_index_esm/* extractPlasmicQueryData */.lL)(element);
}
function plasmicPrepass(element) {
  return internalPlasmicPrepass(element);
}

// src/render.tsx




function renderToElement(_0, _1, _2) {
  return __async(this, arguments, function* (loader, target, lookup, opts = {}) {
    return new Promise((resolve) => {
      const element = makeElement(loader, lookup, opts);
      ReactDOM2.render(element, target, () => resolve());
    });
  });
}
function renderToString(loader, lookup, opts = {}) {
  const element = makeElement(loader, lookup, opts);
  return reactRenderToString(element);
}
function extractPlasmicQueryDataFromElement(_0, _1) {
  return __async(this, arguments, function* (loader, lookup, opts = {}) {
    const element = makeElement(loader, lookup, opts);
    return extractPlasmicQueryData2(element);
  });
}
function hydrateFromElement(_0, _1, _2) {
  return __async(this, arguments, function* (loader, target, lookup, opts = {}) {
    return new Promise((resolve) => {
      const element = makeElement(loader, lookup, opts);
      ReactDOM2.hydrate(element, target, () => resolve());
    });
  });
}
function makeElement(loader, lookup, opts = {}) {
  return /* @__PURE__ */ React6.createElement(
    PlasmicRootProvider,
    {
      loader,
      prefetchedData: opts.prefetchedData,
      globalVariants: opts.globalVariants,
      prefetchedQueryData: opts.prefetchedQueryData,
      pageParams: opts.pageParams,
      pageQuery: opts.pageQuery
    },
    /* @__PURE__ */ React6.createElement(
      PlasmicComponent,
      {
        component: typeof lookup === "string" ? lookup : lookup.name,
        projectId: typeof lookup === "string" ? void 0 : lookup.projectId,
        componentProps: opts.componentProps
      }
    )
  );
}

// src/index.ts
function initPlasmicLoader(opts) {
  const internal = new InternalPlasmicComponentLoader(opts);
  return new PlasmicComponentLoader(internal);
}

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 4638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExtractPlasmicQueryData */
/* harmony import */ var _plasmicapp_prepass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9143);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
"use client";

// src/ExtractPlasmicQueryData.tsx


function ExtractPlasmicQueryData(props) {
  const { children } = props;
  if (!("useId" in React) || !("use" in React)) {
    throw new Error(
      `You can only use <ExtractPlasmicQueryData /> from server components.`
    );
  }
  const scriptId = `plasmic-prefetch-${React["useId"]()}`;
  if (typeof window === "undefined") {
    const {
      queryData,
      headMetadata
    } = React["use"](plasmicPrepassExtract(/* @__PURE__ */ React.createElement(React.Fragment, null, children)));
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "script",
      {
        type: "application/json",
        dangerouslySetInnerHTML: { __html: JSON.stringify(queryData) },
        "data-plasmic-prefetch-id": scriptId,
        suppressHydrationWarning: true
      }
    ), headMetadata && /* @__PURE__ */ React.createElement(
      "script",
      {
        type: "application/json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(headMetadata)
        },
        "data-plasmic-head-metadata-id": scriptId,
        suppressHydrationWarning: true
      }
    ));
  } else {
    return null;
  }
}

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 9143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lL": function() { return /* binding */ extractPlasmicQueryData; }
});

// UNUSED EXPORTS: plasmicPrepass, plasmicPrepassExtract

// EXTERNAL MODULE: ./node_modules/@plasmicapp/query/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(3273);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@plasmicapp/react-ssr-prepass/dist/react-ssr-prepass.es.js


function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }
    return n;
  }, _extends.apply(null, arguments);
}

var Element = 60103;

var TransitionalElement = 60103;

var Portal = 60106;

var Fragment = 60107;

var StrictMode = 60108;

var Profiler = 60114;

var ContextProvider = 60109;

var ContextConsumer = undefined;

var Context = 60110;

var ConcurrentMode = 60111;

var ForwardRef = 60112;

var Suspense = 60113;

var Memo = 60115;

var Lazy = 60116;

var ClientReferenceTag = undefined;

if (typeof Symbol === "function" && Symbol.for) {
  var symbolFor = Symbol.for;
  Element = symbolFor("react.element");
  TransitionalElement = symbolFor("react.transitional.element");
  Portal = symbolFor("react.portal");
  Fragment = symbolFor("react.fragment");
  StrictMode = symbolFor("react.strict_mode");
  Profiler = symbolFor("react.profiler");
  ContextProvider = symbolFor("react.provider");
  ContextConsumer = symbolFor("react.consumer");
  Context = symbolFor("react.context");
  ConcurrentMode = symbolFor("react.concurrent_mode");
  ForwardRef = symbolFor("react.forward_ref");
  Suspense = symbolFor("react.suspense");
  Memo = symbolFor("react.memo");
  Lazy = symbolFor("react.lazy");
  ClientReferenceTag = symbolFor("react.client.reference");
}

var REACT_ELEMENT_TYPE = Element;

var REACT_TRANSITIONAL_ELEMENT_TYPE = TransitionalElement;

var REACT_PORTAL_TYPE = Portal;

var REACT_FRAGMENT_TYPE = Fragment;

var REACT_STRICT_MODE_TYPE = StrictMode;

var REACT_PROFILER_TYPE = Profiler;

var REACT_PROVIDER_TYPE = ContextProvider;

var REACT_CONSUMER_TYPE = ContextConsumer;

var REACT_CONTEXT_TYPE = Context;

var REACT_CONCURRENT_MODE_TYPE = ConcurrentMode;

var REACT_FORWARD_REF_TYPE = ForwardRef;

var REACT_SUSPENSE_TYPE = Suspense;

var REACT_MEMO_TYPE = Memo;

var REACT_LAZY_TYPE = Lazy;

var CLIENT_REFERENCE_TAG = ClientReferenceTag;

function isClientReference(reference) {
  return reference.$$typeof === CLIENT_REFERENCE_TAG;
}

var getComponentName = function(type) {
  if (isClientReference(type)) {
    return undefined;
  }
  if (type.displayName) {
    return type.displayName;
  }
  if (shouldConstruct(type)) {
    return type.constructor.name;
  } else {
    return type.name;
  }
};

function isReact19() {
  return !react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
}

var shouldConstruct = function(Comp) {
  return Comp.prototype && Comp.prototype.isReactComponent;
};

var typeOf = function(x) {
  switch (x.$$typeof) {
   case REACT_PORTAL_TYPE:
    return REACT_PORTAL_TYPE;

   case REACT_ELEMENT_TYPE:
   case REACT_TRANSITIONAL_ELEMENT_TYPE:
    switch (x.type) {
     case REACT_CONCURRENT_MODE_TYPE:
      return REACT_CONCURRENT_MODE_TYPE;

     case REACT_FRAGMENT_TYPE:
      return REACT_FRAGMENT_TYPE;

     case REACT_PROFILER_TYPE:
      return REACT_PROFILER_TYPE;

     case REACT_STRICT_MODE_TYPE:
      return REACT_STRICT_MODE_TYPE;

     case REACT_SUSPENSE_TYPE:
      return REACT_SUSPENSE_TYPE;

     default:
      {
        switch (x.type && x.type.$$typeof) {
         case REACT_LAZY_TYPE:
          return REACT_LAZY_TYPE;

         case REACT_MEMO_TYPE:
          return REACT_MEMO_TYPE;

         case REACT_CONSUMER_TYPE:
          return REACT_CONSUMER_TYPE;

         case REACT_CONTEXT_TYPE:
          return isReact19() ? REACT_PROVIDER_TYPE : REACT_CONSUMER_TYPE;

         case REACT_PROVIDER_TYPE:
          return REACT_PROVIDER_TYPE;

         case REACT_FORWARD_REF_TYPE:
          return REACT_FORWARD_REF_TYPE;

         default:
          return REACT_ELEMENT_TYPE;
        }
      }
    }

   default:
    return undefined;
  }
};

var toArray = react.Children.toArray;

var isAbstractElement = function(node) {
  return node !== null && typeof node === "object";
};

var getChildrenArray = function(node) {
  return toArray(node).filter(isAbstractElement);
};

var computeProps = function(props, defaultProps) {
  return typeof defaultProps === "object" ? _extends({}, defaultProps, props) : props;
};

var currentContextStore = new Map;

var currentContextMap = {};

var prevContextMap = undefined;

var prevContextEntry = undefined;

var getCurrentContextMap = function() {
  return _extends({}, currentContextMap);
};

var getCurrentContextStore = function() {
  return new Map(currentContextStore);
};

var flushPrevContextMap = function() {
  var prev = prevContextMap;
  prevContextMap = undefined;
  return prev;
};

var flushPrevContextStore = function() {
  var prev = prevContextEntry;
  prevContextEntry = undefined;
  return prev;
};

var restoreContextMap = function(prev) {
  if (prev !== undefined) {
    _extends(currentContextMap, prev);
  }
};

var restoreContextStore = function(prev) {
  if (prev !== undefined) {
    currentContextStore.set(prev[0], prev[1]);
  }
};

var setCurrentContextMap = function(map) {
  prevContextMap = undefined;
  currentContextMap = map;
};

var setCurrentContextStore = function(store) {
  prevContextEntry = undefined;
  currentContextStore = store;
};

var assignContextMap = function(map) {
  prevContextMap = {};
  for (var name in map) {
    prevContextMap[name] = currentContextMap[name];
    currentContextMap[name] = map[name];
  }
};

var setContextValue = function(context, value) {
  prevContextEntry = [ context, currentContextStore.get(context) ];
  currentContextStore.set(context, value);
};

var readContextValue = function(context) {
  var value = currentContextStore.get(context);
  if (value !== undefined) {
    return value;
  }
  return context._currentValue;
};

var emptyContext = {};

var maskContext = function(type) {
  var contextType = type.contextType;
  var contextTypes = type.contextTypes;
  if (contextType) {
    return readContextValue(contextType);
  } else if (!contextTypes) {
    return emptyContext;
  }
  var maskedContext = {};
  for (var name in contextTypes) {
    maskedContext[name] = currentContextMap[name];
  }
  return maskedContext;
};

var currentErrorFrame = null;

var getCurrentErrorFrame = function() {
  return currentErrorFrame;
};

var setCurrentErrorFrame = function(frame) {
  currentErrorFrame = frame || null;
};

var rendererStateRef = {
  current: {
    uniqueID: 0
  }
};

var initRendererState = function() {
  return rendererStateRef.current = {
    uniqueID: 0
  };
};

var setCurrentRendererState = function(state) {
  return rendererStateRef.current = state;
};

function is(x, y) {
  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
}

var objectIs = typeof Object.is === "function" ? Object.is : is;

var is$1 = objectIs;

var currentIdentity = null;

var makeIdentity = function() {
  return {};
};

var setCurrentIdentity = function(id) {
  currentIdentity = id;
};

var getCurrentIdentity = function() {
  if (currentIdentity === null) {
    throw new Error("[react-ssr-prepass] Hooks can only be called inside the body of a function component. " + "(https://fb.me/react-invalid-hook-call)");
  }
  return currentIdentity;
};

var firstWorkInProgressHook = null;

var workInProgressHook = null;

var didScheduleRenderPhaseUpdate = false;

var renderPhaseUpdates = null;

var numberOfReRenders = 0;

var RE_RENDER_LIMIT$1 = 25;

var getFirstHook = function() {
  return firstWorkInProgressHook;
};

var setFirstHook = function(hook) {
  firstWorkInProgressHook = hook;
};

function areHookInputsEqual(nextDeps, prevDeps) {
  if (prevDeps === null) {
    return false;
  }
  for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
    if (!is$1(nextDeps[i], prevDeps[i])) {
      return false;
    }
  }
  return true;
}

function createHook() {
  return {
    memoizedState: null,
    queue: null,
    next: null
  };
}

function createWorkInProgressHook() {
  if (workInProgressHook === null) {
    if (firstWorkInProgressHook === null) {
      return firstWorkInProgressHook = workInProgressHook = createHook();
    } else {
      return workInProgressHook = firstWorkInProgressHook;
    }
  } else {
    if (workInProgressHook.next === null) {
      return workInProgressHook = workInProgressHook.next = createHook();
    } else {
      return workInProgressHook = workInProgressHook.next;
    }
  }
}

function renderWithHooks(Component, props, refOrContext) {
  workInProgressHook = null;
  var children = Component(props, refOrContext);
  while (numberOfReRenders < RE_RENDER_LIMIT$1 && didScheduleRenderPhaseUpdate) {
    didScheduleRenderPhaseUpdate = false;
    numberOfReRenders += 1;
    workInProgressHook = null;
    children = Component(props, refOrContext);
  }
  numberOfReRenders = 0;
  renderPhaseUpdates = null;
  workInProgressHook = null;
  return children;
}

function readContext(context, _) {
  return readContextValue(context);
}

function useContext(context, _) {
  getCurrentIdentity();
  return readContextValue(context);
}

function basicStateReducer(state, action) {
  return typeof action === "function" ? action(state) : action;
}

function useState(initialState) {
  return useReducer(basicStateReducer, initialState);
}

function useReducer(reducer, initialArg, init) {
  var id = getCurrentIdentity();
  workInProgressHook = createWorkInProgressHook();
  if (workInProgressHook.queue === null) {
    var initialState;
    if (reducer === basicStateReducer) {
      initialState = typeof initialArg === "function" ? initialArg() : initialArg;
    } else {
      initialState = init !== undefined ? init(initialArg) : initialArg;
    }
    workInProgressHook.memoizedState = initialState;
  }
  var queue = workInProgressHook.queue || (workInProgressHook.queue = {
    last: null,
    dispatch: null
  });
  var dispatch = queue.dispatch || (queue.dispatch = dispatchAction.bind(null, id, queue));
  if (renderPhaseUpdates !== null) {
    var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
    if (firstRenderPhaseUpdate !== undefined) {
      renderPhaseUpdates.delete(queue);
      var newState = workInProgressHook.memoizedState;
      var update = firstRenderPhaseUpdate;
      do {
        var action = update.action;
        newState = reducer(newState, action);
        update = update.next;
      } while (update !== null);
      workInProgressHook.memoizedState = newState;
    }
  }
  return [ workInProgressHook.memoizedState, dispatch ];
}

function useMemo(nextCreate, deps) {
  getCurrentIdentity();
  workInProgressHook = createWorkInProgressHook();
  var nextDeps = deps === undefined ? null : deps;
  var prevState = workInProgressHook.memoizedState;
  if (prevState !== null && nextDeps !== null) {
    var prevDeps = prevState[1];
    if (areHookInputsEqual(nextDeps, prevDeps)) {
      return prevState[0];
    }
  }
  var nextValue = nextCreate();
  workInProgressHook.memoizedState = [ nextValue, nextDeps ];
  return nextValue;
}

function useRef(initialValue) {
  getCurrentIdentity();
  workInProgressHook = createWorkInProgressHook();
  var previousRef = workInProgressHook.memoizedState;
  if (previousRef === null) {
    var ref = {
      current: initialValue
    };
    workInProgressHook.memoizedState = ref;
    return ref;
  } else {
    return previousRef;
  }
}

function useOpaqueIdentifier() {
  getCurrentIdentity();
  workInProgressHook = createWorkInProgressHook();
  if (!workInProgressHook.memoizedState) {
    workInProgressHook.memoizedState = "R:" + (rendererStateRef.current.uniqueID++).toString(36);
  }
  return workInProgressHook.memoizedState;
}

function dispatchAction(componentIdentity, queue, action) {
  if (componentIdentity === currentIdentity) {
    didScheduleRenderPhaseUpdate = true;
    var update = {
      action: action,
      next: null
    };
    if (renderPhaseUpdates === null) {
      renderPhaseUpdates = new Map;
    }
    var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
    if (firstRenderPhaseUpdate === undefined) {
      renderPhaseUpdates.set(queue, update);
    } else {
      var lastRenderPhaseUpdate = firstRenderPhaseUpdate;
      while (lastRenderPhaseUpdate.next !== null) {
        lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
      }
      lastRenderPhaseUpdate.next = update;
    }
  }
}

function useCallback(callback, deps) {
  return useMemo((function() {
    return callback;
  }), deps);
}

function useMutableSource(source, getSnapshot, _subscribe) {
  getCurrentIdentity();
  return getSnapshot(source._source);
}

function noop() {}

function _ref$3(callback) {
  callback();
}

function useTransition() {
  var startTransition = _ref$3;
  return [ startTransition, false ];
}

function useDeferredValue(input) {
  return input;
}

function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
  return getSnapshot();
}

var Dispatcher = {
  readContext: readContext,
  useSyncExternalStore: useSyncExternalStore,
  useContext: useContext,
  useMemo: useMemo,
  useReducer: useReducer,
  useRef: useRef,
  useState: useState,
  useCallback: useCallback,
  useMutableSource: useMutableSource,
  useTransition: useTransition,
  useDeferredValue: useDeferredValue,
  useOpaqueIdentifier: useOpaqueIdentifier,
  useId: useOpaqueIdentifier,
  unstable_useId: useOpaqueIdentifier,
  unstable_useOpaqueIdentifier: useOpaqueIdentifier,
  useLayoutEffect: noop,
  useImperativeHandle: noop,
  useEffect: noop,
  useDebugValue: noop,
  useInsertionEffect: noop,
  isPlasmicPrepass: true
};

var resolve = function(type) {
  var payload = type._payload || type;
  if (payload._status === 0) {
    return payload._result;
  } else if (payload._status === 1) {
    return Promise.resolve(payload._result);
  } else if (payload._status === 2) {
    return Promise.reject(payload._result);
  }
  payload._status = 0;
  return payload._result = (payload._ctor || payload._result)().then((function(Component) {
    payload._result = Component;
    if (typeof Component === "function") {
      payload._status = 1;
    } else if (Component !== null && typeof Component === "object" && typeof Component.default === "function") {
      payload._result = Component.default;
      payload._status = 1;
    } else {
      payload._status = 2;
    }
  })).catch((function(error) {
    payload._status = 2;
    payload._result = error;
    return Promise.reject(error);
  }));
};

var makeFrame$2 = function(type, props, thenable) {
  return {
    kind: "frame.lazy",
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    errorFrame: getCurrentErrorFrame(),
    thenable: thenable,
    props: props,
    type: type
  };
};

var render$4 = function(type, props, queue) {
  var payload = type._payload || type;
  if (payload._status === 1 && payload._result) {
    return (0,react.createElement)(payload._result, props);
  }
  try {
    return (0,react.createElement)(type._init(type._payload), props);
  } catch (err) {
    if (!!err && typeof err.then === "function") {
      queue.push(makeFrame$2(type, props, err));
    }
    return null;
  }
};

var mount$3 = function(type, props, queue) {
  var payload = type._payload || type;
  if (payload._status != null && payload._status <= 0) {
    queue.push(makeFrame$2(type, props, resolve(type)));
    return null;
  }
  return render$4(type, props, queue);
};

var update$4 = function(queue, frame) {
  setCurrentIdentity(null);
  setCurrentContextMap(frame.contextMap);
  setCurrentContextStore(frame.contextStore);
  setCurrentErrorFrame(frame.errorFrame);
  return render$4(frame.type, frame.props, queue);
};

var makeFrame$1 = function(type, props, thenable) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    id: getCurrentIdentity(),
    hook: getFirstHook(),
    kind: "frame.hooks",
    errorFrame: getCurrentErrorFrame(),
    thenable: thenable,
    props: props,
    type: type
  };
};

var render$3 = function(type, props, queue) {
  try {
    return renderWithHooks(type, computeProps(props, type.defaultProps), maskContext(type));
  } catch (error) {
    if (typeof error.then !== "function") {
      console.warn("PLASMIC: Encountered error when pre-rendering " + getComponentName(type) + ": " + error);
      return null;
    }
    queue.push(makeFrame$1(type, props, error));
    return null;
  }
};

var mount$2 = function(type, props, queue, visitor, element) {
  setFirstHook(null);
  setCurrentIdentity(makeIdentity());
  var promise = visitor(element);
  if (promise) {
    queue.push(makeFrame$1(type, props, promise));
    return null;
  }
  return render$3(type, props, queue);
};

var update$3 = function(queue, frame) {
  setFirstHook(frame.hook);
  setCurrentIdentity(frame.id);
  setCurrentContextMap(frame.contextMap);
  setCurrentContextStore(frame.contextStore);
  setCurrentErrorFrame(frame.errorFrame);
  return render$3(frame.type, frame.props, queue);
};

var RE_RENDER_LIMIT = 25;

function _ref$2() {
  return false;
}

function _ref2$1() {
  return null;
}

var createUpdater = function() {
  var queue = [];
  return {
    _thrown: 0,
    queue: queue,
    isMounted: _ref$2,
    enqueueForceUpdate: _ref2$1,
    enqueueReplaceState: function(instance, completeState) {
      if (instance._isMounted) {
        queue.length = 0;
        queue.push(completeState);
      }
    },
    enqueueSetState: function(instance, currentPartialState) {
      if (instance._isMounted) {
        queue.push(currentPartialState);
      }
    }
  };
};

var flushEnqueuedState = function(instance) {
  var queue = instance.updater.queue;
  if (queue.length > 0) {
    var nextState = _extends({}, instance.state);
    for (var i = 0, l = queue.length; i < l; i++) {
      var partial = queue[i];
      var partialState = typeof partial === "function" ? partial.call(instance, nextState, instance.props, instance.context) : partial;
      if (partialState !== null) {
        _extends(nextState, partialState);
      }
    }
    instance.state = nextState;
    queue.length = 0;
  }
};

var createInstance = function(type, props) {
  var updater = createUpdater();
  var computedProps = computeProps(props, type.defaultProps);
  var context = maskContext(type);
  var instance = new type(computedProps, context, updater);
  instance.props = computedProps;
  instance.context = context;
  instance.updater = updater;
  instance._isMounted = true;
  if (instance.state === undefined) {
    instance.state = null;
  }
  if (typeof instance.componentDidCatch === "function" || typeof type.getDerivedStateFromError === "function") {
    var frame = makeFrame(type, instance, null);
    frame.errorFrame = frame;
    setCurrentErrorFrame(frame);
  }
  if (typeof type.getDerivedStateFromProps === "function") {
    var getDerivedStateFromProps = type.getDerivedStateFromProps;
    var state = getDerivedStateFromProps(instance.props, instance.state);
    if (state !== null && state !== undefined) {
      instance.state = _extends({}, instance.state, state);
    }
  } else if (typeof instance.componentWillMount === "function") {
    instance.componentWillMount();
  } else if (typeof instance.UNSAFE_componentWillMount === "function") {
    instance.UNSAFE_componentWillMount();
  }
  return instance;
};

var makeFrame = function(type, instance, thenable) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    errorFrame: getCurrentErrorFrame(),
    thenable: thenable,
    kind: "frame.class",
    error: null,
    instance: instance,
    type: type
  };
};

var render$2 = function(type, instance, queue) {
  flushEnqueuedState(instance);
  var child = null;
  try {
    child = instance.render();
  } catch (error) {
    if (typeof error.then !== "function") {
      console.warn("PLASMIC: Encountered error when pre-rendering component " + getComponentName(type) + ". This is fine as long as you are not fetching data with @plasmicapp/query inside this component.  Error: " + error);
      return null;
    }
    queue.push(makeFrame(type, instance, error));
    return null;
  }
  if (type.childContextTypes !== undefined && typeof instance.getChildContext === "function") {
    var childContext = instance.getChildContext();
    if (childContext !== null && typeof childContext === "object") {
      assignContextMap(childContext);
    }
  }
  if (typeof instance.getDerivedStateFromProps !== "function" && (typeof instance.componentWillMount === "function" || typeof instance.UNSAFE_componentWillMount === "function") && typeof instance.componentWillUnmount === "function") {
    try {
      instance.componentWillUnmount();
    } catch (_err) {}
  }
  instance._isMounted = false;
  return child;
};

var mount$1 = function(type, props, queue, visitor, element) {
  setCurrentIdentity(null);
  var instance = createInstance(type, props);
  var promise = visitor(element, instance);
  if (promise) {
    queue.push(makeFrame(type, instance, promise));
    return null;
  }
  return render$2(type, instance, queue);
};

var update$2 = function(queue, frame) {
  setCurrentIdentity(null);
  setCurrentContextMap(frame.contextMap);
  setCurrentContextStore(frame.contextStore);
  setCurrentErrorFrame(frame.errorFrame);
  if (frame.error) {
    if (++frame.instance.updater._thrown >= RE_RENDER_LIMIT) {
      return null;
    }
    frame.instance._isMounted = true;
    if (typeof frame.instance.componentDidCatch === "function") {
      frame.instance.componentDidCatch(frame.error);
    }
    if (typeof frame.type.getDerivedStateFromError === "function") {
      frame.instance.updater.enqueueSetState(frame.instance, frame.type.getDerivedStateFromError(frame.error));
    }
  }
  return render$2(frame.type, frame.instance, queue);
};

function _ref$1(elt) {
  return elt && typeof elt === "object" && typeOf(elt);
}

var render$1 = function(type, props, queue, clientRefVisitor, element) {
  try {
    var node = clientRefVisitor(element);
    return (0,react.createElement)(react.Fragment, {}, [].concat(node ? getChildrenArray(node) : Object.values(props).flat(Infinity).filter(_ref$1)));
  } catch (error) {
    if (typeof error.then !== "function") {
      console.warn("PLASMIC: Encountered error when pre-rendering client reference: " + error);
      return null;
    }
    queue.push({
      contextMap: getCurrentContextMap(),
      contextStore: getCurrentContextStore(),
      errorFrame: getCurrentErrorFrame(),
      id: getCurrentIdentity(),
      hook: getFirstHook(),
      thenable: error,
      kind: "client-ref",
      type: type,
      props: props,
      element: element,
      clientRefVisitor: clientRefVisitor
    });
    return null;
  }
};

var mount = function(type, props, queue, clientRefVisitor, element) {
  setFirstHook(null);
  setCurrentIdentity(makeIdentity());
  return render$1(type, props, queue, clientRefVisitor, element);
};

var update$1 = function(queue, frame) {
  setFirstHook(frame.hook);
  setCurrentIdentity(frame.id);
  setCurrentContextMap(frame.contextMap);
  setCurrentContextStore(frame.contextStore);
  setCurrentErrorFrame(frame.errorFrame);
  return render$1(frame.type, frame.props, queue, frame.clientRefVisitor, frame.element);
};

var REACT_INTERNALS = react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED || react.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE || react.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;

var ReactCurrentDispatcher = REACT_INTERNALS.ReactCurrentDispatcher || REACT_INTERNALS;

var getReactCurrentDispatcher = function() {
  return ReactCurrentDispatcher.current || ReactCurrentDispatcher.H;
};

var injectReactCurrentDispatcher = function(newDispatcher) {
  if (!isReact19()) {
    ReactCurrentDispatcher.current = newDispatcher;
  } else {
    ReactCurrentDispatcher.H = newDispatcher;
  }
};

var SHOULD_YIELD = typeof setImmediate === "function";

var YIELD_AFTER_MS = 5;

var render = function(type, props, queue, visitor, clientRefVisitor, element) {
  if (isClientReference(type)) {
    return mount(type, props, queue, clientRefVisitor, element);
  }
  return shouldConstruct(type) ? mount$1(type, props, queue, visitor, element) : mount$2(type, props, queue, visitor, element);
};

var visitElement = function(element, queue, visitor, clientRefVisitor) {
  switch (typeOf(element)) {
   case REACT_SUSPENSE_TYPE:
   case REACT_STRICT_MODE_TYPE:
   case REACT_CONCURRENT_MODE_TYPE:
   case REACT_PROFILER_TYPE:
   case REACT_FRAGMENT_TYPE:
    {
      var fragmentElement = element;
      return getChildrenArray(fragmentElement.props.children);
    }

   case REACT_PROVIDER_TYPE:
    {
      var providerElement = element;
      var ref = providerElement.props;
      var value = ref.value;
      var children = ref.children;
      var type = providerElement.type;
      var context = typeof type._context === "object" ? type._context : type;
      setContextValue(context, value);
      return getChildrenArray(children);
    }

   case REACT_CONSUMER_TYPE:
    {
      var consumerElement = element;
      var ref$1 = consumerElement.props;
      var children$1 = ref$1.children;
      if (typeof children$1 === "function") {
        var type$1 = consumerElement.type;
        var context$1 = typeof type$1._context === "object" ? type$1._context : type$1;
        var value$1 = readContextValue(context$1);
        return getChildrenArray(children$1(value$1));
      } else {
        return [];
      }
    }

   case REACT_LAZY_TYPE:
    {
      var lazyElement = element;
      var type$2 = lazyElement.type;
      var child = mount$3(type$2, lazyElement.props, queue);
      return getChildrenArray(child);
    }

   case REACT_MEMO_TYPE:
    {
      var memoElement = element;
      var ref$2 = memoElement.type;
      var type$3 = ref$2.type;
      var child$1 = (0,react.createElement)(type$3, memoElement.props);
      return getChildrenArray(child$1);
    }

   case REACT_FORWARD_REF_TYPE:
    {
      var refElement = element;
      var ref$3 = refElement.type;
      var type$4 = ref$3.render;
      var defaultProps = ref$3.defaultProps;
      var props = computeProps(refElement.props, defaultProps);
      var child$2 = (0,react.createElement)(type$4, props);
      return getChildrenArray(child$2);
    }

   case REACT_ELEMENT_TYPE:
    {
      var el = element;
      if (typeof el.type === "string") {
        return getChildrenArray(el.props.children);
      } else {
        var userElement = element;
        var type$5 = userElement.type;
        var props$1 = userElement.props;
        var child$3 = render(type$5, props$1, queue, visitor, clientRefVisitor, userElement);
        return getChildrenArray(child$3);
      }
    }

   case REACT_PORTAL_TYPE:
   default:
    return [];
  }
};

var visitLoop = function(traversalChildren, traversalMap, traversalStore, traversalErrorFrame, queue, visitor, clientRefVisitor) {
  var prevDispatcher = getReactCurrentDispatcher();
  var start = Date.now();
  try {
    injectReactCurrentDispatcher(Dispatcher);
    while (traversalChildren.length > 0) {
      var element = traversalChildren[traversalChildren.length - 1].shift();
      if (element !== undefined) {
        var children = visitElement(element, queue, visitor, clientRefVisitor);
        traversalChildren.push(children);
        traversalMap.push(flushPrevContextMap());
        traversalStore.push(flushPrevContextStore());
        traversalErrorFrame.push(getCurrentErrorFrame());
      } else {
        traversalChildren.pop();
        restoreContextMap(traversalMap.pop());
        restoreContextStore(traversalStore.pop());
        setCurrentErrorFrame(traversalErrorFrame.pop());
      }
      if (SHOULD_YIELD && Date.now() - start > YIELD_AFTER_MS) {
        return true;
      }
    }
    return false;
  } catch (error) {
    var errorFrame = getCurrentErrorFrame();
    if (!errorFrame) {
      throw error;
    }
    errorFrame.error = error;
    queue.unshift(errorFrame);
    return false;
  } finally {
    injectReactCurrentDispatcher(prevDispatcher);
  }
};

var makeYieldFrame = function(traversalChildren, traversalMap, traversalStore, traversalErrorFrame) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    errorFrame: getCurrentErrorFrame(),
    thenable: null,
    kind: "frame.yield",
    traversalChildren: traversalChildren,
    traversalMap: traversalMap,
    traversalStore: traversalStore,
    traversalErrorFrame: traversalErrorFrame
  };
};

var visit = function(init, queue, visitor, clientRefVisitor) {
  var traversalChildren = [ init ];
  var traversalMap = [ flushPrevContextMap() ];
  var traversalStore = [ flushPrevContextStore() ];
  var traversalErrorFrame = [ getCurrentErrorFrame() ];
  var hasYielded = visitLoop(traversalChildren, traversalMap, traversalStore, traversalErrorFrame, queue, visitor, clientRefVisitor);
  if (hasYielded) {
    queue.unshift(makeYieldFrame(traversalChildren, traversalMap, traversalStore, traversalErrorFrame));
  }
};

var update = function(frame, queue, visitor, clientRefVisitor) {
  if (frame.kind === "frame.yield") {
    setCurrentIdentity(null);
    setCurrentContextMap(frame.contextMap);
    setCurrentContextStore(frame.contextStore);
    setCurrentErrorFrame(frame.errorFrame);
    var hasYielded = visitLoop(frame.traversalChildren, frame.traversalMap, frame.traversalStore, frame.traversalErrorFrame, queue, visitor, clientRefVisitor);
    if (hasYielded) {
      queue.unshift(makeYieldFrame(frame.traversalChildren, frame.traversalMap, frame.traversalStore, frame.traversalErrorFrame));
    }
  } else {
    var prevDispatcher = getReactCurrentDispatcher();
    var children = null;
    injectReactCurrentDispatcher(Dispatcher);
    try {
      if (frame.kind === "frame.class") {
        children = update$2(queue, frame);
      } else if (frame.kind === "frame.hooks") {
        children = update$3(queue, frame);
      } else if (frame.kind === "frame.lazy") {
        children = update$4(queue, frame);
      } else if (frame.kind === "client-ref") {
        children = update$1(queue, frame);
      }
    } catch (error) {
      var errorFrame = getCurrentErrorFrame();
      if (!errorFrame) {
        throw error;
      }
      errorFrame.error = error;
      queue.unshift(errorFrame);
      children = null;
    } finally {
      injectReactCurrentDispatcher(prevDispatcher);
    }
    visit(getChildrenArray(children), queue, visitor, clientRefVisitor);
  }
};

function _ref(resolve, reject) {
  setImmediate(resolve);
}

var flushFrames = function(queue, visitor, clientRefVisitor, state) {
  var frame = queue.shift();
  if (!frame) {
    return Promise.resolve();
  }
  if (SHOULD_YIELD && frame.kind === "frame.yield") {
    frame.thenable = new Promise(_ref);
  }
  return Promise.resolve(frame.thenable).then((function() {
    setCurrentRendererState(state);
    update(frame, queue, visitor, clientRefVisitor);
    return flushFrames(queue, visitor, clientRefVisitor, state);
  }), (function(error) {
    if (!frame.errorFrame) {
      throw error;
    }
    frame.errorFrame.error = error;
    update(frame.errorFrame, queue, visitor, clientRefVisitor);
  }));
};

var defaultVisitor = function() {
  return undefined;
};

var runningPrepassCount = 0;

function _ref2() {
  runningPrepassCount--;
  if (!runningPrepassCount) {
    delete globalThis.__ssrPrepassEnv;
  }
}

var renderPrepass = function(element, visitor, clientRefVisitor) {
  if (!visitor) {
    visitor = defaultVisitor;
  }
  if (!clientRefVisitor) {
    clientRefVisitor = defaultVisitor;
  }
  var queue = [];
  var state = initRendererState();
  setCurrentContextMap({});
  setCurrentContextStore(new Map);
  setCurrentErrorFrame(null);
  try {
    runningPrepassCount++;
    globalThis.__ssrPrepassEnv = {
      readContextValue: readContextValue,
      setContextValue: setContextValue
    };
    visit(getChildrenArray(element), queue, visitor, clientRefVisitor);
  } catch (error) {
    runningPrepassCount--;
    if (!runningPrepassCount) {
      delete globalThis.__ssrPrepassEnv;
    }
    return Promise.reject(error);
  }
  return flushFrames(queue, visitor, clientRefVisitor, state).finally(_ref2);
};


//# sourceMappingURL=react-ssr-prepass.es.js.map

;// CONCATENATED MODULE: ./node_modules/@plasmicapp/prepass/dist/index.esm.js



async function plasmicPrepassExtract(element, onClientComponentRef) {
  const cache = /* @__PURE__ */ new Map();
  const headMetadata = {};
  try {
    await plasmicPrepass(
      /* @__PURE__ */ react.createElement(index_esm.PlasmicPrepassContext, { cache }, /* @__PURE__ */ react.createElement(index_esm.HeadMetadataContext.Provider, { value: headMetadata }, element)),
      onClientComponentRef
    );
  } catch (err) {
    console.warn(`PLASMIC: Error encountered while pre-rendering`, err);
  }
  const filteredCache = Object.fromEntries(
    Array.from(cache.entries()).filter(
      ([key, val]) => !key.startsWith("$swr$") && !key.startsWith("$csq$") && val !== void 0
    )
  );
  const queryData = (() => {
    try {
      return JSON.parse(
        JSON.stringify(
          filteredCache,
          (_key, value) => value !== void 0 ? value : null
        )
      );
    } catch {
      return filteredCache;
    }
  })();
  return {
    queryData,
    headMetadata
  };
}
async function extractPlasmicQueryData(element, onClientComponentRef) {
  return (await plasmicPrepassExtract(element, onClientComponentRef)).queryData;
}
async function plasmicPrepass(element, onClientComponentRef) {
  await renderPrepass(element, void 0, onClientComponentRef);
}



/***/ }),

/***/ 3273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HeadMetadataContext": function() { return /* binding */ HeadMetadataContext; },
  "PlasmicPrepassContext": function() { return /* binding */ PlasmicPrepassContext; },
  "PlasmicQueryDataProvider": function() { return /* binding */ PlasmicQueryDataProvider; },
  "addLoadingStateListener": function() { return /* binding */ addLoadingStateListener; },
  "isPlasmicPrepass": function() { return /* binding */ isPlasmicPrepass; },
  "useMutablePlasmicQueryData": function() { return /* binding */ useMutablePlasmicQueryData; },
  "usePlasmicDataConfig": function() { return /* binding */ usePlasmicDataConfig; },
  "usePlasmicQueryData": function() { return /* binding */ usePlasmicQueryData; },
  "useSWRConfig": function() { return /* reexport */ useSWRConfig; },
  "wrapLoadingFetcher": function() { return /* binding */ wrapLoadingFetcher; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/swr/dist/index.mjs


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var noop = function () { };
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = ( /*#__NOINLINE__*/noop());
var OBJECT = Object;
var isUndefined = function (v) { return v === UNDEFINED; };
var isFunction = function (v) { return typeof v == 'function'; };
var mergeObjects = function (a, b) { return OBJECT.assign({}, a, b); };
var STR_UNDEFINED = 'undefined';
// NOTE: Use function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var hasWindow = function () { return typeof window != STR_UNDEFINED; };
var hasDocument = function () { return typeof document != STR_UNDEFINED; };
var hasRequestAnimationFrame = function () {
    return hasWindow() && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var stableHash = function (arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result)
            return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for (index = 0; index < arg.length; index++) {
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while (!isUndefined((index = keys.pop()))) {
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    }
    else {
        result = isDate
            ? arg.toJSON()
            : type == 'symbol'
                ? arg.toString()
                : type == 'string'
                    ? JSON.stringify(arg)
                    : '' + arg;
    }
    return result;
};

/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */
var online = true;
var isOnline = function () { return online; };
var hasWin = hasWindow();
var hasDoc = hasDocument();
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var onWindowEvent = hasWin && window.addEventListener
    ? window.addEventListener.bind(window)
    : noop;
var onDocumentEvent = hasDoc ? document.addEventListener.bind(document) : noop;
var offWindowEvent = hasWin && window.removeEventListener
    ? window.removeEventListener.bind(window)
    : noop;
var offDocumentEvent = hasDoc
    ? document.removeEventListener.bind(document)
    : noop;
var isVisible = function () {
    var visibilityState = hasDoc && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
var initFocus = function (callback) {
    // focus revalidate
    onDocumentEvent('visibilitychange', callback);
    onWindowEvent('focus', callback);
    return function () {
        offDocumentEvent('visibilitychange', callback);
        offWindowEvent('focus', callback);
    };
};
var initReconnect = function (callback) {
    // revalidate on reconnected
    var onOnline = function () {
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function () {
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return function () {
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
var preset = {
    isOnline: isOnline,
    isVisible: isVisible
};
var defaultConfigOptions = {
    initFocus: initFocus,
    initReconnect: initReconnect
};

var IS_SERVER = !hasWindow() || 'Deno' in window;
// Polyfill requestAnimationFrame
var rAF = function (f) {
    return hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? react.useEffect : react.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
var navigatorConnection = typeof navigator !== 'undefined' &&
    navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var slowConnection = !IS_SERVER &&
    navigatorConnection &&
    (['slow-2g', '2g'].includes(navigatorConnection.effectiveType) ||
        navigatorConnection.saveData);

var serialize = function (key) {
    if (isFunction(key)) {
        try {
            key = key();
        }
        catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key =
        typeof key == 'string'
            ? key
            : (Array.isArray(key) ? key.length : key)
                ? stableHash(key)
                : '';
    var infoKey = key ? '$swr$' + key : '';
    return [key, args, infoKey];
};

// Global state used to deduplicate requests and store listeners
var SWRGlobalState = new WeakMap();

var FOCUS_EVENT = 0;
var RECONNECT_EVENT = 1;
var MUTATE_EVENT = 2;

var broadcastState = function (cache, key, data, error, isValidating, revalidate, broadcast) {
    if (broadcast === void 0) { broadcast = true; }
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], FETCH = _a[3];
    var revalidators = EVENT_REVALIDATORS[key];
    var updaters = STATE_UPDATERS[key];
    // Cache was populated, update states of all hooks.
    if (broadcast && updaters) {
        for (var i = 0; i < updaters.length; ++i) {
            updaters[i](data, error, isValidating);
        }
    }
    // If we also need to revalidate, only do it for the first hook.
    if (revalidate) {
        // Invalidate the key by deleting the concurrent request markers so new
        // requests will not be deduped.
        delete FETCH[key];
        if (revalidators && revalidators[0]) {
            return revalidators[0](MUTATE_EVENT).then(function () {
                return cache.get(key);
            });
        }
    }
    return cache.get(key);
};

// Global timestamp.
var __timestamp = 0;
var getTimestamp = function () { return ++__timestamp; };

var internalMutate = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var cache, _key, _data, _opts, options, populateCache, revalidate, rollbackOnError, customOptimisticData, _a, key, keyInfo, _b, MUTATION, data, error, beforeMutationTs, hasCustomOptimisticData, rollbackData, optimisticData, res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    cache = args[0], _key = args[1], _data = args[2], _opts = args[3];
                    options = typeof _opts === 'boolean' ? { revalidate: _opts } : _opts || {};
                    populateCache = isUndefined(options.populateCache)
                        ? true
                        : options.populateCache;
                    revalidate = options.revalidate !== false;
                    rollbackOnError = options.rollbackOnError !== false;
                    customOptimisticData = options.optimisticData;
                    _a = serialize(_key), key = _a[0], keyInfo = _a[2];
                    if (!key)
                        return [2 /*return*/];
                    _b = SWRGlobalState.get(cache), MUTATION = _b[2];
                    // If there is no new data provided, revalidate the key with current state.
                    if (args.length < 3) {
                        // Revalidate and broadcast state.
                        return [2 /*return*/, broadcastState(cache, key, cache.get(key), UNDEFINED, UNDEFINED, revalidate, true)];
                    }
                    data = _data;
                    beforeMutationTs = getTimestamp();
                    MUTATION[key] = [beforeMutationTs, 0];
                    hasCustomOptimisticData = !isUndefined(customOptimisticData);
                    rollbackData = cache.get(key);
                    // Do optimistic data update.
                    if (hasCustomOptimisticData) {
                        optimisticData = isFunction(customOptimisticData)
                            ? customOptimisticData(rollbackData)
                            : customOptimisticData;
                        cache.set(key, optimisticData);
                        broadcastState(cache, key, optimisticData);
                    }
                    if (isFunction(data)) {
                        // `data` is a function, call it passing current cache value.
                        try {
                            data = data(cache.get(key));
                        }
                        catch (err) {
                            // If it throws an error synchronously, we shouldn't update the cache.
                            error = err;
                        }
                    }
                    if (!(data && isFunction(data.then))) return [3 /*break*/, 2];
                    return [4 /*yield*/, data.catch(function (err) {
                            error = err;
                        })
                        // Check if other mutations have occurred since we've started this mutation.
                        // If there's a race we don't update cache or broadcast the change,
                        // just return the data.
                    ];
                case 1:
                    // This means that the mutation is async, we need to check timestamps to
                    // avoid race conditions.
                    data = _c.sent();
                    // Check if other mutations have occurred since we've started this mutation.
                    // If there's a race we don't update cache or broadcast the change,
                    // just return the data.
                    if (beforeMutationTs !== MUTATION[key][0]) {
                        if (error)
                            throw error;
                        return [2 /*return*/, data];
                    }
                    else if (error && hasCustomOptimisticData && rollbackOnError) {
                        // Rollback. Always populate the cache in this case but without
                        // transforming the data.
                        populateCache = true;
                        data = rollbackData;
                        cache.set(key, rollbackData);
                    }
                    _c.label = 2;
                case 2:
                    // If we should write back the cache after request.
                    if (populateCache) {
                        if (!error) {
                            // Transform the result into data.
                            if (isFunction(populateCache)) {
                                data = populateCache(data, rollbackData);
                            }
                            // Only update cached data if there's no error. Data can be `undefined` here.
                            cache.set(key, data);
                        }
                        // Always update or reset the error.
                        cache.set(keyInfo, mergeObjects(cache.get(keyInfo), { error: error }));
                    }
                    // Reset the timestamp to mark the mutation has ended.
                    MUTATION[key][1] = getTimestamp();
                    return [4 /*yield*/, broadcastState(cache, key, data, error, UNDEFINED, revalidate, !!populateCache)
                        // Throw error or return data
                    ];
                case 3:
                    res = _c.sent();
                    // Throw error or return data
                    if (error)
                        throw error;
                    return [2 /*return*/, populateCache ? res : data];
            }
        });
    });
};

var revalidateAllKeys = function (revalidators, type) {
    for (var key in revalidators) {
        if (revalidators[key][0])
            revalidators[key][0](type);
    }
};
var initCache = function (provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that bound to
    // the cache.
    // Provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        var opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = {};
        var mutate = internalMutate.bind(UNDEFINED, provider);
        var unmount = noop;
        // Update the state if it's new, or the provider has been extended.
        SWRGlobalState.set(provider, [EVENT_REVALIDATORS, {}, {}, {}, mutate]);
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        if (!IS_SERVER) {
            // When listening to the native events for auto revalidations,
            // we intentionally put a delay (setTimeout) here to make sure they are
            // fired after immediate JavaScript executions, which can possibly be
            // React's state updates.
            // This avoids some unnecessary revalidations such as
            // https://github.com/vercel/swr/issues/1680.
            var releaseFocus_1 = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
            var releaseReconnect_1 = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
            unmount = function () {
                releaseFocus_1 && releaseFocus_1();
                releaseReconnect_1 && releaseReconnect_1();
                // When un-mounting, we need to remove the cache provider from the state
                // storage too because it's a side-effect. Otherwise when re-mounting we
                // will not re-register those event listeners.
                SWRGlobalState.delete(provider);
            };
        }
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [provider, mutate, unmount];
    }
    return [provider, SWRGlobalState.get(provider)[4]];
};

// error retry
var onErrorRetry = function (_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) *
        (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
// Default cache provider
var _a = initCache(new Map()), cache = _a[0], mutate = _a[1];
// Default config
var defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry: onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare: function (currentData, newData) {
        return stableHash(currentData) == stableHash(newData);
    },
    isPaused: function () { return false; },
    cache: cache,
    mutate: mutate,
    fallback: {}
}, 
// use web preset by default
preset);

var mergeConfigs = function (a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

var SWRConfigContext = (0,react.createContext)({});
var SWRConfig$1 = function (props) {
    var value = props.value;
    // Extend parent context values and middleware.
    var extendedConfig = mergeConfigs((0,react.useContext)(SWRConfigContext), value);
    // Should not use the inherited provider.
    var provider = value && value.provider;
    // Use a lazy initialized state to create the cache on first access.
    var cacheContext = (0,react.useState)(function () {
        return provider
            ? initCache(provider(extendedConfig.cache || cache), value)
            : UNDEFINED;
    })[0];
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(function () { return (cacheContext ? cacheContext[2] : UNDEFINED); }, []);
    return (0,react.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

/**
 * An implementation of state with dependency-tracking.
 */
var useStateWithDeps = function (state, unmountedRef) {
    var rerender = (0,react.useState)({})[1];
    var stateRef = (0,react.useRef)(state);
    // If a state property (data, error or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = (0,react.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
     * @param payload To change stateRef, pass the values explicitly to setState:
     * @example
     * ```js
     * setState({
     *   isValidating: false
     *   data: newData // set data to newData
     *   error: undefined // set error to undefined
     * })
     *
     * setState({
     *   isValidating: false
     *   data: undefined // set data to undefined
     *   error: err // set error to err
     * })
     * ```
     */
    var setState = (0,react.useCallback)(function (payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for (var _ in payload) {
            var k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            rerender({});
        }
    }, 
    // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update the state reference.
    useIsomorphicLayoutEffect(function () {
        stateRef.current = state;
    });
    return [stateRef, stateDependenciesRef.current, setState];
};

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

var useSWRConfig = function () {
    return mergeObjects(defaultConfig, (0,react.useContext)(SWRConfigContext));
};

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var withArgs = function (hook) {
    return function useSWRArgs() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Get the default and inherited configuration.
        var fallbackConfig = useSWRConfig();
        // Normalize arguments.
        var _a = normalize(args), key = _a[0], fn = _a[1], _config = _a[2];
        // Merge configurations.
        var config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        if (use) {
            for (var i = use.length; i-- > 0;) {
                next = use[i](next);
            }
        }
        return next(key, fn || config.fetcher, config);
    };
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var subscribeCallback = function (key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function () {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

var WITH_DEDUPE = { dedupe: true };
var useSWRHandler = function (_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, fallbackData = config.fallbackData, suspense = config.suspense, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline;
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], MUTATION = _a[2], FETCH = _a[3];
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArgs` is an array of arguments parsed from the key, which will be passed
    // to the fetcher.
    var _b = serialize(_key), key = _b[0], fnArgs = _b[1], keyInfo = _b[2];
    // If it's the initial render of this hook.
    var initialMountedRef = (0,react.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0,react.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0,react.useRef)(key);
    var fetcherRef = (0,react.useRef)(fetcher);
    var configRef = (0,react.useRef)(config);
    var getConfig = function () { return configRef.current; };
    var isActive = function () { return getConfig().isVisible() && getConfig().isOnline(); };
    var patchFetchInfo = function (info) {
        return cache.set(keyInfo, mergeObjects(cache.get(keyInfo), info));
    };
    // Get the current state that SWR should return.
    var cached = cache.get(key);
    var fallback = isUndefined(fallbackData)
        ? config.fallback[key]
        : fallbackData;
    var data = isUndefined(cached) ? fallback : cached;
    var info = cache.get(keyInfo) || {};
    var error = info.error;
    var isInitialMount = !initialMountedRef.current;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldRevalidate = function () {
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !isUndefined(revalidateOnMount))
            return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused())
            return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately on mount again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense)
            return isUndefined(data) ? false : config.revalidateIfStale;
        // If there is no stale data, we need to revalidate on mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return isUndefined(data) || config.revalidateIfStale;
    };
    // Resolve the current validating state.
    var resolveValidating = function () {
        if (!key || !fetcher)
            return false;
        if (info.isValidating)
            return true;
        // If it's not mounted yet and it should revalidate on mount, revalidate.
        return isInitialMount && shouldRevalidate();
    };
    var isValidating = resolveValidating();
    var _c = useStateWithDeps({
        data: data,
        error: error,
        isValidating: isValidating
    }, unmountedRef), stateRef = _c[0], stateDependencies = _c[1], setState = _c[2];
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0,react.useCallback)(function (revalidateOpts) { return __awaiter(void 0, void 0, void 0, function () {
        var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, isCurrentKeyMounted, cleanupState, newState, finishRequestAndUpdateState, mutationInfo, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentFetcher = fetcherRef.current;
                    if (!key ||
                        !currentFetcher ||
                        unmountedRef.current ||
                        getConfig().isPaused()) {
                        return [2 /*return*/, false];
                    }
                    loading = true;
                    opts = revalidateOpts || {};
                    shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                    isCurrentKeyMounted = function () {
                        return !unmountedRef.current &&
                            key === keyRef.current &&
                            initialMountedRef.current;
                    };
                    cleanupState = function () {
                        // Check if it's still the same request before deleting.
                        var requestInfo = FETCH[key];
                        if (requestInfo && requestInfo[1] === startAt) {
                            delete FETCH[key];
                        }
                    };
                    newState = { isValidating: false };
                    finishRequestAndUpdateState = function () {
                        patchFetchInfo({ isValidating: false });
                        // We can only set state if it's safe (still mounted with the same key).
                        if (isCurrentKeyMounted()) {
                            setState(newState);
                        }
                    };
                    // Start fetching. Change the `isValidating` state, update the cache.
                    patchFetchInfo({
                        isValidating: true
                    });
                    setState({ isValidating: true });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (shouldStartNewRequest) {
                        // Tell all other hooks to change the `isValidating` state.
                        broadcastState(cache, key, stateRef.current.data, stateRef.current.error, true);
                        // If no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && !cache.get(key)) {
                            setTimeout(function () {
                                if (loading && isCurrentKeyMounted()) {
                                    getConfig().onLoadingSlow(key, config);
                                }
                            }, config.loadingTimeout);
                        }
                        // Start the request and save the timestamp.
                        FETCH[key] = [currentFetcher.apply(void 0, fnArgs), getTimestamp()];
                    }
                    _a = FETCH[key], newData = _a[0], startAt = _a[1];
                    return [4 /*yield*/, newData];
                case 2:
                    newData = _b.sent();
                    if (shouldStartNewRequest) {
                        // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                    }
                    // If there're other ongoing request(s), started after the current one,
                    // we need to ignore the current one to avoid possible race conditions:
                    //   req1------------------>res1        (current one)
                    //        req2---------------->res2
                    // the request that fired later will always be kept.
                    // The timestamp maybe be `undefined` or a number
                    if (!FETCH[key] || FETCH[key][1] !== startAt) {
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Clear error.
                    patchFetchInfo({
                        error: UNDEFINED
                    });
                    newState.error = UNDEFINED;
                    mutationInfo = MUTATION[key];
                    if (!isUndefined(mutationInfo) &&
                        // case 1
                        (startAt <= mutationInfo[0] ||
                            // case 2
                            startAt <= mutationInfo[1] ||
                            // case 3
                            mutationInfo[1] === 0)) {
                        finishRequestAndUpdateState();
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Deep compare with latest state to avoid extra re-renders.
                    // For local state, compare and assign.
                    if (!compare(stateRef.current.data, newData)) {
                        newState.data = newData;
                    }
                    else {
                        // data and newData are deeply equal
                        // it should be safe to broadcast the stale data
                        newState.data = stateRef.current.data;
                        // At the end of this function, `brocastState` invokes the `onStateUpdate` function,
                        // which takes care of avoiding the re-render
                    }
                    // For global state, it's possible that the key has changed.
                    // https://github.com/vercel/swr/pull/1058
                    if (!compare(cache.get(key), newData)) {
                        cache.set(key, newData);
                    }
                    // Trigger the successful callback if it's the original request.
                    if (shouldStartNewRequest) {
                        if (isCurrentKeyMounted()) {
                            getConfig().onSuccess(newData, key, config);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    cleanupState();
                    // Not paused, we continue handling the error. Otherwise discard it.
                    if (!getConfig().isPaused()) {
                        // Get a new error, don't use deep comparison for errors.
                        patchFetchInfo({ error: err_1 });
                        newState.error = err_1;
                        // Error event and retry logic. Only for the actual request, not
                        // deduped ones.
                        if (shouldStartNewRequest && isCurrentKeyMounted()) {
                            getConfig().onError(err_1, key, config);
                            if ((typeof config.shouldRetryOnError === 'boolean' &&
                                config.shouldRetryOnError) ||
                                (isFunction(config.shouldRetryOnError) &&
                                    config.shouldRetryOnError(err_1))) {
                                // When retrying, dedupe is always enabled
                                if (isActive()) {
                                    // If it's active, stop. It will auto revalidate when refocusing
                                    // or reconnecting.
                                    getConfig().onErrorRetry(err_1, key, config, revalidate, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                    }
                    return [3 /*break*/, 4];
                case 4:
                    // Mark loading as stopped.
                    loading = false;
                    // Update the current hook's state.
                    finishRequestAndUpdateState();
                    // Here is the source of the request, need to tell all other hooks to
                    // update their states.
                    if (isCurrentKeyMounted() && shouldStartNewRequest) {
                        broadcastState(cache, key, newState.data, newState.error, false);
                    }
                    return [2 /*return*/, true];
            }
        });
    }); }, 
    // `setState` is immutable, and `eventsCallback`, `fnArgs`, `keyInfo`,
    // and `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key]);
    // Similar to the global mutate, but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var boundMutate = (0,react.useCallback)(
    // By using `bind` we don't need to modify the size of the rest arguments.
    // Due to https://github.com/microsoft/TypeScript/issues/37181, we have to
    // cast it to any for now.
    internalMutate.bind(UNDEFINED, cache, function () { return keyRef.current; }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update fetcher and config refs.
    useIsomorphicLayoutEffect(function () {
        fetcherRef.current = fetcher;
        configRef.current = config;
    });
    // After mounted or key changed.
    useIsomorphicLayoutEffect(function () {
        if (!key)
            return;
        var keyChanged = key !== keyRef.current;
        var softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
        // Expose state updater to global event listeners. So we can update hook's
        // internal state from the outside.
        var onStateUpdate = function (updatedData, updatedError, updatedIsValidating) {
            setState(mergeObjects({
                error: updatedError,
                isValidating: updatedIsValidating
            }, 
            // Since `setState` only shallowly compares states, we do a deep
            // comparison here.
            compare(stateRef.current.data, updatedData)
                ? UNDEFINED
                : {
                    data: updatedData
                }));
        };
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var nextFocusRevalidatedAt = 0;
        var onRevalidate = function (type) {
            if (type == FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus &&
                    now > nextFocusRevalidatedAt &&
                    isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            }
            else if (type == RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            }
            else if (type == MUTATE_EVENT) {
                return revalidate();
            }
            return;
        };
        var unsubUpdate = subscribeCallback(key, STATE_UPDATERS, onStateUpdate);
        var unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // When `key` updates, reset the state to the initial value
        // and trigger a rerender if necessary.
        if (keyChanged) {
            setState({
                data: data,
                error: error,
                isValidating: isValidating
            });
        }
        // Trigger a revalidation.
        if (shouldRevalidate()) {
            if (isUndefined(data) || IS_SERVER) {
                // Revalidate immediately.
                softRevalidate();
            }
            else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                rAF(softRevalidate);
            }
        }
        return function () {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubUpdate();
            unsubEvents();
        };
    }, [key, revalidate]);
    // Polling
    useIsomorphicLayoutEffect(function () {
        var timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = isFunction(refreshInterval)
                ? refreshInterval(data)
                : refreshInterval;
            // We only start next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online and not errored.
            if (!stateRef.current.error &&
                (refreshWhenHidden || getConfig().isVisible()) &&
                (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            }
            else {
                // Schedule next interval to check again.
                next();
            }
        }
        next();
        return function () {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [refreshInterval, refreshWhenHidden, refreshWhenOffline, revalidate]);
    // Display debug info in React DevTools.
    (0,react.useDebugValue)(data);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && isUndefined(data) && key) {
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data() {
            stateDependencies.data = true;
            return data;
        },
        get error() {
            stateDependencies.error = true;
            return error;
        },
        get isValidating() {
            stateDependencies.isValidating = true;
            return isValidating;
        }
    };
};
var SWRConfig = OBJECT.defineProperty(SWRConfig$1, 'default', {
    value: defaultConfig
});
var unstable_serialize = function (key) { return serialize(key)[0]; };
var useSWR = withArgs(useSWRHandler);

// useSWR



;// CONCATENATED MODULE: ./node_modules/@plasmicapp/query/dist/index.esm.js
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/query-data.tsx


var __SWRConfig = void 0;
var mutateKeys = (invalidateKey) => {
  if (__SWRConfig) {
    const { cache, mutate } = __SWRConfig;
    (invalidateKey != null ? [invalidateKey] : Array.from(cache.keys())).forEach((key) => {
      mutate(key);
    });
  }
};
function getPlasmicDefaultSWROptions(opts) {
  return {
    revalidateIfStale: !!(opts == null ? void 0 : opts.isMutable),
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  };
}
function usePlasmicQueryData(key, fetcher) {
  const prepassCtx = react.useContext(PrepassContext);
  const opts = getPlasmicDefaultSWROptions();
  if (prepassCtx) {
    opts.suspense = true;
  }
  const config = useSWRConfig();
  react.useEffect(() => {
    __SWRConfig = config;
  }, [config]);
  const wrappedFetcher = react.useMemo(
    () => wrapLoadingFetcher(fetcher),
    [fetcher]
  );
  const resp = useSWR(key, wrappedFetcher, opts);
  if (resp.data !== void 0) {
    return { data: resp.data };
  } else if (resp.error) {
    return { error: resp.error };
  } else {
    return { isLoading: true };
  }
}
function useMutablePlasmicQueryData(key, fetcher, options) {
  const prepassCtx = react.useContext(PrepassContext);
  const opts = __spreadValues(__spreadValues({}, getPlasmicDefaultSWROptions({ isMutable: true })), options);
  if (prepassCtx) {
    opts.suspense = true;
  }
  const config = useSWRConfig();
  react.useEffect(() => {
    __SWRConfig = config;
  }, [config]);
  const [isLoading, setIsLoading] = react.useState(false);
  const fetcherWrapper = react.useCallback(
    (...args) => __async(this, null, function* () {
      setIsLoading(true);
      try {
        return yield wrapLoadingFetcher(fetcher)(...args);
      } finally {
        setIsLoading(false);
      }
    }),
    [fetcher]
  );
  const laggyDataRef = react.useRef();
  const { isValidating, mutate, data, error } = useSWR(
    key,
    fetcherWrapper,
    opts
  );
  react.useEffect(() => {
    if (data !== void 0) {
      laggyDataRef.current = data;
    }
  }, [data]);
  return react.useMemo(
    () => __spreadValues(__spreadValues({
      isValidating,
      mutate,
      isLoading: data === void 0 && error === void 0 || isLoading
    }, data !== void 0 ? { data } : error === void 0 && laggyDataRef.current ? (
      // Show previous data if available
      { data: laggyDataRef.current, isLagging: true }
    ) : {}), error !== void 0 ? { error } : {}),
    [isValidating, mutate, data, error, isLoading]
  );
}
function PlasmicQueryDataProvider(props) {
  const { children, suspense, prefetchedCache } = props;
  const prepass = react.useContext(PrepassContext);
  if (prepass) {
    return /* @__PURE__ */ react.createElement(react.Fragment, null, children);
  } else {
    return /* @__PURE__ */ react.createElement(
      SWRConfig,
      {
        value: {
          fallback: prefetchedCache != null ? prefetchedCache : {},
          suspense
        }
      },
      children
    );
  }
}
var PrepassContext = react.createContext(false);
function PlasmicPrepassContext(props) {
  const { cache, children } = props;
  return /* @__PURE__ */ react.createElement(PrepassContext.Provider, { value: true }, /* @__PURE__ */ react.createElement(
    SWRConfig,
    {
      value: {
        provider: () => cache,
        suspense: true,
        fallback: {}
      }
    },
    children
  ));
}
var usePlasmicDataConfig = useSWRConfig;
var loadingCount = 0;
var listeners = [];
function addLoadingStateListener(listener, opts) {
  listeners.push(listener);
  if (opts == null ? void 0 : opts.immediate) {
    listener(loadingCount > 0);
  }
  return () => {
    listeners.splice(listeners.indexOf(listener), 1);
  };
}
function wrapLoadingFetcher(fetcher) {
  return (...args) => __async(this, null, function* () {
    if (loadingCount === 0) {
      listeners.forEach((listener) => listener(true));
    }
    loadingCount += 1;
    try {
      const res = fetcher(...args);
      return isPromiseLike(res) ? yield res : res;
    } finally {
      loadingCount -= 1;
      if (loadingCount === 0) {
        listeners.forEach((listener) => listener(false));
      }
    }
  });
}
function isPromiseLike(x) {
  return !!x && typeof x === "object" && "then" in x && typeof x.then === "function";
}
function isPlasmicPrepass() {
  var _a, _b, _c;
  return !!((_c = (_b = (_a = react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) == null ? void 0 : _a.ReactCurrentDispatcher) == null ? void 0 : _b.current) == null ? void 0 : _c.isPlasmicPrepass);
}
var HeadMetadataContext = react.createContext({});

// src/index.tsx

if (typeof window !== "undefined") {
  const root = window;
  const maybeExistingMutateAllKeys = root.__SWRMutateAllKeys;
  root.__SWRMutateAllKeys = (invalidateKey) => {
    mutateKeys(invalidateKey);
    if (typeof maybeExistingMutateAllKeys === "function") {
      maybeExistingMutateAllKeys(invalidateKey);
    }
  };
}

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* globals define,module */
/*
Using a Universal Module Loader that should be browser, require, and AMD friendly
http://ricostacruz.com/cheatsheets/umdjs.html
*/
;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function() {
  "use strict";
  /* globals console:false */

  if ( ! Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    };
  }

  /**
   * Return an array that contains no duplicates (original not modified)
   * @param  {array} array   Original reference array
   * @return {array}         New array with no duplicates
   */
  function arrayUnique(array) {
    var a = [];
    for (var i=0, l=array.length; i<l; i++) {
      if (a.indexOf(array[i]) === -1) {
        a.push(array[i]);
      }
    }
    return a;
  }

  var jsonLogic = {};
  var operations = {
    "==": function(a, b) {
      return a == b;
    },
    "===": function(a, b) {
      return a === b;
    },
    "!=": function(a, b) {
      return a != b;
    },
    "!==": function(a, b) {
      return a !== b;
    },
    ">": function(a, b) {
      return a > b;
    },
    ">=": function(a, b) {
      return a >= b;
    },
    "<": function(a, b, c) {
      return (c === undefined) ? a < b : (a < b) && (b < c);
    },
    "<=": function(a, b, c) {
      return (c === undefined) ? a <= b : (a <= b) && (b <= c);
    },
    "!!": function(a) {
      return jsonLogic.truthy(a);
    },
    "!": function(a) {
      return !jsonLogic.truthy(a);
    },
    "%": function(a, b) {
      return a % b;
    },
    "log": function(a) {
      console.log(a); return a;
    },
    "in": function(a, b) {
      if (!b || typeof b.indexOf === "undefined") return false;
      return (b.indexOf(a) !== -1);
    },
    "cat": function() {
      return Array.prototype.join.call(arguments, "");
    },
    "substr": function(source, start, end) {
      if (end < 0) {
        // JavaScript doesn't support negative end, this emulates PHP behavior
        var temp = String(source).substr(start);
        return temp.substr(0, temp.length + end);
      }
      return String(source).substr(start, end);
    },
    "+": function() {
      return Array.prototype.reduce.call(arguments, function(a, b) {
        return parseFloat(a, 10) + parseFloat(b, 10);
      }, 0);
    },
    "*": function() {
      return Array.prototype.reduce.call(arguments, function(a, b) {
        return parseFloat(a, 10) * parseFloat(b, 10);
      });
    },
    "-": function(a, b) {
      if (b === undefined) {
        return -a;
      } else {
        return a - b;
      }
    },
    "/": function(a, b) {
      return a / b;
    },
    "min": function() {
      return Math.min.apply(this, arguments);
    },
    "max": function() {
      return Math.max.apply(this, arguments);
    },
    "merge": function() {
      return Array.prototype.reduce.call(arguments, function(a, b) {
        return a.concat(b);
      }, []);
    },
    "var": function(a, b) {
      var not_found = (b === undefined) ? null : b;
      var data = this;
      if (typeof a === "undefined" || a==="" || a===null) {
        return data;
      }
      var sub_props = String(a).split(".");
      for (var i = 0; i < sub_props.length; i++) {
        if (data === null || data === undefined) {
          return not_found;
        }
        // Descending into data
        data = data[sub_props[i]];
        if (data === undefined) {
          return not_found;
        }
      }
      return data;
    },
    "missing": function() {
      /*
      Missing can receive many keys as many arguments, like {"missing:[1,2]}
      Missing can also receive *one* argument that is an array of keys,
      which typically happens if it's actually acting on the output of another command
      (like 'if' or 'merge')
      */

      var missing = [];
      var keys = Array.isArray(arguments[0]) ? arguments[0] : arguments;

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = jsonLogic.apply({"var": key}, this);
        if (value === null || value === "") {
          missing.push(key);
        }
      }

      return missing;
    },
    "missing_some": function(need_count, options) {
      // missing_some takes two arguments, how many (minimum) items must be present, and an array of keys (just like 'missing') to check for presence.
      var are_missing = jsonLogic.apply({"missing": options}, this);

      if (options.length - are_missing.length >= need_count) {
        return [];
      } else {
        return are_missing;
      }
    },
  };

  jsonLogic.is_logic = function(logic) {
    return (
      typeof logic === "object" && // An object
      logic !== null && // but not null
      ! Array.isArray(logic) && // and not an array
      Object.keys(logic).length === 1 // with exactly one key
    );
  };

  /*
  This helper will defer to the JsonLogic spec as a tie-breaker when different language interpreters define different behavior for the truthiness of primitives.  E.g., PHP considers empty arrays to be falsy, but Javascript considers them to be truthy. JsonLogic, as an ecosystem, needs one consistent answer.

  Spec and rationale here: http://jsonlogic.com/truthy
  */
  jsonLogic.truthy = function(value) {
    if (Array.isArray(value) && value.length === 0) {
      return false;
    }
    return !! value;
  };


  jsonLogic.get_operator = function(logic) {
    return Object.keys(logic)[0];
  };

  jsonLogic.get_values = function(logic) {
    return logic[jsonLogic.get_operator(logic)];
  };

  jsonLogic.apply = function(logic, data) {
    // Does this array contain logic? Only one way to find out.
    if (Array.isArray(logic)) {
      return logic.map(function(l) {
        return jsonLogic.apply(l, data);
      });
    }
    // You've recursed to a primitive, stop!
    if ( ! jsonLogic.is_logic(logic) ) {
      return logic;
    }

    var op = jsonLogic.get_operator(logic);
    var values = logic[op];
    var i;
    var current;
    var scopedLogic;
    var scopedData;
    var initial;

    // easy syntax for unary operators, like {"var" : "x"} instead of strict {"var" : ["x"]}
    if ( ! Array.isArray(values)) {
      values = [values];
    }

    // 'if', 'and', and 'or' violate the normal rule of depth-first calculating consequents, let each manage recursion as needed.
    if (op === "if" || op == "?:") {
      /* 'if' should be called with a odd number of parameters, 3 or greater
      This works on the pattern:
      if( 0 ){ 1 }else{ 2 };
      if( 0 ){ 1 }else if( 2 ){ 3 }else{ 4 };
      if( 0 ){ 1 }else if( 2 ){ 3 }else if( 4 ){ 5 }else{ 6 };

      The implementation is:
      For pairs of values (0,1 then 2,3 then 4,5 etc)
      If the first evaluates truthy, evaluate and return the second
      If the first evaluates falsy, jump to the next pair (e.g, 0,1 to 2,3)
      given one parameter, evaluate and return it. (it's an Else and all the If/ElseIf were false)
      given 0 parameters, return NULL (not great practice, but there was no Else)
      */
      for (i = 0; i < values.length - 1; i += 2) {
        if ( jsonLogic.truthy( jsonLogic.apply(values[i], data) ) ) {
          return jsonLogic.apply(values[i+1], data);
        }
      }
      if (values.length === i+1) {
        return jsonLogic.apply(values[i], data);
      }
      return null;
    } else if (op === "and") { // Return first falsy, or last
      for (i=0; i < values.length; i+=1) {
        current = jsonLogic.apply(values[i], data);
        if ( ! jsonLogic.truthy(current)) {
          return current;
        }
      }
      return current; // Last
    } else if (op === "or") {// Return first truthy, or last
      for (i=0; i < values.length; i+=1) {
        current = jsonLogic.apply(values[i], data);
        if ( jsonLogic.truthy(current) ) {
          return current;
        }
      }
      return current; // Last
    } else if (op === "filter") {
      scopedData = jsonLogic.apply(values[0], data);
      scopedLogic = values[1];

      if ( ! Array.isArray(scopedData)) {
        return [];
      }
      // Return only the elements from the array in the first argument,
      // that return truthy when passed to the logic in the second argument.
      // For parity with JavaScript, reindex the returned array
      return scopedData.filter(function(datum) {
        return jsonLogic.truthy( jsonLogic.apply(scopedLogic, datum));
      });
    } else if (op === "map") {
      scopedData = jsonLogic.apply(values[0], data);
      scopedLogic = values[1];

      if ( ! Array.isArray(scopedData)) {
        return [];
      }

      return scopedData.map(function(datum) {
        return jsonLogic.apply(scopedLogic, datum);
      });
    } else if (op === "reduce") {
      scopedData = jsonLogic.apply(values[0], data);
      scopedLogic = values[1];
      initial = typeof values[2] !== "undefined" ? jsonLogic.apply(values[2], data) : null;

      if ( ! Array.isArray(scopedData)) {
        return initial;
      }

      return scopedData.reduce(
        function(accumulator, current) {
          return jsonLogic.apply(
            scopedLogic,
            {current: current, accumulator: accumulator}
          );
        },
        initial
      );
    } else if (op === "all") {
      scopedData = jsonLogic.apply(values[0], data);
      scopedLogic = values[1];
      // All of an empty set is false. Note, some and none have correct fallback after the for loop
      if ( ! Array.isArray(scopedData) || ! scopedData.length) {
        return false;
      }
      for (i=0; i < scopedData.length; i+=1) {
        if ( ! jsonLogic.truthy( jsonLogic.apply(scopedLogic, scopedData[i]) )) {
          return false; // First falsy, short circuit
        }
      }
      return true; // All were truthy
    } else if (op === "none") {
      scopedData = jsonLogic.apply(values[0], data);
      scopedLogic = values[1];

      if ( ! Array.isArray(scopedData) || ! scopedData.length) {
        return true;
      }
      for (i=0; i < scopedData.length; i+=1) {
        if ( jsonLogic.truthy( jsonLogic.apply(scopedLogic, scopedData[i]) )) {
          return false; // First truthy, short circuit
        }
      }
      return true; // None were truthy
    } else if (op === "some") {
      scopedData = jsonLogic.apply(values[0], data);
      scopedLogic = values[1];

      if ( ! Array.isArray(scopedData) || ! scopedData.length) {
        return false;
      }
      for (i=0; i < scopedData.length; i+=1) {
        if ( jsonLogic.truthy( jsonLogic.apply(scopedLogic, scopedData[i]) )) {
          return true; // First truthy, short circuit
        }
      }
      return false; // None were truthy
    }

    // Everyone else gets immediate depth-first recursion
    values = values.map(function(val) {
      return jsonLogic.apply(val, data);
    });


    // The operation is called with "data" bound to its "this" and "values" passed as arguments.
    // Structured commands like % or > can name formal arguments while flexible commands (like missing or merge) can operate on the pseudo-array arguments
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/arguments
    if (operations.hasOwnProperty(op) && typeof operations[op] === "function") {
      return operations[op].apply(data, values);
    } else if (op.indexOf(".") > 0) { // Contains a dot, and not in the 0th position
      var sub_ops = String(op).split(".");
      var operation = operations;
      for (i = 0; i < sub_ops.length; i++) {
        if (!operation.hasOwnProperty(sub_ops[i])) {
          throw new Error("Unrecognized operation " + op +
            " (failed at " + sub_ops.slice(0, i+1).join(".") + ")");
        }
        // Descending into operations
        operation = operation[sub_ops[i]];
      }

      return operation.apply(data, values);
    }

    throw new Error("Unrecognized operation " + op );
  };

  jsonLogic.uses_data = function(logic) {
    var collection = [];

    if (jsonLogic.is_logic(logic)) {
      var op = jsonLogic.get_operator(logic);
      var values = logic[op];

      if ( ! Array.isArray(values)) {
        values = [values];
      }

      if (op === "var") {
        // This doesn't cover the case where the arg to var is itself a rule.
        collection.push(values[0]);
      } else {
        // Recursion!
        values.forEach(function(val) {
          collection.push.apply(collection, jsonLogic.uses_data(val) );
        });
      }
    }

    return arrayUnique(collection);
  };

  jsonLogic.add_operation = function(name, code) {
    operations[name] = code;
  };

  jsonLogic.rm_operation = function(name) {
    delete operations[name];
  };

  jsonLogic.rule_like = function(rule, pattern) {
    // console.log("Is ". JSON.stringify(rule) . " like " . JSON.stringify(pattern) . "?");
    if (pattern === rule) {
      return true;
    } // TODO : Deep object equivalency?
    if (pattern === "@") {
      return true;
    } // Wildcard!
    if (pattern === "number") {
      return (typeof rule === "number");
    }
    if (pattern === "string") {
      return (typeof rule === "string");
    }
    if (pattern === "array") {
      // !logic test might be superfluous in JavaScript
      return Array.isArray(rule) && ! jsonLogic.is_logic(rule);
    }

    if (jsonLogic.is_logic(pattern)) {
      if (jsonLogic.is_logic(rule)) {
        var pattern_op = jsonLogic.get_operator(pattern);
        var rule_op = jsonLogic.get_operator(rule);

        if (pattern_op === "@" || pattern_op === rule_op) {
          // echo "\nOperators match, go deeper\n";
          return jsonLogic.rule_like(
            jsonLogic.get_values(rule, false),
            jsonLogic.get_values(pattern, false)
          );
        }
      }
      return false; // pattern is logic, rule isn't, can't be eq
    }

    if (Array.isArray(pattern)) {
      if (Array.isArray(rule)) {
        if (pattern.length !== rule.length) {
          return false;
        }
        /*
          Note, array order MATTERS, because we're using this array test logic to consider arguments, where order can matter. (e.g., + is commutative, but '-' or 'if' or 'var' are NOT)
        */
        for (var i = 0; i < pattern.length; i += 1) {
          // If any fail, we fail
          if ( ! jsonLogic.rule_like(rule[i], pattern[i])) {
            return false;
          }
        }
        return true; // If they *all* passed, we pass
      } else {
        return false; // Pattern is array, rule isn't
      }
    }

    // Not logic, not array, not a === match for rule.
    return false;
  };

  return jsonLogic;
}));


/***/ }),

/***/ 1365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3152)


/***/ }),

/***/ 3144:
/***/ (function(module) {

"use strict";

/* globals self */ var fetch = self.fetch.bind(self);
module.exports = fetch;
module.exports["default"] = module.exports;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3152:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.EDGE_UNSUPPORTED_NODE_APIS = exports.RSC_MODULE_TYPES = exports.TRACE_OUTPUT_VERSION = exports.STATIC_STATUS_PAGES = exports.DEFAULT_SANS_SERIF_FONT = exports.DEFAULT_SERIF_FONT = exports.OPTIMIZED_FONT_PROVIDERS = exports.GOOGLE_FONT_PROVIDER = exports.SERVER_PROPS_ID = exports.STATIC_PROPS_ID = exports.PERMANENT_REDIRECT_STATUS = exports.TEMPORARY_REDIRECT_STATUS = exports.EDGE_RUNTIME_WEBPACK = exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL = exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS = exports.CLIENT_STATIC_FILES_RUNTIME_WEBPACK = exports.CLIENT_STATIC_FILES_RUNTIME_AMP = exports.CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH = exports.APP_CLIENT_INTERNALS = exports.CLIENT_STATIC_FILES_RUNTIME_MAIN_APP = exports.CLIENT_STATIC_FILES_RUNTIME_MAIN = exports.MIDDLEWARE_REACT_LOADABLE_MANIFEST = exports.MIDDLEWARE_BUILD_MANIFEST = exports.FLIGHT_SERVER_CSS_MANIFEST = exports.FLIGHT_MANIFEST = exports.NEXT_CLIENT_SSR_ENTRY_SUFFIX = exports.NEXT_BUILTIN_DOCUMENT = exports.MODERN_BROWSERSLIST_TARGET = exports.STRING_LITERAL_DROP_BUNDLE = exports.CLIENT_STATIC_FILES_RUNTIME = exports.CLIENT_STATIC_FILES_PATH = exports.CLIENT_PUBLIC_FILES_PATH = exports.BLOCKED_PAGES = exports.BUILD_ID_FILE = exports.CONFIG_FILES = exports.SERVER_DIRECTORY = exports.FONT_MANIFEST = exports.REACT_LOADABLE_MANIFEST = exports.DEV_MIDDLEWARE_MANIFEST = exports.MIDDLEWARE_MANIFEST = exports.DEV_CLIENT_PAGES_MANIFEST = exports.SERVER_FILES_MANIFEST = exports.IMAGES_MANIFEST = exports.ROUTES_MANIFEST = exports.PRERENDER_MANIFEST = exports.EXPORT_DETAIL = exports.EXPORT_MARKER = exports.FONT_LOADER_MANIFEST = exports.SUBRESOURCE_INTEGRITY_MANIFEST = exports.APP_BUILD_MANIFEST = exports.BUILD_MANIFEST = exports.APP_PATH_ROUTES_MANIFEST = exports.APP_PATHS_MANIFEST = exports.PAGES_MANIFEST = exports.PHASE_TEST = exports.PHASE_DEVELOPMENT_SERVER = exports.PHASE_PRODUCTION_SERVER = exports.PHASE_PRODUCTION_BUILD = exports.PHASE_EXPORT = exports.COMPILER_INDEXES = exports.COMPILER_NAMES = void 0;
const COMPILER_NAMES = {
    client: "client",
    server: "server",
    edgeServer: "edge-server"
};
exports.COMPILER_NAMES = COMPILER_NAMES;
const COMPILER_INDEXES = {
    [COMPILER_NAMES.client]: 0,
    [COMPILER_NAMES.server]: 1,
    [COMPILER_NAMES.edgeServer]: 2
};
exports.COMPILER_INDEXES = COMPILER_INDEXES;
const PHASE_EXPORT = "phase-export";
exports.PHASE_EXPORT = PHASE_EXPORT;
const PHASE_PRODUCTION_BUILD = "phase-production-build";
exports.PHASE_PRODUCTION_BUILD = PHASE_PRODUCTION_BUILD;
const PHASE_PRODUCTION_SERVER = "phase-production-server";
exports.PHASE_PRODUCTION_SERVER = PHASE_PRODUCTION_SERVER;
const PHASE_DEVELOPMENT_SERVER = "phase-development-server";
exports.PHASE_DEVELOPMENT_SERVER = PHASE_DEVELOPMENT_SERVER;
const PHASE_TEST = "phase-test";
exports.PHASE_TEST = PHASE_TEST;
const PAGES_MANIFEST = "pages-manifest.json";
exports.PAGES_MANIFEST = PAGES_MANIFEST;
const APP_PATHS_MANIFEST = "app-paths-manifest.json";
exports.APP_PATHS_MANIFEST = APP_PATHS_MANIFEST;
const APP_PATH_ROUTES_MANIFEST = "app-path-routes-manifest.json";
exports.APP_PATH_ROUTES_MANIFEST = APP_PATH_ROUTES_MANIFEST;
const BUILD_MANIFEST = "build-manifest.json";
exports.BUILD_MANIFEST = BUILD_MANIFEST;
const APP_BUILD_MANIFEST = "app-build-manifest.json";
exports.APP_BUILD_MANIFEST = APP_BUILD_MANIFEST;
const SUBRESOURCE_INTEGRITY_MANIFEST = "subresource-integrity-manifest";
exports.SUBRESOURCE_INTEGRITY_MANIFEST = SUBRESOURCE_INTEGRITY_MANIFEST;
const FONT_LOADER_MANIFEST = "font-loader-manifest";
exports.FONT_LOADER_MANIFEST = FONT_LOADER_MANIFEST;
const EXPORT_MARKER = "export-marker.json";
exports.EXPORT_MARKER = EXPORT_MARKER;
const EXPORT_DETAIL = "export-detail.json";
exports.EXPORT_DETAIL = EXPORT_DETAIL;
const PRERENDER_MANIFEST = "prerender-manifest.json";
exports.PRERENDER_MANIFEST = PRERENDER_MANIFEST;
const ROUTES_MANIFEST = "routes-manifest.json";
exports.ROUTES_MANIFEST = ROUTES_MANIFEST;
const IMAGES_MANIFEST = "images-manifest.json";
exports.IMAGES_MANIFEST = IMAGES_MANIFEST;
const SERVER_FILES_MANIFEST = "required-server-files.json";
exports.SERVER_FILES_MANIFEST = SERVER_FILES_MANIFEST;
const DEV_CLIENT_PAGES_MANIFEST = "_devPagesManifest.json";
exports.DEV_CLIENT_PAGES_MANIFEST = DEV_CLIENT_PAGES_MANIFEST;
const MIDDLEWARE_MANIFEST = "middleware-manifest.json";
exports.MIDDLEWARE_MANIFEST = MIDDLEWARE_MANIFEST;
const DEV_MIDDLEWARE_MANIFEST = "_devMiddlewareManifest.json";
exports.DEV_MIDDLEWARE_MANIFEST = DEV_MIDDLEWARE_MANIFEST;
const REACT_LOADABLE_MANIFEST = "react-loadable-manifest.json";
exports.REACT_LOADABLE_MANIFEST = REACT_LOADABLE_MANIFEST;
const FONT_MANIFEST = "font-manifest.json";
exports.FONT_MANIFEST = FONT_MANIFEST;
const SERVER_DIRECTORY = "server";
exports.SERVER_DIRECTORY = SERVER_DIRECTORY;
const CONFIG_FILES = [
    "next.config.js",
    "next.config.mjs"
];
exports.CONFIG_FILES = CONFIG_FILES;
const BUILD_ID_FILE = "BUILD_ID";
exports.BUILD_ID_FILE = BUILD_ID_FILE;
const BLOCKED_PAGES = [
    "/_document",
    "/_app",
    "/_error"
];
exports.BLOCKED_PAGES = BLOCKED_PAGES;
const CLIENT_PUBLIC_FILES_PATH = "public";
exports.CLIENT_PUBLIC_FILES_PATH = CLIENT_PUBLIC_FILES_PATH;
const CLIENT_STATIC_FILES_PATH = "static";
exports.CLIENT_STATIC_FILES_PATH = CLIENT_STATIC_FILES_PATH;
const CLIENT_STATIC_FILES_RUNTIME = "runtime";
exports.CLIENT_STATIC_FILES_RUNTIME = CLIENT_STATIC_FILES_RUNTIME;
const STRING_LITERAL_DROP_BUNDLE = "__NEXT_DROP_CLIENT_FILE__";
exports.STRING_LITERAL_DROP_BUNDLE = STRING_LITERAL_DROP_BUNDLE;
const MODERN_BROWSERSLIST_TARGET = [
    "chrome 64",
    "edge 79",
    "firefox 67",
    "opera 51",
    "safari 12"
];
exports.MODERN_BROWSERSLIST_TARGET = MODERN_BROWSERSLIST_TARGET;
const NEXT_BUILTIN_DOCUMENT = "__NEXT_BUILTIN_DOCUMENT__";
exports.NEXT_BUILTIN_DOCUMENT = NEXT_BUILTIN_DOCUMENT;
const NEXT_CLIENT_SSR_ENTRY_SUFFIX = ".__sc_client__";
exports.NEXT_CLIENT_SSR_ENTRY_SUFFIX = NEXT_CLIENT_SSR_ENTRY_SUFFIX;
const FLIGHT_MANIFEST = "flight-manifest";
exports.FLIGHT_MANIFEST = FLIGHT_MANIFEST;
const FLIGHT_SERVER_CSS_MANIFEST = "flight-server-css-manifest";
exports.FLIGHT_SERVER_CSS_MANIFEST = FLIGHT_SERVER_CSS_MANIFEST;
const MIDDLEWARE_BUILD_MANIFEST = "middleware-build-manifest";
exports.MIDDLEWARE_BUILD_MANIFEST = MIDDLEWARE_BUILD_MANIFEST;
const MIDDLEWARE_REACT_LOADABLE_MANIFEST = "middleware-react-loadable-manifest";
exports.MIDDLEWARE_REACT_LOADABLE_MANIFEST = MIDDLEWARE_REACT_LOADABLE_MANIFEST;
const CLIENT_STATIC_FILES_RUNTIME_MAIN = "main";
exports.CLIENT_STATIC_FILES_RUNTIME_MAIN = CLIENT_STATIC_FILES_RUNTIME_MAIN;
const CLIENT_STATIC_FILES_RUNTIME_MAIN_APP = "".concat(CLIENT_STATIC_FILES_RUNTIME_MAIN, "-app");
exports.CLIENT_STATIC_FILES_RUNTIME_MAIN_APP = CLIENT_STATIC_FILES_RUNTIME_MAIN_APP;
const APP_CLIENT_INTERNALS = "app-client-internals";
exports.APP_CLIENT_INTERNALS = APP_CLIENT_INTERNALS;
const CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH = "react-refresh";
exports.CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH = CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH;
const CLIENT_STATIC_FILES_RUNTIME_AMP = "amp";
exports.CLIENT_STATIC_FILES_RUNTIME_AMP = CLIENT_STATIC_FILES_RUNTIME_AMP;
const CLIENT_STATIC_FILES_RUNTIME_WEBPACK = "webpack";
exports.CLIENT_STATIC_FILES_RUNTIME_WEBPACK = CLIENT_STATIC_FILES_RUNTIME_WEBPACK;
const CLIENT_STATIC_FILES_RUNTIME_POLYFILLS = "polyfills";
exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS = CLIENT_STATIC_FILES_RUNTIME_POLYFILLS;
const CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL = Symbol(CLIENT_STATIC_FILES_RUNTIME_POLYFILLS);
exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL = CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL;
const EDGE_RUNTIME_WEBPACK = "edge-runtime-webpack";
exports.EDGE_RUNTIME_WEBPACK = EDGE_RUNTIME_WEBPACK;
const TEMPORARY_REDIRECT_STATUS = 307;
exports.TEMPORARY_REDIRECT_STATUS = TEMPORARY_REDIRECT_STATUS;
const PERMANENT_REDIRECT_STATUS = 308;
exports.PERMANENT_REDIRECT_STATUS = PERMANENT_REDIRECT_STATUS;
const STATIC_PROPS_ID = "__N_SSG";
exports.STATIC_PROPS_ID = STATIC_PROPS_ID;
const SERVER_PROPS_ID = "__N_SSP";
exports.SERVER_PROPS_ID = SERVER_PROPS_ID;
const GOOGLE_FONT_PROVIDER = "https://fonts.googleapis.com/";
exports.GOOGLE_FONT_PROVIDER = GOOGLE_FONT_PROVIDER;
const OPTIMIZED_FONT_PROVIDERS = [
    {
        url: GOOGLE_FONT_PROVIDER,
        preconnect: "https://fonts.gstatic.com"
    },
    {
        url: "https://use.typekit.net",
        preconnect: "https://use.typekit.net"
    }
];
exports.OPTIMIZED_FONT_PROVIDERS = OPTIMIZED_FONT_PROVIDERS;
const DEFAULT_SERIF_FONT = {
    name: "Times New Roman",
    xAvgCharWidth: 821,
    azAvgWidth: 854.3953488372093,
    unitsPerEm: 2048
};
exports.DEFAULT_SERIF_FONT = DEFAULT_SERIF_FONT;
const DEFAULT_SANS_SERIF_FONT = {
    name: "Arial",
    xAvgCharWidth: 904,
    azAvgWidth: 934.5116279069767,
    unitsPerEm: 2048
};
exports.DEFAULT_SANS_SERIF_FONT = DEFAULT_SANS_SERIF_FONT;
const STATIC_STATUS_PAGES = [
    "/500"
];
exports.STATIC_STATUS_PAGES = STATIC_STATUS_PAGES;
const TRACE_OUTPUT_VERSION = 1;
exports.TRACE_OUTPUT_VERSION = TRACE_OUTPUT_VERSION;
const RSC_MODULE_TYPES = {
    client: "client",
    server: "server"
};
exports.RSC_MODULE_TYPES = RSC_MODULE_TYPES;
const EDGE_UNSUPPORTED_NODE_APIS = [
    "clearImmediate",
    "setImmediate",
    "BroadcastChannel",
    "Buffer",
    "ByteLengthQueuingStrategy",
    "CompressionStream",
    "CountQueuingStrategy",
    "DecompressionStream",
    "DomException",
    "MessageChannel",
    "MessageEvent",
    "MessagePort",
    "ReadableByteStreamController",
    "ReadableStreamBYOBRequest",
    "ReadableStreamDefaultController",
    "TextDecoderStream",
    "TextEncoderStream",
    "TransformStreamDefaultController",
    "WritableStreamDefaultController"
];
exports.EDGE_UNSUPPORTED_NODE_APIS = EDGE_UNSUPPORTED_NODE_APIS;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=constants.js.map


/***/ }),

/***/ 1864:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={114:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t="";n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(114);module.exports=t})();

/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3573)


/***/ }),

/***/ 8339:
/***/ (function(module) {

/*!
 * pascalcase <https://github.com/jonschlinkert/pascalcase>
 *
 * Copyright (c) 2015-present, Jon ("Schlink") Schlinkert.
 * Licensed under the MIT License.
 */

const titlecase = input => input[0].toLocaleUpperCase() + input.slice(1);

module.exports = value => {
  if (value === null || value === void 0) return '';
  if (typeof value.toString !== 'function') return '';

  let input = value.toString().trim();
  if (input === '') return '';
  if (input.length === 1) return input.toLocaleUpperCase();

  let match = input.match(/[a-zA-Z0-9]+/g);
  if (match) {
    return match.map(m => titlecase(m)).join('');
  }

  return input;
};


/***/ })

}]);